export const en = {
  mcs: {
  "title": "MCS preparation",
  "context": "Your own preparation for the ICF Mentor Coach Specialization — separate from your mentees’ credential progress",
  "disclaimer": "MCAi assists preparation and documentation only. Nothing here is ICF approval, a credential award, qualifying education, or a substitute for the mentor’s professional review.",
  "linkCard": "Preparing for the MCS yourself? → MCS preparation",
  "routeLevels": "Route & levels",
  "routes": {
    "standard": "Standard",
    "prior_learning": "Credit for prior learning"
  },
  "standardDescription": "Standard: record your mentor-coaching education and level-specific training.",
  "priorDescription": "Prior learning: record relevant education and mentoring experience; evaluation training is excluded from counted hours.",
  "targetLevels": "Target levels",
  "credentialType": "Credential type",
  "credentialStatus": "Credential status",
  "accRenewed": "ACC has been renewed",
  "checklist": "Checklist",
  "checklistSaved": "Checklist reflects your last save. Save to recalculate.",
  "progress": "{{done}} done · {{todo}} to do · {{needsAttention}} need attention · {{notApplicable}} not applicable",
  "hoursSummary": "Total {{total}} h · Live {{synchronous}} h · Asynchronous {{asynchronous}} h · Evaluation training {{evaluation_training_hours}} h · Counted {{counted_for_route}} h",
  "general": "General",
  "officialGuidance": "Official guidance",
  "education_entries": "Education records",
  "evaluation_trainings": "Evaluation training per level",
  "experience_entries": "Mentoring experience",
  "reflections": "Reflections on your mentoring conversations",
  "reflectionNote": "MCAi does not assess mentor-coaching competencies automatically. This is structured reflection and human review.",
  "providerLetter": "Provider letter available",
  "ambiguities": "What ICF has not clarified yet",
  "unsaved": "Unsaved changes",
  "upToDate": "All changes saved",
  "save": "Save",
  "saving": "Saving…",
  "saved": "Preparation saved.",
  "saveError": "Could not save preparation. Your changes are still here. Please retry.",
  "retry": "Could not load preparation. Retry",
  "linkError": "Could not open the guidance link.",
  "add": "Add",
  "edit": "Edit",
  "remove": "Remove",
  "apply": "Apply entry",
  "cancel": "Cancel",
  "hours": "hours",
  "validation": "Enter the required title/course or reflection, a non-negative number of hours, and valid dates (YYYY-MM-DD).",
  "summary": "MCS preparation summary",
  "summaryError": "Could not load the summary.",
  "emptySummary": "No cohort members yet.",
  "statuses": {
    "active": "Active",
    "renewed": "Renewed",
    "lapsed": "Lapsed",
    "done": "Done",
    "todo": "To do",
    "needs_attention": "Needs attention",
    "not_applicable": "Not applicable"
  },
  "items": {
    "eligible_credential": "Eligible credential",
    "education_hours": "Education hours",
    "evaluation_training": "Evaluation training",
    "experience_five_mentees": "Five mentees",
    "application": "Application",
    "renewal_plan": "Renewal plan",
    "other": "Requirement"
  },
  "fields": {
    "title": "Title",
    "provider": "Provider",
    "hours": "Hours",
    "synchronous": "Synchronous (live)",
    "is_icf_evaluation_training": "ICF evaluation training",
    "completed_on": "Completed on (YYYY-MM-DD, optional)",
    "evidence_note": "Evidence note",
    "level": "Level",
    "course": "Course",
    "kind": "Experience type",
    "label": "Name / label",
    "credential_earned_on": "Credential earned on (YYYY-MM-DD, optional)",
    "note": "Note",
    "text": "Reflection",
    "created_at": "Date (YYYY-MM-DD)"
  },
  "kinds": {
    "credentialed_client": "Credentialed client",
    "program_student": "Program student"
  },
  "notes": {
    "transition_dates": "Transition dates",
    "level_1_2_scope": "Level 1/2 scope",
    "jan_apr_overlap": "January–April overlap",
    "mcc_crf_submission": "MCC CRF submission",
    "renewal": "Renewal",
    "disclaimer": "Disclaimer"
  }
},
  billingRecovery: {
    paymentTitle: 'Your payment needs attention',
    paymentMessage: 'Your plan and data are still here. Update your payment method to restore access without starting a second subscription.',
    unavailableTitle: 'We could not verify billing right now',
    unavailableMessage: 'This is a temporary connection problem. We will not ask you to purchase your plan again.',
    updatePayment: 'Update payment method',
    retry: 'Try again',
    signOut: 'Sign out',
    portalError: 'We could not open billing management. Please try again in a minute.',
  },
  invitePerson: {
    tabs: {
      student: 'Student',
      mentor: 'Mentor',
      admin: 'Admin',
      billing: 'Billing contact'
    },
    student: {
      capabilityTitle: 'What can this person do?',
      cap1: 'Uploads their sessions',
      cap2: 'Can share with their mentor',
      cap3: 'Views their own progress',
      hintTitle: 'About this role',
      hintBody: 'Students manage their own sessions and can share them with their mentors.',
      submit: 'Send invite',
      submitting: 'Sending…',
      successTitle: 'Invite sent',
      successMessage: 'Student invited. The invitation email has been queued.',
      errorMessage: 'An error occurred while inviting the student.',
      footerHint: 'Details are verified before the invite is sent.'
    },
    errorTitle: 'Invite could not be sent',
    activePersonalSubscriptionWarning: 'This person already has an account with an active personal subscription. Joining your school does not cancel it; they can cancel it in their billing settings.',
    mentor: {
      capabilityTitle: 'What can this person do?',
      cap1: 'Reviews shared sessions',
      cap2: 'Provides structured feedback',
      cap3: 'Tracks cohort progress',
      hintTitle: 'About this role',
      hintBody: 'Mentors only see sessions that students have shared with them.',
      submit: 'Send invite',
      submitting: 'Sending…',
      successTitle: 'Mentor invite sent',
      successMessage: 'Mentor invitation sent by email.',
      errorMessage: 'An error occurred while inviting the mentor.',
      footerHint: 'Mentor receives a single-use invite link.'
    },
    admin: {
      capabilityTitle: 'What can this person do?',
      cap1: 'Invites students and mentors',
      cap2: 'Manages frameworks and cohorts',
      cap3: 'Accesses school reports',
      hintTitle: 'About this role',
      hintBody: 'Admins get full access to school settings. Add with care.',
      submit: 'Create admin',
      submitting: 'Creating…',
      successTitle: 'Admin added',
      successMessage: 'Admin account created.',
      errorMessage: 'An error occurred while adding the admin.',
      footerHint: 'Admin gets full school access as soon as they are created.'
    },
    billing: {
      capabilityTitle: 'What can this person do?',
      cap1: 'Completes Stripe checkout',
      cap2: 'Manages invoices and payments',
      cap3: 'Adjusts seat counts',
      hintTitle: 'About this role',
      hintBody: 'Billing contacts only see financial transactions. They cannot access student or session data.',
      submit: 'Create billing contact',
      submitting: 'Creating…',
      successTitle: 'Billing contact added',
      successMessage: 'Billing contact created.',
      errorMessage: 'An error occurred while adding the billing contact.',
      footerHint: 'A Stripe checkout link is generated automatically if needed.',
      openCheckoutPrompt: 'Open the Stripe checkout page now?',
      openCheckout: 'Open checkout'
    },
    validation: {
      nameRequired: 'Full name is required.',
      emailInvalid: 'Enter a valid email address.'
    },
    title: 'Invite person',
    subtitle: 'Add a new user to the school account. An invitation email is sent automatically.',
    fields: {
      name: 'Full Name',
      namePlaceholder: 'e.g. Jane Smith',
      email: 'Email',
      emailPlaceholder: 'jane.smith@example.com',
      password: 'Temporary password (optional)',
      passwordPlaceholder: 'At least 8 characters',
      passwordHint: 'If left blank, an invite link will be sent.'
    },
    cancel: 'Cancel'
  },
  cohortSettings: {
    title: 'Cohort settings',
    programLevel: 'Training program level',
    programLevelHint: 'ICF replaced ACTP/ACSTH in 2022 with the numbered Level 1/2/3 system. Select which credential your training program prepares for.',
    noLevel: 'Not specified',
    features: 'Features enabled for this cohort',
    featuresHint: 'Only the features you enable here will appear in the sidebar for students in this cohort.',
    noFeatures: 'No enableable features yet.',
    cancel: 'Cancel',
    save: 'Save'
  },
  voice: {
    fileTooLarge: 'File is too large. Maximum size is {{max}}MB.'
  },
  // Language Selection

  // In-app upgrade paywall
  upgrade: {
    title: 'Unlock this feature',
    subtitle: 'Upgrade your plan to get full access.',
    unlocks: 'Unlocks',
    packageLabel: 'Included in',
    cta: 'Upgrade now',
    maybeLater: 'Maybe later',
    perMonth: '/mo',
    cyclePicker: 'Choose your billing period',
    save: 'Save {{pct}}%',
    cycle: {
      '1mo': 'Monthly',
      '3mo': '3 months',
      '6mo': '6 months',
    },
    feature: {
      levelSelect: 'ICF level selection',
      markerTable: 'the marker evidence table',
      customMode: 'custom analysis mode',
      observationPdf: 'the ICF observation form export',
      icfProgress: 'ICF progress tracking',
      generic: 'this feature',
    },
    benefit: {
      tier2_1: 'Choose the target ICF level for each analysis',
      tier2_2: 'Detailed marker-by-marker evidence table',
      tier2_3: 'Track your ICF progress over time',
      tier3_1: 'Everything in Chasing Credentials',
      tier3_2: 'Custom analysis instructions',
      tier3_3: 'ICF observation form PDF export',
    },
  },

  billing: {
    conflicts: {
      alreadySubscribedTitle: 'Subscription already active',
      alreadySubscribedMessage: 'You already have an active subscription. Update your current plan instead of starting a new checkout.',
      resumeAvailableTitle: 'Resume your subscription',
      resumeAvailableMessage: 'This subscription is scheduled to cancel. Resume it to keep your current access without creating a new subscription.',
      pendingCancellationTitle: 'Use your current subscription',
      pendingCancellationMessage: 'Your subscription is scheduled to cancel. Change the current plan instead of starting a second subscription.',
      resumeAction: 'Resume',
      changePlanAction: 'Change plan',
      dismissAction: 'Not now',
      resumeSuccessTitle: 'Subscription resumed',
      resumeSuccessMessage: 'Your subscription will continue at the end of the current period.',
      changePlanSuccessTitle: 'Subscription updated',
      changePlanSuccessMessage: 'Your current subscription has been updated.',
      subscriptionGoneTitle: 'Your subscription has ended',
      subscriptionGoneMessage: 'Your previous subscription has ended. Choose a plan to start a new one.',
      introOfferUnavailableTitle: 'Introductory trial unavailable',
      introOfferUnavailableMessage: 'This account has previous subscription or trial history. Review the price, then tap Continue again to start with immediate payment.',
      introCheckoutInProgressTitle: 'Trial checkout already open',
      introCheckoutInProgressMessage: 'Your trial checkout is already open or still being prepared. Complete it, close it, or try again in a moment.',
    },
    checkout: {
      startTrialTitle: 'Start Your {{days}}-Day Trial',
      completeTitle: 'Complete Your Subscription',
      preparing: 'Preparing checkout...',
      initFailed: 'Checkout initialization failed',
      actionRequired: 'Choose Resume or Change plan to continue.',
      retry: 'Try Again',
      loadingPaymentForm: 'Loading payment form...',
      loadFailed: 'The secure payment form could not be loaded. Please try again.',
      noCheckoutUrl: 'No checkout URL received',
      failureTitle: 'Checkout could not start',
      failureMessage: 'We could not open the secure payment checkout. Try again.',
      failureEscalated: 'Checkout has failed several times. Try another payment method or contact support if the problem continues.',
    },
    comebackOffer: {
      title: 'Welcome back',
      subtitle: "It's been a little while since you checked out our plans — here's 30% off your first billing period, on us.",
      cta: 'Claim my 30% off',
      dismissA11y: 'Dismiss offer',
      appliedBadge: '30% off will be applied at checkout',
    },
    finalOffer: {
      title: 'This is our final offer',
      subtitle: 'First month for {{price}} on Students or Chasing Credentials — pay now, no trial.',
      cta: 'Claim my first month for {{price}}',
      dismissA11y: 'Dismiss offer',
      renewalNotice: 'Renews at {{price}}/month after the first month. Cancel anytime.',
      appliedBadge: '{{price}} first month will be applied at checkout',
    },
  },

  // PDF export tool
  pdfExport: {
    title: 'PDF Export Tool',
    subtitle: 'Create and export coaching reports as PDF',
    titleLabel: 'Report title',
    titlePlaceholder: 'Enter report title...',
    titleDefault: 'Coaching Report',
    headerName: 'Name',
    headerCategory: 'Category',
    headerNotes: 'Notes',
    tableData: 'Table Data',
    loadSample: 'Load Sample',
    columnHeaders: 'Column Headers',
    dataRows: 'Data Rows',
    rowLabel: 'Row {{n}}',
    headerPlaceholder: 'Header {{n}}',
    cellPlaceholder: 'Cell {{n}}',
    addColumn: 'Add column',
    addRow: 'Add row',
    exporting: 'Exporting...',
    exportButton: 'Export to PDF',
    dialogTitle: 'Export PDF Report',
    errorTitle: 'Error',
    successTitle: 'Success',
    errorMinColumn: 'Table must have at least one column',
    errorMinRow: 'Table must have at least one row',
    errorNeedTitle: 'Please enter a title for the report',
    saveSuccess: 'PDF saved to: {{path}}',
    saveFailed: 'Failed to save PDF file',
    exportFailed: 'Failed to export PDF',
  },

  // Common
  common: {
    unknown: 'Unknown',
    continue: 'Continue',
    minutesShort: 'min',
    remaining: 'remaining',
    downloadFailed: 'Failed to download',
    failed: 'Failed',
    ok: 'OK',
    create: 'Create',
    noResults: 'No matches',
    secure: 'Secure',
    loading: 'Loading...',
    saving: 'Saving...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    retry: 'Retry',
    back: 'Back',
    next: 'Next',
    done: 'Done',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    info: 'Info',
    and: 'and',
    accessDenied: 'Access denied',
    noData: 'No data found',
    loadError: 'Failed to load data',
    optional: 'Optional',
    view: 'View',
    remove: 'Remove',
    send: 'Send',
    invite: 'Invite',
    share: 'Share',
    open: 'Open',
  },

  // Navigation
  navigation: {
    dashboard: 'Dashboard',
    chat: 'Chat',
    sessions: 'Sessions',
    progress: 'Progress',
    documents: 'Documents',
    platformAdmin: 'Platform Admin',
    schoolManagement: 'School Management',
    schoolAdmin: 'School Admin',
    transcripts: 'Transcripts',
    myDocuments: 'My Documents',
    students: 'Members',
    profile: 'Profile',
    mentorTraining: 'Mentor Coach Training',
    mentorEngagements: 'Mentees',
    settings: 'Settings',
    adminSection: 'Admin',
    logout: 'Logout',
    more: 'More',
    help: 'Help',
    // New 5-tab structure
    home: 'Home',
    library: 'Library',
    aiChat: 'Mentor Coaching AI',
  },

  shell: {
    recentSessions: 'Recent sessions',
    noSessions: 'No sessions yet',
    trustTitle: 'Your coaching data stays under your control.',
    trustCopy: 'Private, secure, and aligned with ICF ethics.',
  },

  invitations: {
    title: 'Student Invitations',
    pendingSection: 'Pending Invitations ({{count}})',
    legacySection: 'Legacy Pending ({{count}})',
    noPending: 'No pending invitations found.',
    noLegacy: 'No legacy pending invitations.',
    expires: 'Expires: {{date}}',
    awaiting: 'Awaiting acceptance',
    invited: 'Invited',
    invitedStatus: 'Invitation sent',
    actions: {
      resend: 'Resend',
      resendInvitation: 'Resend Invitation',
      cancel: 'Cancel',
      recount: 'Recount Students',
      resentTitle: 'Invitation Resent',
      resentBody: 'The invitation link has been refreshed.',
      recountDone: 'Recount Completed',
      recountFromTo: 'Updated: {{prev}} → {{next}}',
      cancelConfirm: 'Are you sure you want to cancel this invitation?',
    }
  },

  // Feedback
  feedback: {
    button: 'Feedback',
    modalTitle: 'Share Feedback',
    modalDescription: 'Spot something that feels off? We read every note. Please tell us what happened.',
    categories: {
      bug: 'Report a bug',
      suggestion: 'Suggest improvement',
      praise: 'Give kudos',
      question: 'Ask a question',
      other: 'Other',
    },
    messagePlaceholder: 'Give us the details…',
    autoContextNote: 'We automatically capture the screen you were on and your device details.',
    cancel: 'Cancel',
    submit: 'Send',
    submitting: 'Sending…',
    successTitle: 'Thank you!',
    successMessage: 'Your feedback helps us improve.',
    errorTitle: 'Oops',
    errorMessage: 'Something went wrong while sending your feedback. Please try again.',
    errorTooShort: 'Please share at least a couple of sentences so we can help.',

    // Admin Management
    management: {
      title: 'User Feedback',
      subtitle: 'total submissions',
      searchPlaceholder: 'Search by message or email...',
      filterByCategory: 'Filter by Category',
      filterByPlatform: 'Filter by Platform',
      all: 'All',
      deleteTitle: 'Delete Feedback',
      deleteMessage: 'Are you sure you want to delete this feedback? This action cannot be undone.',
      deleteSuccess: 'Feedback deleted successfully',
      deleteError: 'Failed to delete feedback',
      noFeedback: 'No feedback submissions yet',
      noFeedbackFiltered: 'No feedback found matching your filters',
      page: 'Page',
      of: 'of',
    },
  },

  // Terms Acceptance
  terms: {
    title: 'Terms & Privacy',
    subtitle: 'Please review and accept our terms before continuing',
    summary: 'By using Mentor Coaching AI, you agree to our Terms of Service which govern your use of the platform, and our Privacy Policy which explains how we collect, use, and protect your personal data and coaching session information.',
    agreeLabel: 'I have read and agree to the Terms of Service and Privacy Policy',
    continue: 'Continue',
    acceptError: 'Failed to accept terms. Please try again.',
  },

  onboarding: {
    appName: 'Mentor Coaching AI',
    skipTour: 'Skip tour',
    back: 'Back',
    next: 'Next',
    continueToPlans: 'Continue to plans',
    continueToIntake: 'Continue — a few quick questions',
    continueToDashboard: 'Continue to dashboard',
    proceedToPayment: 'Proceed to Payment',
    securePayment: 'Secure payment • Cancel anytime • 14-day money-back guarantee',
    infoMessage: 'You can revisit this tour anytime from Settings → Help & Support. We keep improving it based on your feedback.',
    journey: {
      part1: 'Getting to know MCAi — 1 of 2',
      part2: 'Personalizing your plan — 2 of 2',
    },
    completionErrorTitle: 'Could not finish onboarding',
    completionErrorMessage: 'Your progress is still here. Try again to continue.',
    slides: {
      welcome: {
        title: 'Welcome',
        titleWithPlan: 'Your {{plan}} plan is ready',
        description: "Here's what's waiting on the other side — quick preview before we get you set up.",
      },
      transcript: {
        title: 'Mentor-level feedback in minutes, not hours',
        description: 'Upload audio into a transcription flow built specifically for coaching sessions, then get feedback notes and development guidance grounded in the ICF competencies. Mentor coaches save 2–3 hours per session.',
      },
      demo: {
        title: 'See what your first report looks like',
        description: "A real coaching session, anonymized, alongside the analysis it produced. So you know exactly what's waiting after your first upload.",
        cta: 'Show me a sample report',
        skip: 'Skip',
        modalTitle: 'Sample report',
        tabTranscript: 'Transcript',
        tabAnalysis: 'Analysis',
        close: 'Close',
      },
      featureMap: {
        title: 'Everything you need between mentor sessions',
        description: 'Your membership connects each session to practical feedback, progress, and next-step tools.',
        trialConfirmation: 'Start with one real session. Your trial is secure, private, and can be cancelled anytime.',
        nextUp: 'Next: 4 quick questions so your first analysis is tuned to you.',
        items: {
          voice: { label: 'Coaching-specific transcription', line: 'Built for coaching sessions', detail: 'A transcription flow built specifically for coaching conversations: speaker separation, coach/client labeling, and analysis-ready output. Upload audio and go straight to feedback.' },
          analysis: { label: 'ICF analysis', line: 'Competency and marker feedback', detail: 'See strengths, development edges, and transcript-grounded evidence for each ICF competency.' },
          progress: { label: 'Progress tracking', line: 'Growth across sessions', detail: 'Track readiness and recurring patterns across the sessions you choose to include.' },
          development: { label: 'Development plan', line: 'Focused practice steps', detail: 'Turn each report into a short, practical plan for what to practice before your next mentor session.' },
          export: { label: 'PDF & DOCX export', line: 'Reports you can keep', detail: 'Export reports and evidence in formats that are easy to review or discuss with your mentor.' },
          library: { label: 'Session library', line: 'Everything in one place', detail: 'Return to transcripts, reports, and follow-up conversations without losing the thread.' },
          meeting: { label: 'Meeting feedback', line: 'Structured observation notes', detail: 'Capture evidence-based observation notes and development questions for real mentor-coaching conversations.' },
          chat: { label: 'AI mentor chat', line: 'Follow-up Q&A on every report', detail: 'Ask follow-up questions about your session, evidence, or development plan directly in the report conversation.' },
        },
      },
      progress: {
        title: 'Feedback on every session — not just 3 or 5',
        description: "Most coaches only get evaluated on a handful of sessions before ACC, PCC, or MCC. Track your growth across every session, see what's holding your level, and bring sharper questions to your mentor.",
      },
      methodology: {
        title: 'Built on ICF competency indicators, not a generic AI',
        description: "Your feedback is grounded in the ICF's own competency framework and behavioral indicators, structured to your target level — ACC, PCC, or MCC. Sessions stay AES-256 encrypted, GDPR-compliant, and we never log session content.",
      },
      trial: {
        title: 'Try it on a real session, risk-free',
        description: 'Start your free trial with full access — upload, score, chat, track. Cancel anytime, 14-day money-back guarantee. Your recordings stay AES-256 encrypted and private.',
      },
      confirmation: {
        title: 'A few quick questions, then your first analysis',
        description: "Tell us your target (ACC/PCC/MCC), where you struggle, and how often you coach. We'll tune your very first analysis to you.",
      },
    },
  },

  sampleReport: {
    banner: 'Sample report · fictional, anonymized demo session analyzed by MCAi',
    languageNotice: 'This sample is available in English and Turkish. Your own reports are generated in your selected language.',
    close: 'Close sample report',
    verdictEyebrow: 'LEVEL DECISION',
    levelDecisionHeading: 'Level decision',
    performingAt: 'Performing at',
    performingAtLevel: 'Performing at {{level}}',
    sessionMeta: '{{minutes}} min session · {{language}}',
    fictionalParticipants: 'Fictional participants: {{coach}} and {{client}}',
    competencyHeading: 'ICF competency breakdown',
    competencySubheading: 'Tap a competency to inspect the marker-level evidence.',
    evidenceHeading: 'Observed evidence',
    markerReferences: 'Marker references',
    strengths: 'Observed evidence',
    developmentEdge: 'Development edge',
    noDevelopmentEvidence: 'No material development pattern was identified in this sample.',
    confidence: '{{percent}}% confidence',
    expandCompetency: 'Expand {{competency}}',
    collapseCompetency: 'Collapse {{competency}}',
    narrativeHeading: 'Narrative feedback',
    sessionOverview: 'Session overview',
    whatNext: 'What to work on next',
    developmentPlanHeading: 'Development plan preview',
    developmentPlanIntro: 'Three practices generated from this session',
    whyLabel: 'Why',
    practiceLabel: 'Practice',
    whyText: 'Why: {{why}}',
    practiceText: 'Practice: {{practice}}',
    transcriptHeading: 'Transcript excerpt with markers',
    transcriptSubheading: 'See how the report connects feedback to the original conversation.',
    coachSpeaker: 'Coach',
    clientSpeaker: 'Client',
    annotationLabel: 'Evidence link',
    transcriptSpeakerMeta: '{{timestamp}} · {{speaker}}',
    annotationText: 'Evidence link: {{marker}}',
    quotedEvidence: '“{{quote}}”',
    evidenceMeta: '{{timestamp}} · {{rationale}}',
    markerReferencesText: 'Marker references: {{markers}}',
    includedHeading: 'Every analysis also gives you',
    includedExports: 'PDF/DOCX export',
    includedProgress: 'ICF progress tracking',
    includedFollowup: 'Follow-up Q&A with your AI mentor coach',
    continueCta: 'Continue',
    uploadCta: 'Upload your session',
    content: {
      competencies: {
        C1: {
          narrative: 'Ethical boundaries and client autonomy remain clear.',
          positiveExamples: {
            0: {
              quote: 'What would make this conversation useful for you today?',
              rationale: 'Invites client ownership from the outset.',
            },
          },
        },
        C2: {
          narrative: 'The coach demonstrates reflective self-management.',
          positiveExamples: {
            0: {
              quote: 'I noticed I wanted to solve that for you, so let me pause.',
              rationale: 'Names and releases the impulse to advise.',
            },
          },
        },
        C3: {
          narrative: 'The agreement is specific and remains connected to the client’s desired outcome.',
          positiveExamples: {
            0: {
              quote: 'If we get to the end with clarity, what will be different for you?',
              rationale: 'Clarifies the session outcome in observable terms.',
            },
          },
        },
        C4: {
          narrative: 'The client is given permission to think aloud without judgment.',
          positiveExamples: {
            0: {
              quote: 'Take your time. There is no right answer here.',
              rationale: 'Supports psychological safety and reflection.',
            },
          },
        },
        C5: {
          narrative: 'Presence is grounded and responsive; the next edge is using silence after high-value questions.',
          positiveExamples: {
            0: {
              quote: 'What is happening for you as you sit with that?',
              rationale: 'Brings attention to the client’s present experience.',
            },
          },
          developmentExamples: {
            0: {
              quote: 'And what would happen if you delegated that — would your team step up?',
              rationale: 'Stacks two questions and suggests a direction.',
            },
          },
          inconsistentPatterns: {
            0: 'Occasional stacked questions reduce reflective space.',
          },
        },
        C6: {
          narrative: 'The coach listens beyond content for identity, energy, and shifts in meaning.',
          positiveExamples: {
            0: {
              quote: 'When you say “reliable,” what does that word ask you to carry?',
              rationale: 'Uses the client’s language to explore meaning.',
            },
            1: {
              quote: 'Your pace changed when you said “permission.” What are you noticing?',
              rationale: 'Surfaces a tonal shift without interpreting it for the client.',
            },
          },
        },
        C7: {
          narrative: 'Awareness is evoked through concise questions connected to the client’s identity and choices.',
          positiveExamples: {
            0: {
              quote: 'What becomes possible if reliability includes asking for help?',
              rationale: 'Invites a reframing grounded in the client’s own theme.',
            },
            1: {
              quote: 'What would a version of that boundary sound like in your own voice?',
              rationale: 'Moves awareness toward authentic expression.',
            },
          },
          developmentExamples: {
            0: {
              quote: 'And what would happen if you delegated that — would your team step up?',
              rationale: 'Contains an implied solution.',
            },
          },
        },
        C8: {
          narrative: 'The client authors a measurable experiment and names the support needed to follow through.',
          positiveExamples: {
            0: {
              quote: 'What small experiment are you willing to run this week?',
              rationale: 'Turns insight into a client-owned action.',
            },
            1: {
              quote: 'What will tell you on Friday that this experiment helped?',
              rationale: 'Invites the client to define success evidence.',
            },
          },
        },
      },
      session: {
        title: 'PCC demo session — finding a sustainable leadership rhythm',
        coachName: 'Elena Hart (fictional)',
        clientName: 'Maya Reed (fictional)',
      },
      overallAssessment: '**Performing at PCC.** The coach consistently partners with the client, listens for meaning beneath the words, and turns emerging awareness into a client-owned experiment. The clearest next edge is to allow more silence before adding a second question.',
      recommendations: {
        0: 'Ask one question at a time after emotionally significant client statements.',
        1: 'Let two full breaths pass before adding language when the client is reflecting.',
        2: 'Keep linking action design back to the identity shift the client named.',
      },
      narrative: {
        sessionOverview: 'The session moves from a practical concern about workload into a deeper exploration of how the client defines reliability. The coach follows the client’s language rather than forcing a productivity frame, which allows the client to recognize that asking for help can be part of responsible leadership.',
        whatToWorkOnNext: 'Your strongest pattern is **listening for meaning beneath the words**. The next growth edge is restraint: when a question creates visible reflection, stay with the silence instead of adding a second question. This will make the already-strong awareness work feel even more spacious and client-led.',
      },
      developmentPlan: {
        headline: 'Protect the space after your strongest questions',
        focusAreas: {
          C5: {
            title: 'Use silence deliberately',
            why: 'Your best questions already create reflection; extra wording sometimes interrupts it.',
            practice: 'After a meaningful question, silently count two breaths before speaking again.',
          },
          C7: {
            title: 'Keep questions singular',
            why: 'One clear question gives the client more freedom to choose where to go.',
            practice: 'Review one session and mark every stacked question, then rewrite each as one sentence.',
          },
          C8: {
            title: 'Connect action to identity',
            why: 'The client’s action becomes more durable when it expresses the shift they discovered.',
            practice: 'Close with: “How does this action reflect who you want to be?”',
          },
        },
        firstAction: 'Record one 20-minute practice session focused on asking one question and leaving space.',
        weeklyPractice: 'Review three moments of silence and note what the client did with the space.',
        nextMilestone: 'Demonstrate consistent single-question pacing across two consecutive sessions.',
      },
      markers: {
        PCC_C6_01: {
          text: 'Responds to the whole person, not only the problem presented.',
          quote: 'When you say “reliable,” what does that word ask you to carry?',
          explanation: 'The coach follows the client’s identity language and invites deeper meaning.',
        },
        PCC_C7_03: {
          text: 'Asks questions that help the client explore beyond current thinking.',
          quote: 'What becomes possible if reliability includes asking for help?',
          explanation: 'The question opens a new definition without prescribing it.',
        },
        PCC_C5_02: {
          text: 'Allows sufficient space for the client to reflect and respond.',
          quote: 'And what would happen if you delegated that — would your team step up?',
          explanation: 'The stacked question narrows the client’s reflective space.',
        },
      },
      transcript: {
        0: { text: 'If I ask for help, I worry they will think I am not reliable enough for this role.' },
        1: {
          text: 'When you say “reliable,” what does that word ask you to carry?',
          annotation: 'PCC marker 6.1 · listens for the client’s meaning',
        },
        2: { text: 'It asks me to carry everything. I have never considered that reliability could include trusting the team.' },
        3: {
          text: 'What becomes possible if reliability includes asking for help?',
          annotation: 'PCC marker 7.1 · evokes a client-led reframe',
        },
      },
    },
  },

  // Guided product tour (QA F4). Step ids match tour/tourModel.ts. `where`
  // is shown when the step's element is not on screen (centered card).
  guidedTour: {
    dialogLabel: 'Guided tour',
    counter: 'Step {{current}} of {{total}}',
    next: 'Next',
    back: 'Back',
    skip: 'Skip tour',
    finish: 'Finish',
    whereLabel: 'Where to find it',
    steps: {
      nav_overview: {
        title: 'Everything starts from this menu',
        body: 'Move between Home, Chat, Sessions and Profile here, plus Mentees and Progress when your plan has them. On a phone the menu sits at the bottom and "More" holds the rest.',
        where: 'The menu is on the left on a computer and at the bottom on a phone.',
      },
      upload_session: {
        title: 'Upload a coaching session',
        body: 'In Sessions, upload a recording (MP3, M4A, WAV) or a transcript (PDF, DOCX, TXT). Recordings are transcribed first, then analysed.',
        where: 'Menu → Sessions, upload area at the top of the page.',
      },
      analysis_runs: {
        title: 'Where the analysis runs',
        body: 'The analysis runs on our side and usually takes a few minutes; a long recording takes longer because it is transcribed first. You can leave the page: Sessions shows each session and its status.',
        where: 'Menu → Sessions.',
      },
      report_open: {
        title: 'Your report opens here',
        body: 'Each analysed session has its own report. The top shows the ICF level the session demonstrates, followed by a summary and your next steps.',
        where: 'After your first analysis: Menu → Sessions → open the analysed session.',
      },
      report_read: {
        title: 'How to read the report',
        body: 'Each ICF competency shows its level and the quotes from your session behind it. Start with the summary and next steps, then open the competencies you want to work on.',
        where: 'In a report, scroll down to the competencies.',
      },
      chat_reassess: {
        title: 'Ask about a report, or re-assess it',
        body: 'In Chat you can ask follow-up questions about your sessions and reports, or ask to re-assess a session, for example against the PCC markers. A re-assessment uses 1 analysis credit.',
        where: 'Menu → Chat.',
      },
      progress_goal: {
        title: 'Progress toward your ICF goal',
        body: 'Progress shows how your competencies develop across sessions and how close you are to your target level (ACC, PCC or MCC).',
        where: 'Menu → Progress.',
      },
      profile_plan: {
        title: 'Your plan and credits',
        body: 'Profile shows your plan, how many analyses and chats you have used, and your credit balance. Credits pay for extra analyses and reports; you can buy more or change your plan here.',
        where: 'Menu → Profile (on a phone: the person icon at the top).',
      },
      profile_account: {
        title: 'Your account',
        body: 'Profile holds your account details, language and data settings.',
        where: 'Menu → Profile (on a phone: the person icon at the top).',
      },
      mentees: {
        title: 'Your mentees',
        body: 'Mentees lists everyone you mentor. Each mentee has a workspace with their sessions, reviews and forms.',
        where: 'Menu → Mentees (on a phone: in the bottom bar or under More).',
      },
      create_engagement: {
        title: 'Add a mentee',
        body: '"New mentee" starts a mentoring engagement: the mentee\'s name and email, the ICF level they are working toward and the form language.',
        where: 'Mentees → New mentee.',
      },
      engagement_add_session: {
        title: 'Add a session to a mentee',
        body: 'In the mentee\'s Sessions tab, upload a recording or transcript of their coaching session, or add a session by hand.',
        where: 'Mentees → open a mentee → Sessions → Upload session.',
      },
      sof_review: {
        title: 'Review a session (SOF)',
        body: '"Review" opens the ICF Session Observation Form for that session. MCAi drafts the observations with evidence from the transcript; you confirm or change each one.',
        where: 'Mentees → open a mentee → Sessions → Review.',
      },
      crf: {
        title: 'Competency Review Form (CRF)',
        body: 'Under Review & documents you build the Competency Review Form from the reviewed sessions, write your cumulative feedback and finalize it.',
        where: 'Mentees → open a mentee → Review & documents.',
      },
      send_forms: {
        title: 'Send the forms',
        body: 'When a form is finalized, email it to your mentee or download the PDF.',
        where: 'Mentees → open a mentee → Review & documents → Email to mentee.',
      },
      mcs_prep: {
        title: 'MCS preparation',
        body: 'Track your own preparation for the ICF Mentor Coach Specialization: your hours, each requirement and the official guidance behind it.',
        where: 'Menu → MCS preparation (on a phone: under More).',
      },
      finish: {
        title: 'You\'re ready',
        body: 'You can take this tour again any time from Help.',
        where: 'Help is in the menu on a computer and at the top on a phone.',
      },
    },
  },

  // In-app Help menu (shell): replay the tour, FAQ, feedback.
  helpMenu: {
    title: 'Help',
    tour: 'Take the guided tour',
    tourDescription: 'A short walk through where everything is.',
    faq: 'Help center and FAQ',
    faqDescription: 'Answers to common questions (opens our website).',
    feedback: 'Send feedback',
    feedbackDescription: 'Tell us what is confusing or broken.',
  },

  // Contextual "what is this?" hints. Ids match GUIDANCE_HINT_IDS.
  guidanceHints: {
    open: 'What is this?',
    dismiss: 'Got it',
    analysis_options: {
      title: 'What are these options?',
      body: 'They tell the analysis how to read this session, for example the ICF level to assess against. "Auto" picks the level from the session. If you are unsure, keep the defaults.',
    },
    credits_minutes: {
      title: 'Analyses, chats and credits',
      body: 'Your plan includes a number of analyses each month and a daily chat limit (the bars). Credits are extra: they pay for analyses and reports beyond your plan, and a re-assessment in Chat uses 1 credit.',
    },
    report_level: {
      title: 'What does this level mean?',
      body: 'It is MCAi\'s estimate of the ICF level this session demonstrates (ACC, PCC or MCC), based on the evidence in this report. It is feedback for your development, not an ICF credential decision.',
    },
    sof_review: {
      title: 'What is the SOF review?',
      body: 'The ICF Session Observation Form records what you observed in one session. MCAi drafts it from the transcript; you confirm or edit each item before it counts.',
    },
    crf_form: {
      title: 'What is the CRF?',
      body: 'The ICF Competency Review Form summarises your mentee\'s development across the reviewed sessions. Finalize it when your feedback is complete, then send it to your mentee.',
    },
  },

  // Contextual Tips (one-time tooltips at key moments)
  tips: {
    firstAttach: 'Great! Upload your coaching session recording or transcript here. PDF, Word, and audio files all work.',
    firstAnalysisDone: 'Your analysis is ready! You can ask follow-up questions right here — like "What can I improve on active listening?"',
    newTranscriptReminder: 'Working on a different transcript? Click + to start a new chat. Each transcript should have its own chat.',
    creditLow: 'You have 1 credit left. Each transcript analysis uses 1 credit.',
    pdfExport: 'Need this for your credential file? Export it as an ICF-ready PDF or DOCX.',
    icfProgress: 'Two sessions in — see how your competencies are trending on the Progress tab.',
    practiceExam: 'Preparing for an ICF credential exam? Practice questions are built into Progress.',
    voiceRecording: 'You can record sessions directly — no separate recorder needed.',
    documentsRag: 'Upload coaching notes or ICF study documents so your AI mentor can use them in answers.',
    meetingFeedback: 'Use meeting feedback for structured observation notes, competency evidence, and next-step coaching.',
    mentorTraining: 'Mentor coaches: MCQ drills and cohort grading live under Mentor Training.',
  },

  // Post-Payment Onboarding Intake Form
  intake: {
    mentorWorkspace: {"eyebrow": "Your mentor workspace", "openMentees": "Open Mentees", "empty": "Generate your mentor workspace to organize your next actions.", "refresh": "Refresh workspace", "generate": "Generate workspace", "updated": "Your mentor workspace is up to date."},
    revealCtaEngagements: "Open mentor engagements",
    title: 'Welcome to Mentor Coaching AI',
    revealCtaPlans: 'Choose your plan',
    subtitle: 'A few quick questions so we can build you a personalized coaching plan.',
    helperText: 'Your answers tune your first analysis and development plan. You can update them later from your profile.',
    questions: {
      profileType: 'Which best describes you?',
      credentials: 'Do you hold any coaching credential?',
      credential: 'Which credential do you hold today?',
      hours: 'About how many coaching hours have you logged?',
      education: 'How did you train as a coach?',
      goal: 'What are you working toward next?',
      goalHelper: 'We\'ll tailor your feedback and plan to this goal.',
      frequency: 'How often do you currently coach?',
      challenge: 'What feels hardest right now?',
      focusCompetency: 'Where would you like extra emphasis in your analyses?',
      focusCompetencyHelper: 'Because you\'re working toward your next credential, you can pick the competency you want extra weight on. The AI still evaluates all eight.',
      mentorUse: 'What will you use Mentor Coaching AI for most?',
      mentorVolume: 'How many coaches do you currently mentor or supervise?',
      mentorChallenge: 'What\'s hardest in your mentor work right now?',
      menteeFocus: 'Which competency do your mentees struggle with most?',
      menteeFocusHelper: 'Choose the recurring pattern you most want help observing. MCAi will still evaluate all eight competencies.',
    },
    next: 'Continue',
    back: 'Back',
    stepProgress: 'Step {{current}} of {{total}}',
    skipQuestion: 'Skip this question',
    profileTypes: {
      student: 'Student',
      studentDescription: 'I\'m learning to become a coach',
      coach: 'Professional Coach',
      coachDescription: 'I\'m an active practicing coach',
      mentor: 'Mentor Coach',
      mentorDescription: 'I mentor and supervise other coaches',
    },
    credentialOptions: {
      none: { title: 'No credential yet', description: 'I\'m on my way — credential not earned.' },
      acc: { title: 'ICF ACC', description: 'Associate Certified Coach' },
      pcc: { title: 'ICF PCC', description: 'Professional Certified Coach' },
      mcc: { title: 'ICF MCC', description: 'Master Certified Coach' },
      other: { title: 'Other credential', description: 'EMCC, AC, or another body' },
    },
    hourBuckets: {
      under10: { title: 'Under 10 hours', description: 'Just getting started.' },
      tens: { title: '10 – 50 hours', description: 'Early practice.' },
      fifties: { title: '50 – 100 hours', description: 'Building consistency.' },
      hundreds: { title: '100 – 500 hours', description: 'Established practice.' },
      master: { title: '500+ hours', description: 'Seasoned practitioner.' },
    },
    educationOptions: {
      icf_accredited: { title: 'ICF-accredited program', description: 'Level 1, Level 2, ACTP, ACSTH, or equivalent.' },
      coaching_school: { title: 'Coaching school (non-ICF)', description: 'Other dedicated coaching training.' },
      self_taught: { title: 'Self-taught', description: 'Books, videos, mentors, no formal program.' },
      none: { title: 'No formal training yet', description: 'Just curious or starting out.' },
      other: { title: 'Other', description: 'A different path.' },
    },
    mentorUseOptions: {
      mentee_sessions: { title: 'Reviewing my mentees\' sessions', description: 'Evidence-based feedback on the coaches I mentor.' },
      own_development: { title: 'My own coaching development', description: 'Staying sharp in my own client work.' },
      feedback_prep: { title: 'Preparing mentor feedback', description: 'Structured, marker-level notes for mentor conversations.' },
      program: { title: 'Running a training program', description: 'Grading and progress across a cohort of students.' },
    },
    mentorVolumeOptions: {
      none_yet: { title: 'None yet', description: 'I am preparing to mentor or supervise coaches.' },
      few: { title: '1–3 coaches', description: 'A small mentoring practice.' },
      several: { title: '4–10 coaches', description: 'Several active mentees or supervisees.' },
      many: { title: '10+ coaches', description: 'A larger program or supervision load.' },
    },
    mentorChallengeOptions: {
      evidence: { title: 'Grounding feedback in transcript evidence', description: 'Connecting observations to specific coaching moments.' },
      calibration: { title: 'Calibrating to ICF markers consistently', description: 'Keeping evaluations steady across coaches and sessions.' },
      time: { title: 'Time spent per session review', description: 'Preparing useful feedback more efficiently.' },
      difficult_feedback: { title: 'Delivering hard feedback well', description: 'Being direct while preserving trust and learning.' },
      other: { title: 'Something else', description: 'I will share more context in chat.' },
    },
    goalLevels: {
      ACC: { title: 'ICF ACC', description: 'Earn my Associate Certified Coach credential.' },
      PCC: { title: 'ICF PCC', description: 'Earn my Professional Certified Coach credential.' },
      MCC: { title: 'ICF MCC', description: 'Earn my Master Certified Coach credential.' },
      exploring: { title: 'Just improving my craft', description: 'No specific exam — I want better feedback on real sessions.' },
    },
    challengeOptions: {
      listening: { title: 'Listening deeply', description: 'I want to hear what\'s underneath the words.' },
      questions: { title: 'Asking powerful questions', description: 'Less advice, more insight-opening.' },
      presence: { title: 'Staying present', description: 'Slowing my own thinking in the moment.' },
      structure: { title: 'Structuring the session', description: 'Agreement, exploration, action — making it land.' },
      confidence: { title: 'Trusting myself as a coach', description: 'Quieting the inner critic.' },
      other: { title: 'Something else', description: 'I\'ll share more in chat.' },
    },
    focusCompetencies: {
      C4: {
        title: 'Cultivating trust and safety',
        description: 'Creating a safe, open space your client can lean into.',
      },
      C5: {
        title: 'Maintaining presence',
        description: 'Staying grounded, calm and fully attentive in the moment.',
      },
      C6: {
        title: 'Active listening',
        description: 'Truly hearing what is said — and reflecting it back.',
      },
      C7: {
        title: 'Powerful questions & evoking awareness',
        description: 'Asking questions that open insight, not advice.',
      },
      C8: {
        title: 'Facilitating client growth',
        description: 'Building action, accountability and lasting change.',
      },
      none: {
        title: 'I\'m not sure yet',
        description: 'The AI will evaluate all eight ICF competencies evenly.',
      },
    },
    placeholders: {
      credentials: 'e.g., ICF ACC, PCC, MCC, or other certifications',
      hours: 'e.g., 100',
      education: 'e.g., ICF-accredited program, coaching school, etc.',
      goal: 'Tell us what you hope to achieve...',
    },
    submit: 'Submit',
    skip: 'Skip for now',
    errors: {
      profileTypeRequired: 'Please select your profile type.',
      invalidHours: 'Please enter a valid number of coaching hours (0 or more).',
      submitFailed: 'We could not save your answers. Please try again.',
      skipFailed: 'Unable to skip right now. Please try again.',
      loadFailed: 'We could not restore your saved answers. You can continue here and try saving again.',
    },
    results: {
      title: 'Thank You!',
      skipped: 'You can update your profile anytime from Settings → Profile.',
      saved: 'Your responses have been saved. We\'ll use this information to personalize your experience.',
      continue: 'Continue',
    },
    loading: {
      title: 'Building your plan',
      subtitle: 'This takes a few seconds.',
      checkpoints: {
        readingProfile: 'Reading your profile',
        mappingFocus: 'Picking your focus areas',
        draftingPlan: 'Drafting your plan',
      },
      tip: "Your plan will update as you upload more sessions — it's a living document.",
    },
    plan: {
      eyebrow: 'Your development plan',
      focusHeading: "We'll focus on",
      practiceLabel: 'Practice',
      practiceText: 'Practice: {{practice}}',
      nextMilestoneLabel: 'Next milestone',
      weeklyPracticeLabel: 'Weekly practice',
      firstActionLabel: 'Start here',
      continueCta: 'Take me there',
      sampleAnalysisCta: 'See the sample analysis',
      skippedTitle: "You're all set",
      skippedBody: 'You can build your personalized plan anytime from Settings → Profile.',
      generationFailedTitle: 'We could not build your plan',
      generationFailedBody: 'Your answers are saved. Try again to finish your personalized development plan.',
      retryCta: 'Try building the plan again',
    },
  },

  plans: {
    sampleReportLink: 'See a sample report first',
    cycle1mo: '1 month',
    cycle3mo: '3 months',
    cycle6mo: '6 months',
    months: 'mo',
    tier1: 'Essential',
    tier2: 'Growth',
    tier3: 'Partner Success',
    title: 'Choose the plan that fits your coaching journey',
    subtitle: 'Monthly or annual billing, cancel anytime. Upgrade as your practice grows.',
    selectionTitle: 'Pick a plan, try 3 days free',
    selectionSubtitleLine1: 'Let’s set up your account before your first session.',
    selectionSubtitleLine2: 'Start with a card-backed trial. Cancel anytime before it ends.',
    selectionTitlePaid: 'Choose a plan to continue',
    selectionSubtitlePaidLine1: 'Your account and previous work are ready when you return.',
    selectionSubtitlePaidLine2: 'You will review the total and pay securely in checkout.',
    payMonthly: 'Monthly',
    payYearly: 'Yearly',
    save20Short: 'Save 20%',
    save20: 'Save 20% with annual billing',
    yearlySavingBadge: '2 months free',
    perMonth: '/ mo',
    perYear: '/ yr',
    month: 'month',
    currency: 'TL',
    getStarted: 'Start trial',
    startTrial: 'Start trial',
    continueToCheckout: 'Continue to checkout',
    processing: 'Redirecting…',
    mostPopular: 'Recommended',
    mentorUpsell: {
      onlyInTitle: 'Only in Mentor Coach',
      mentees: 'Mentees workspace with the ICF SOF and CRF forms',
      sendForms: 'Signed SOF and CRF PDFs emailed to your mentees',
      analyses: '10 AI session analyses a month (5 in Chasing Credentials)',
      menteesNotIncluded: 'Mentees not included',
    },
    yourSelectedPlan: 'Your selected plan',
    preselectedBadge: 'Your pick',
    alreadyCovered: {
      title: 'You already have an active plan',
      cta: 'Continue to app',
    },
    changePlan: 'Change plan',
    resumeSubscription: 'Resume subscription',
    moreFeatures: 'more features',
    selectPlan: 'Select a Plan',
    paywallCta: 'Unlock mentor-grade AI feedback for your coaching practice',
    footer: 'All plans include secure storage, GDPR-compliant processing, and email support.',
    cardTrialNotice: 'Card required. You will not be charged until the trial ends.',
    moneyBackGuarantee: '14-day money-back guarantee',
    moneyBackDescription: 'Not satisfied? Contact us within 14 days of your first payment for a full refund, no questions asked.',
    chips: {
      icfGoal: 'ICF target: {{level}}',
      language: 'Language: {{language}}',
      usage: 'Usage: Audio + transcripts',
    },
    noPaymentBanner: {
      headline: 'No payment due today.',
      subline: 'Secure checkout starts your 3-day trial today and bills only after the trial ends.',
    },
    trialEndedBanner: {
      headline: 'Your free trial has ended.',
      subline: 'Pick a plan to keep going. Cancel anytime.',
    },
    ready: {
      title: 'Your account is ready',
      goalSaved: 'Target level saved',
      languageSet: 'Language preference set',
      slotOpened: 'First session slot opened',
      hint: 'After choosing a plan, you’ll go straight to the app.',
    },
    trust: {
      secureTitle: 'Your coaching data is safe',
      secureSub: 'Encrypted and protected.',
      icfTitle: 'ICF-aligned assessment',
      icfSub: 'Scored against ICF standards.',
      noChargeTitle: 'No charge today',
      noChargeSub: 'Free for 3 days, then your plan starts.',
      payTodayTitle: 'Clear checkout total',
      payTodaySub: 'Review the amount before you pay.',
    },
    autoContinue: 'Trial converts automatically when finished. Cancel anytime from account settings.',
    paidCheckoutNotice: 'Your selected plan starts after successful payment. You can manage renewal from account settings.',
    legalTerms: 'Terms of service',
    legalPrivacy: 'Privacy',
    later: 'Maybe later',
    notAvailableTitle: 'Plan selection not available',
    notAvailableMessage: 'Your access is managed by your organization. Please contact your school administrator or support if you have questions.',
    errors: {
      authRequired: 'Please sign in to continue to checkout.',
      paymentFailed: 'Something went wrong while starting checkout. Please try again.',
    },
    individual: {
      name: 'Students',
      tagline: 'For students building the habit of reviewing real sessions.',
      monthlyPrice: '1250',
      yearlyPrice: '15000',
      features: {
        transcripts: '3 AI session analyses/month',
        transcriptionMinutes: '120 voice transcription minutes/month',
        chats: '10 chats per day',
        analytics: 'Basic ICF feedback and progress signals',
        support: 'Email support',
      },
    },
    advanced: {
      name: 'Chasing Credentials',
      tagline: 'For ACC/PCC/MCC candidates preparing stronger submissions.',
      monthlyPrice: '3750',
      yearlyPrice: '45000',
      features: {
        transcripts: '5 AI session analyses/month',
        transcriptionMinutes: '300 voice transcription minutes/month',
        chats: '25 chats per day',
        analytics: 'Advanced analytics & insights',
        support: 'Email support',
        tracking: 'Progress tracking',
        coaching: 'ICF exam-ready DOCX transcript export',
      },
    },
    professional: {
      name: 'Mentor Coach',
      tagline: 'For mentor coaches reviewing sessions at higher volume.',
      monthlyPrice: '8750',
      yearlyPrice: '105000',
      features: {
        transcripts: '10 AI session analyses/month',
        transcriptionMinutes: '1,200 voice transcription minutes/month',
        chats: '50 chats per day',
        analytics: 'Advanced analytics & insights',
        support: 'Email support',
        tracking: 'Progress tracking',
        coaching: 'ICF exam-ready DOCX transcript export',
        mentoring: 'Custom analysis mode and mentor-grade review workflow',
      },
    },
    schools: {
      title: 'For coaching schools & academies',
      subtitle: 'Bulk licensing, white-label portals, and cohort analytics.',
      contact: 'Talk to us about school pricing',
      emailSubject: 'Mentor Coaching AI — School Pricing Inquiry',
      emailBody: 'Hi Mentor Coaching AI team,%0A%0AWe would love to learn more about cohort pricing for our coaching school.%0A%0ABest regards,',
    },
    schoolPaywall: {
      title: 'Complete your school subscription',
      description: 'Finalize your Mentor Coaching AI subscription so students and coaches can access their seats.',
      summaryTitle: 'Plan summary',
      baseLabel: 'Base package',
      baseSummary: '{{price}} / month for {{seats}} seats included',
      addonLabel: 'Add-on package',
      addonSummary: '{{price}} / month per {{seats}} seats',
      packageSingular: 'package',
      packagePlural: 'packages',
      seatTargetLabel: 'Total seats needed',
      seatTargetPlaceholder: 'e.g., 25',
      seatTargetHelp: 'Adjust this if you need more or fewer student seats before checkout.',
      monthlyTotal: 'Estimated monthly total: {{price}}',
      loading: 'Loading plan…',
      notConfigured: 'This school does not yet have a billing plan. Ask a platform admin to configure pricing.',
      errorLoading: 'We could not load the plan summary. Please try again or contact support.',
      checkout: 'Proceed to payment',
      checkoutDescription: 'You will be redirected to Stripe to complete the subscription.',
      checkoutError: 'We could not start the Stripe checkout session. Please try again.',
      instructions: 'After completing payment in Stripe, return here and refresh to unlock onboarding.',
      refresh: 'I completed payment',
      refreshError: 'We could not refresh the subscription status. Please try again.',
    },
  },

  b2bPlanSelection: {
    title: 'Build the right plan for your academy',
    subtitle: 'Choose the number of student and mentor seats you need. Admin accounts are included.',
    yourPlan: 'Your plan summary',
    seats: 'Student + mentor seats',
    seatHelper: 'Your base plan includes {{base}} billable seats. Each add-on bundle adds {{bundle}} seats. Admins do not count.',
    tier: 'Service tier',
    total: 'Estimated monthly total',
    checkout: 'Continue to secure checkout',
    priceDisclaimer: 'Final invoices may vary based on taxes and regional adjustments.',
    redirecting: 'Redirecting you to the correct plan screen…',
    fallbackMissingScreenTitle: 'Loading billing screen…',
    fallbackMissingScreenBody: 'We could not load the school billing experience. Please refresh the page or contact support if this continues.',
    errors: {
      fetchPlan: 'We couldn’t load the plan preview. Please refresh or contact support.',
      notConfigured: 'Your school’s billing plan has not been set up yet, so it can’t be activated here. Contact support@mentorcoaching.ai and we will activate your school.',
      checkout: 'We couldn’t start checkout. Please try again.',
      activationPending: 'Payment succeeded, but Stripe is still finalizing your school subscription. Refresh in a moment to continue.',
      noSchool: 'We could not locate your school profile. Please ask support to confirm your invitation.',
      unauthorized: 'Only school administrators can access this billing screen.',
    },
    errorActions: {
      retry: 'Try again',
      contactSupport: 'Contact support',
      signOut: 'Sign out',
    },
    tiers: {
      tier1: {
        label: 'Core Enablement',
        description: 'Essential analytics, transcript feedback, and email support for smaller cohorts launching with Mentor Coaching AI.',
      },
      tier2: {
        label: 'Growth Accelerator',
        description: 'Everything in Core plus onboarding concierge, cohort insights, and priority support for growing academies.',
      },
      tier3: {
        label: 'Partner Success',
        description: 'Dedicated success manager, white-label options, and custom reporting for network-scale coaching programs.',
      },
    },
    // Flat tier labels for components expecting plans.tierX
    tier1: 'Core Enablement',
    tier2: 'Growth Accelerator',
    tier3: 'Partner Success',
  },

  // Auth
  auth: {
    accountLoadError: {
      title: "We couldn't load your account",
      body: 'This is usually temporary. You are still signed in. Please try again in a moment.',
      retry: 'Retry',
    },
    login: {
      title: 'Welcome Back',
      welcome: 'Welcome Back',
      subtitle: 'Sign in to continue your coaching journey',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
      loginButton: 'Sign In',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      signUp: 'Sign Up',
      rememberMe: 'Remember me',
      fillAllFields: 'Please fill in all fields',
      serverError: 'Server error. Please try again later.',
      invalidCredentials: 'Invalid email or password',
      loginFailed: 'Login failed. Please try again.',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      or: 'or',
      continueWithGoogle: 'Continue with Google',
      googleNotConfigured: 'Google sign-in is not configured for this platform.',
      googleInitializing: 'Google sign-in is still initializing. Please try again.',
      continueWithApple: 'Continue with Apple',
      appleSigninFailed: 'Apple sign-in failed. Please try again.',
      terms: 'By signing in, you agree to our Terms of Service and Privacy Policy',
      termsPrefix: 'By signing in, you agree to our',
      termsSuffix: '.',
    },
    passwordless: {
      // One-time banner for legacy users who registered with a password
      // before the passwordless redesign. Dismiss = ack endpoint call.
      migrationBanner: {
        title: 'We simplified sign-in',
        body: "No more passwords. From now on, you'll always sign in with a one-time code or magic link sent to your email — same account, just safer and easier.",
        gotIt: 'Got it',
      },
      // Shared chrome (header + trust strip beneath the card)
      chrome: {
        appName: 'Mentor Coaching AI',
        help: 'Help',
        trust: {
          noPassword: {
            title: 'No password',
            subtitle: 'Faster, more secure sign-in',
          },
          icf: {
            title: 'ICF aligned',
            subtitle: "Built on ICF's competency model",
          },
          audio: {
            title: 'Audio and transcripts',
            subtitle: 'Your sessions get analyzed',
          },
        },
      },
      // Login screen (OTP)
      login: {
        badge: 'Your coaching data is safe',
        // Logotype above the H1 already shows the brand — H1 leads with action.
        title: 'Sign in',
        subtitle: "Enter your email and we'll send you a 6-digit code. No password to remember.",
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        sendCode: 'Send code',
        sending: 'Sending…',
        codeSentTitle: 'Enter your code',
        codeSentSubtitle: 'We sent a 6-digit code to {{email}}.',
        codeExpiresIn: 'Code valid for 10 minutes',
        verify: 'Verify and sign in',
        verifying: 'Verifying…',
        resend: 'Resend code',
        resendCooldown: 'Resend in {{seconds}}s',
        resendWait: 'Please wait {{seconds}}s before resending.',
        changeEmail: 'Use a different email',
        wrongCode: 'We could not verify that code. Try again or request a new one.',
        invalidCodeFormat: 'Enter the 6-digit code from your email.',
        noActiveCode: 'No active code found. Request a new code.',
        registrationDisabled: 'New sign-ups are temporarily closed. If you already have an account, use the email you registered with.',
        expiredCode: 'That code has expired. Request a new one.',
        tooManyAttempts: 'Too many incorrect attempts. Request a new code.',
        otpLocked: 'Too many incorrect attempts. Try again in an hour.',
        incorrectCode: 'That code is incorrect. Try again.',
        accountInactive: 'This account is inactive. Contact support if you think this is a mistake.',
        sendCodeError: 'We could not send the code. Please try again.',
        invalidEmail: 'Enter a valid email address.',
        or: 'or',
        continueWithGoogle: 'Continue with Google',
        continueWithApple: 'Continue with Apple',
        newAccountHint: "New here? Enter your email above and we'll set up your account after verification.",
        noAccount: "Don't have an account?",
        signUp: 'Create account',
      },
      // Sign-up screen (magic link)
      signup: {
        badge: 'Try free',
        // Logotype above the H1 already shows the brand — H1 leads with action.
        title: 'Create your account',
        subtitle: "Enter your email and we'll send you a sign-up link — no password needed. Then answer a few short questions and start your free trial.",
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        sendLink: 'Send magic link',
        sending: 'Sending…',
        linkHint: "We'll verify you securely when you open the link.",
        linkSentTitle: 'Check your inbox',
        linkSentBody: 'We sent a sign-in link to {{email}}. Open it to finish setting up your account.',
        linkSentTip: 'Tip: open the email on this device so the link drops you straight back here.',
        sendAnother: 'Send another link',
        changeEmail: 'Use a different email',
        sendError: 'We could not send the link. Please try again.',
        invalidEmail: 'Enter a valid email address.',
        or: 'or',
        signUpWithGoogle: 'Sign up with Google',
        signUpWithApple: 'Sign up with Apple',
        terms: 'By continuing, you agree to the Terms of Service and Privacy Policy.',
      },
      // Magic-link consume screen
      consume: {
        verifying: 'Signing you in…',
        verifyingHint: 'Confirming the link is valid. Hang tight.',
        success: "You're in!",
        successHint: 'Redirecting you to your workspace…',
        invalid: 'This sign-in link has expired or was already used',
        invalidHint: 'Sign-in links work once and expire after 15 minutes. Get a new code to sign in.',
        invalidHintWithEmail: 'Sign-in links work once and expire after 15 minutes. We can email a new sign-in code to {{email}}.',
        sendNewCode: 'Email me a new code',
        sendingNewCode: 'Sending…',
        newCodeFailed: "We couldn't send a new code just now. Enter your email on the sign-in page to get one.",
        backToSignIn: 'Back to sign in',
        checkFailed: "We couldn't check this sign-in link",
        checkFailedHint: 'Check your connection and try again.',
        tryAgain: 'Try again',
      },
    },
    invitation: {
      title: 'Activate Your Account',
      subtitle: 'Confirm your name to access your coaching workspace. No password is needed.',
      school: 'School',
      email: 'Email',
      inviter: 'Invited by',
      fullName: 'Full Name',
      fullNamePlaceholder: 'e.g., Jane Coach',
      passwordlessTitle: 'Passwordless sign-in',
      passwordlessBody: 'After activation, use your email address to receive a one-time code whenever you sign in.',
      password: 'Password',
      passwordPlaceholder: 'Create a secure password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter your password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      requirements: 'Password requirements',
      requirementLength: 'Minimum 8 characters',
      requirementMix: 'Use a mix of letters and numbers',
      createButton: 'Activate Account',
      terms: 'By continuing, you agree to follow the platform’s usage policies.',
      invalidLink: 'This invitation link is invalid or has expired.',
      validationError: 'We could not validate this invitation. Please request a new link.',
      fullNameRequired: 'Please enter your full name.',
      passwordRequired: 'Please choose a password.',
      passwordTooShort: 'Password must be at least 8 characters.',
      passwordMismatch: 'Passwords do not match.',
      acceptFailed: 'We could not complete the invitation. Please try again.',
      acceptError: 'Something went wrong while activating the invitation.',
      success: 'Welcome aboard, {{name}}! Your account is ready. Sign in with the one-time code sent to your email.',
      personalSubscriptionWarning: 'Joining your school does not cancel your personal subscription. You can manage or cancel it in Billing.',
    },
    register: {
      title: 'Get Started',
      createAccount: 'Get Started',
      subtitle: 'Create your coaching account',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      password: 'Password',
      passwordPlaceholder: 'Create a password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter your full name',
      firstName: 'First Name',
      lastName: 'Last Name',
      registerButton: 'Create Account',
      createButton: 'Create Account',
      hasAccount: 'Already have an account?',
      haveAccount: 'Already have an account?',
      signIn: 'Sign In',
      agreeToTerms: 'I agree to the Terms of Service and Privacy Policy',
      terms: 'By creating an account, you agree to our Terms of Service and Privacy Policy',
      termsPrefix: 'By creating an account, you agree to our',
      termsSuffix: '.',
      // Validation errors
      fullNameRequired: 'Please enter your full name',
      emailRequired: 'Please enter your email address',
      invalidEmail: 'Please enter a valid email address',
      passwordRequired: 'Please enter a password',
      passwordTooShort: 'Password must be at least 8 characters long',
      passwordNeedsUppercase: 'Password must contain at least one uppercase letter',
      passwordNeedsLowercase: 'Password must contain at least one lowercase letter',
      passwordNeedsNumber: 'Password must contain at least one number',
      passwordMismatch: 'Passwords do not match',
      termsRequired: 'You must accept the Terms of Service',
      registrationFailed: 'Registration failed. Please try again.',
      accountCreated: 'Account created! Please check your email to verify your account.',
      creatingAccount: 'Creating account...',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },
    logout: {
      title: 'Logout',
      message: 'Are you sure you want to logout?',
      confirm: 'Logout',
      cancel: 'Cancel',
    },
  },

  // Dashboard
  dashboard: {
    unlimited: 'Unlimited',
    plan: {
      eyebrow: 'Your plan',
      dismiss: 'Hide plan card',
      focusLabel: 'Focus areas',
      weeklyLabel: 'Weekly practice',
      startLabel: 'Start here'
    },
    transcriptionMinutes: 'transcription minutes',
    noRecentSessions: 'No sessions yet',
    webPrivacyNote: 'Your coaching data is in your control.',
    recentSessionsTitle: 'Recent sessions',
    title: 'Dashboard',
    welcome: 'Welcome back',
    welcomeMessage: 'Your coaching progress overview',
    profileSettings: 'Profile & Settings',
    personalizedPlan: 'Personalized Plan',
    activeSessions: 'Active Sessions',
    icfProgress: 'ICF Progress',
    chatConversations: 'Chat conversations',
    recentConversations: 'Recent Conversations',
    noConversationsYet: 'No conversations yet',
    startChatWithAI: 'Start your first conversation with Mentor Coaching AI',
    startChatting: 'Start chatting to see your recent sessions here.',
    sessionStarted: 'Started',
    quickActions: 'Quick Actions',
    uploadDocument: 'Upload Document',
    addMaterials: 'Add coaching materials',
    startChat: 'Start Chat',
    newChat: 'New Chat',
    beginConversation: 'Start conversation with AI',
    uploadAudio: 'Upload Audio Recording',
    uploadAudioDesc: 'Upload a coaching session recording for transcription and ICF analysis',
    refreshData: 'Refresh',
    updateData: 'Update data',
    pullLatestStats: 'Pull latest dashboard stats',
    loadingData: 'Loading dashboard data...',
    failedToLoad: 'Failed to load dashboard data',
    webGreeting: 'Hi, {{name}}',
    webGreetingSubtitle: 'Upload a new session today or return to your latest feedback.',
    webRecentSession: 'Session',
    webUploadTitle: 'New session analysis',
    webUploadBody: 'Upload audio, PDF, DOCX, or TXT. Your feedback will be ready in chat.',
    webUploadCta: 'Upload session',
    webHowItWorks: 'How it works',
    webSecure: 'Secure',
    webIcfAligned: 'ICF aligned',
    webTurkishSupported: 'Turkish supported',
    webLatestFeedback: 'Your latest feedback',
    webLatestAnalysisAvailable: 'Latest analysis ready',
    webTrialAnalysisPreview: 'Trial analysis preview',
    webAnalysisScore: '{{score}}/100 overall',
    webAnalysisLevel: '{{level}} level',
    webAnalysisReadyCopy: 'Your analysis is complete and ready to explore. Open the feedback to review the evidence and next steps.',
    webAnalysisHighlights: 'Top highlights',
    webNoAnalysisTitle: 'No analysis yet',
    webNoAnalysisCopy: 'Upload your first session to create real feedback here.',
    webLatestFallback: 'Demo coaching session analysis',
    webCompleted: 'Completed',
    webOpenFeedback: 'Open feedback',
    webSuggestedFollowup: 'Follow-up question',
    webPccQuestion: 'Am I ready for PCC level?',
    webGeneralFollowupQuestion: 'What is the most important next action from this feedback?',
    webWeeklyFocus: 'This week’s focus',
    webWeeklyFocusFallback: 'Next session focus',
    webActiveListening: 'Active listening',
    webFocusCopy: 'Suggested micro-practices will appear here after your latest analyses.',
    webOpenExercise: 'View suggested practice',
    webProgressLockedTitle: 'Unlock ICF progress tracking',
    webProgressLockedCopy: 'Upgrade to the Advanced plan to automatically track readiness level, strengths, and development focus.',
    webProgressLockedCta: 'Upgrade plan',
    webProgressLockedSchoolTitle: 'ICF progress is not enabled on this school plan',
    webProgressLockedSchoolCopy: 'This section appears only on school plans with ICF progress tracking. You can still upload sessions and use feedback in chat.',
    webProgressLockedSchoolCta: 'Manage school plan',
    webSessionsAnalyzed: 'sessions analyzed',
    webNoProgressYet: 'Waiting for data',
    webEstimatedLevel: 'Estimated level',
    webStrongArea: 'Strong area',
    webFocus: 'Focus',
    webRecentFeedback: 'Recent feedback',
    webNoRecentFeedback: 'Your completed session analyses will appear here.',
    webDemoAnalysisOne: 'Demo coaching session analysis',
    webDemoAnalysisTwo: 'Powerful questioning analysis',
    webDemoAnalysisThree: 'Silence use draft',
    webHowModalTitle: 'How does session upload work?',
    webHowModalBody: 'Choose an audio file or transcript. The default settings are enough for most users.',
    webHowStepOne: 'Choose your file',
    webHowStepTwo: 'Analysis is prepared automatically',
    webHowStepThree: 'Review the result in chat',
    stats: {
      sessions: 'Sessions',
      progress: 'Progress',
      hours: 'Hours',
      goals: 'Goals',
    },
    recentSessions: {
      title: 'Recent Sessions',
      viewAll: 'View All',
      noSessions: 'No sessions yet',
      startFirst: 'Start your first coaching session',
    },
    intakeSummary: {
      title: 'Your Coaching Profile',
      viewDetails: 'View Details',
      updateProfile: 'Update Profile',
    },
    session: 'Session',

    // Credits
    credits: 'Credits',
    lowCredits: 'Low',
    availableCredits: 'Available Credits',
    subscriptionCredits: 'Subscription',
    purchasedCredits: 'Purchased',
    creditsResetOn: 'Resets on',
    buyMoreCredits: 'Buy More Credits',
    buyTranscriptionMinutes: 'Buy Transcription Minutes',
    purchasedCreditsNeverExpire: 'Purchased credits never expire',
    // Credit warning banner
    runningLowOnCredits: 'Running Low on Credits',
    creditsRemaining: 'You have {{remaining}} credit(s) remaining out of {{total}} this month.',
    creditsRemainingNoTotal: 'You have {{remaining}} credit(s) remaining.',
    // Credit purchase modal
    buyCredits: 'Buy Credits',
    getMoreAnalysisCredits: 'Get more analysis credits',
    addCreditsToSchool: 'Add credits to your school pool',
    loadingCreditPacks: 'Loading credit packs...',
    failedToLoadPacks: 'Failed to load credit packs. Please try again.',
    tryAgain: 'Try Again',
    comingSoon: 'Coming Soon',
    comingSoonMessage: 'Credit pack purchases will be available soon. In the meantime, you can use your subscription credits.',
    gotIt: 'Got it',
    credit: 'Credit',
    creditPlural: 'Credits',
    perCredit: 'per credit',
    bestValue: 'Best Value',
    creditsNeverExpireInfo: 'Purchased credits never expire and can be used anytime. They are used before your subscription credits.',
    secureCheckout: 'Secure checkout powered by Stripe',
    noPacksAvailable: 'No Credit Packs Available',
    noPacksAvailableMessage: 'Credit packs are being configured. Please check back soon.',
    packNotAvailableYet: 'Not available yet',
    checkoutFailed: 'Checkout Failed',
    checkoutFailedMessage: 'Unable to start checkout. Please try again.',
    purchaseSuccess: 'Purchase Successful!',
    creditsAdded: 'credits added to your account!',
    purchaseProcessing: 'Purchase Processing',
    purchaseProcessingMessage: 'Your payment is being processed. Credits will appear shortly.',
    ok: 'OK',
    // Zero credit blocker
    noCreditsAvailable: 'No Credits Available',
    usedAllCredits: "You've used all {{total}} credits included in your subscription this month.",
    noCreditsToAnalyze: "You don't have any credits available to analyze coaching sessions.",
    planRequiredToAnalyze: 'An active plan is required. Choose a plan to continue.',
    creditsWillRefresh: 'Your credits will refresh on your next billing cycle',
    getMoreCredits: 'Get more credits to continue analyzing your coaching sessions.',
    buyMoreCreditsButton: 'Buy More Credits',
    upgradePlan: 'Upgrade Plan',
    cancel: 'Cancel',
    // Sharing
    recentlyShared: 'Recently Shared with You',
    viewAllShared: 'View All Shared',
    sharedBy: 'From',
    noRecentShared: 'No shared documents yet',
    unknown: 'Unknown',
    welcomePlanTitle: 'Your AI Welcome Plan',
    welcomePlanSubtitle: 'Start with the personalized message seeded from your onboarding answers.',
    welcomePlanOpen: 'Open your welcome plan',
    welcomePlanFallbackPreview: 'Your personalized welcome plan is ready. Open it to see the next steps Mentor Coaching AI prepared for you.',
    activationChecklistTitle: 'Activation Checklist',
    uploadFirstSession: 'Upload your first session',
    sampleSessionTitle: 'PCC demo session',
    sampleSessionMeta: '38 min · anonymized real sample analysis',
    sampleSessionOpen: 'Open the PCC sample session report',
    sampleBadge: 'SAMPLE',
    levelUpChecklistTitle: 'Level up',
    activationChecklistProgress: '{{completed}}/{{total}} complete',
    levelUpChecklistComplete: "You've explored everything MCAi offers 🎓",
    activationItems: {
      profile: 'Build your coaching profile',
      upload: 'Upload your first session',
      analysis: 'Run your first analysis',
      reply: 'Reply to your AI coach',
      pdfExport: 'Export your analysis as PDF',
      icfProgress: 'Check your ICF progress',
      developmentPlan: 'Review your development plan',
      practiceExam: 'Try a practice exam question',
      documents: 'Add a document to your library',
    },
    activationGoalTitle: 'Your first session can move you closer to {{goal}}',
    activationGoalWithCredentialsBody: 'With {{credentials}} in your background, uploading a real session is the fastest way to make progress toward {{goal}}.',
    activationGoalBody: 'Upload a real session or start a chat to turn your plan into progress toward {{goal}}.',
    activationCredentialsBody: 'With {{credentials}} in your background, your first upload will give you feedback that fits your current practice.',
    activationScreenBadge: 'First analysis',
    activationScreenTitle: 'Upload Your First Session',
    activationScreenSubtitle: 'The fastest way to see Mentor Coaching AI working is to upload one real coaching session or try the sample analysis first.',
    activationScreenGoal: 'Hi {{firstName}}, the fastest way to make progress toward {{goal}} is to upload one real coaching session or preview the flow with a sample analysis.',
    activationGreetingName: 'there',
    activationScreenWhyTitle: 'Why start here',
    activationScreenWhyOne: 'You will get a transcript, analysis, and concrete ICF-aligned coaching feedback from your own session.',
    activationScreenWhyTwo: 'Your welcome plan becomes more useful once it is grounded in a real conversation.',
    activationScreenWhyThree: 'If you are not ready to upload yet, you can still preview the experience with a sample session.',
    activationScreenPrimaryCta: 'Upload audio recording',
    activationScreenSecondaryCta: 'Try a sample analysis first',
    activationScreenPracticeCta: 'Practice with an AI client',
    activationScreenContinueCta: 'Continue to dashboard',
    practiceSession: {
      eyebrow: 'AI-active onboarding',
      title: 'Practice with an AI client',
      subtitle: 'Run a realistic coaching conversation to rehearse your ICF competencies.',
      description: 'Choose a scenario and coach the AI client naturally for as many turns as you like.',
      startCta: 'Start practice session',
      starting: 'Starting practice session...',
      sending: 'Sending...',
      startPrompt: "Let's begin the practice session.",
      sessionPrefix: 'Practice',
      sessionHint: 'Stay in coach mode. The AI will stay in client mode.',
      inputPlaceholder: 'Coach the client here...',
      startFailed: 'We could not start the practice session. Please try again.',
      replyFailed: 'Your message could not be sent. Please try again.',
      scenarios: {
        overwhelmedLeader: {
          title: 'Overwhelmed leader',
          description: 'A newly promoted manager is stretched thin, over-functioning, and close to burnout.',
          context: 'The client is a newly promoted team leader who says yes to everything, feels responsible for everyone, and is losing energy at home and at work.',
        },
        careerTransition: {
          title: 'Career transition',
          description: 'A senior professional wants a change but keeps second-guessing the move.',
          context: 'The client wants to leave a stable career path for more meaningful work, but keeps hesitating because of financial fear and identity loss.',
        },
        confidenceAfterFeedback: {
          title: 'Confidence after feedback',
          description: 'A coach lost momentum after difficult feedback and now doubts their own capability.',
          context: 'The client is a practicing coach who received sharp feedback after a recent session and now feels hesitant, self-conscious, and less trusting of their instincts.',
        },
      },
    },
  },

  // Chat
  chat: {
    activationCelebrationTitle: 'Your first analysis is ready 🎉',
    activationCelebrationBody: "You're now getting the feedback most coaches only receive 3–5 times in their whole credential journey.",
    activationCelebrationCta: 'Read your feedback',
    samplePreviewBadge: 'SAMPLE — your real analysis will appear here',
    samplePreviewTitle: 'PCC demo session analysis',
    samplePreviewSummary: 'Performing at PCC, with marker evidence across all eight competencies and a focused development plan.',
    samplePreviewQuestionOne: 'What can I improve in active listening?',
    samplePreviewAnswerOne: 'Stay with the client’s exact language for one more beat before reframing, then reflect the tension you heard and let the client choose where to go next.',
    samplePreviewOpen: 'Explore the real sample report',
    fileFallback: 'File',
    referenceTruncated: 'File attached, but it was long so we kept the first part as context.',
    referenceAttachFailed: 'Could not attach this file.',
    referenceRemoveFailed: 'Could not remove this file.',
    webSuggestionStrength: 'What was my strongest ICF behavior?',
    webSuggestionImprove: 'What should I focus on in the next session?',
    webSuggestionPcc: 'Am I ready for PCC level?',
    webUsageChat: 'Chat',
    webUsageCountUnavailable: 'Usage count could not be loaded',
    webUsageDaily: 'Daily limit',
    trialUsageLabel: 'Free trial',
    trialUsageSummary: 'Trial: {{used}}/{{total}} chats · {{hours}}h left',
    trialChatsValue: '{{used}}/{{total}} chats',
    trialUsageRemaining: '{{remaining}} remaining · {{hours}}h left',
    trialAnalysisLabel: 'Trial analysis',
    trialAnalysisRemaining: '{{remaining}} of {{total}} remaining in trial',
    trialVoiceLabel: 'Trial voice minutes',
    trialVoiceUsage: '{{used}} of {{total}} min used in trial',
    trialUsageTitle: 'Free trial allowance',
    trialUsageExplanation: 'Your trial includes {{total}} chats until its deadline.',
    webUsageAnalysis: 'Analysis',
    webUsageUnlimitedAnalysis: 'Unlimited analysis',
    webSchoolPlanIncluded: 'Institution plan',
    webUsageMonthly: 'monthly usage',
    webUsageCredits: 'Credit balance',
    webUsageVoice: 'Voice duration',
    webUsageUsed: 'used',
    webUsageTotal: 'total quota',
    webUsageTranscription: 'Transcription minutes',
    webTranscriptReady: 'Transcript ready',
    webAnalysisDone: 'ICF analysis completed',
    removeReference: 'Remove reference',
    attachAnalyzeOption: 'Upload transcript for analysis',
    attachReferenceOption: 'Attach reference file',
    attachMenu: 'Attach a file',
    dropToAttach: 'Drop — will be added as a reference file',
    webComposerPlaceholder: 'Ask a follow-up question...',
    webFileSummary: 'File summary',
    webSecurelySaved: 'Securely saved',
    webAnalysisSummary: 'Analysis summary',
    webType: 'Type',
    webIcfAssessment: 'ICF assessment',
    webLanguage: 'Language',
    webLevel: 'Level',
    webMessages: 'Message',
    webProgressNote: 'Each analysis can be added to progress tracking and is securely saved.',
    title: 'Coach AI',
    subtitle: 'Your AI coaching companion',
    placeholder: 'Type your message...',
    send: 'Send',
    thinking: 'AI is thinking...',
    error: 'Failed to send message',
    retry: 'Retry',
    newConversation: 'New Conversation',
    conversations: 'Conversations',
    noMessages: 'Start a conversation with your AI coach',
    welcomeMessage: 'Hello! I\'m your AI coaching assistant. How can I help you today?',

    // Enhanced Chat Screen
    session: 'Session',
    loading: 'Loading chat...',
    failedToLoadSessions: 'Failed to load chat sessions',
    failedToLoadMessages: 'Failed to load messages',
    viewSessions: 'View sessions',
    attachDocument: 'Attach document',
    newSession: 'New session',
    messagesCount: '{{count}} messages',
    tapToSwitch: 'Tap to switch sessions',
    chats: 'Chats',
    transcripts: 'Transcripts',
    dailyChats: 'Daily Chat',
    monthlyTranscripts: 'Monthly Transcript',
    extraCredits: 'Extra Credit',
    webSchoolPlan: 'School plan',
    webCredits: 'credits',
    webCreditStatus: 'Credit status',
    yourAllowances: 'Your Allowances',
    dailyChatsTitle: 'Daily Chats',
    monthlyTranscriptsTitle: 'Monthly Transcripts',
    purchasedCreditsTitle: 'Purchased Credits',
    dailyChatsExplanation: 'Your current plan includes {{limit}} chat messages per day. This allowance resets every day at midnight.',
    monthlyTranscriptsExplanation: 'Your current plan includes {{limit}} transcript analyses per month. Each document you upload and analyze uses one credit. This allowance resets at the start of each month.',
    purchasedCreditsExplanation: 'These are extra credits you purchased separately. They never expire and are always used first, before your subscription allowance.',

    // Quota messages
    quotaExceeded: 'Daily Limit Exceeded',
    dailyLimitMessage: 'You\'ve reached your daily limit of {{limit}} messages. Please try again tomorrow or upgrade your plan.',
    transcriptQuotaExceeded: 'Monthly Transcript Limit Exceeded',
    monthlyTranscriptLimitMessage: 'You\'ve reached your monthly limit of {{limit}} transcript analyses. Please try again next month or upgrade your plan.',
    sendingMessage: 'Sending message...',
    aiThinking: '🤔 AI is thinking... This may take a moment.',
    processing: 'Processing...',
    sendFailed: 'Failed to send message',

    // File analysis
    filePickError: 'Error selecting file',
    defaultAnalysisInstructions: 'Analyze this coaching session transcript according to ICF standards and provide an evaluation. Highlight the coach\'s competencies, strengths, and areas for development.',
    quickTemplates: 'Quick Templates',
    pccSessionAnalysis: 'PCC Session Analysis',
    fileUploaded: '📎 File uploaded: {{filename}}',
    analyzingDocument: 'Analyzing... This may take a while. Want a coaching joke? "I asked a powerful question; now I\'m coaching the silence." 😊',
    analysisError: 'Analysis Error',
    analysisFailed: 'Failed to analyze document',
    analysisInstructionsRequired: 'Please enter analysis instructions',
    uploadTranscriptPromptTitle: 'Upload transcript',
    uploadTranscriptPromptMessage: 'To continue, please upload your transcript file (.docx, .pdf, .txt).',
    uploadTranscriptPromptAction: 'Upload file',

    // Modals
    analysisInstructions: 'Analysis Instructions',
    analyze: 'Analyze',
    howToAnalyze: 'How would you like the AI to analyze this file?',
    analysisPlaceholder: 'Example: Analyze this coaching session transcript according to ICF standards...',
    icfProgressTracking: 'ICF Progress Tracking',
    icfProgressDescription: 'Include this analysis results in ICF progress tracking',
    examples: 'Examples',
    examplePCC: 'Analyze this coaching session transcript according to ICF standards and evaluate at PCC level.',
    exampleStrengths: 'Identify the coach\'s strengths and areas for development in this transcript. Provide specific examples.',
    exampleQuestions: 'Analyze the quality of questions used by the coach in this session and suggest more effective questions.',
    examplePccMarkers: 'List each ICF PCC marker as Seen/Not Seen with timestamps and quotes for the markers that appear.',
    exampleNegativeReflection: 'Assess whether the coach heard and reflected the client\'s negative emotions and statements; if not, call out the gaps with relevant ICF competencies.',
    pccEvaluation: 'PCC Evaluation',
    strengthsAndDevelopment: 'Strengths & Development',
    questionAnalysis: 'Question Analysis',

    // Transcript analyzed indicator
    transcriptAnalyzedBadge: 'Transcript analyzed in this chat',

    // Sessions list
    chatSessions: 'Chat Sessions',
    newChat: 'New Chat',
    noConversations: 'No conversations yet',
    startFirstChat: 'Start your first chat!',
    renameSession: 'Rename Session',
    sessionTitlePlaceholder: 'Enter session title...',
    sessionRenamed: 'Session renamed successfully',
    renameFailed: 'Failed to rename session',
    deleteConversation: 'Delete Conversation',
    deleteConfirmTitle: 'Delete Conversation?',
    deleteConfirmMessage: 'Are you sure you want to delete this conversation? This action cannot be undone.',
    delete: 'Delete',
    deleteSuccess: 'Conversation deleted',
    deleteFailed: 'Failed to delete conversation',

    // UI
    startConversation: 'Start a conversation',
    conversationDescription: 'Ask questions about your coaching materials or upload documents for analysis',
    sources: 'Sources',
    downloadPdf: 'Download PDF',
    downloadStandardPdf: 'Download analysis (PDF)',
    downloadObservationPdf: 'Download observation form (PDF)',
    exportPdfFailed: 'Could not export the PDF. Please try again.',
    dailyLimitReached: 'Daily chat limit reached ({{used}}/{{limit}}). Try again tomorrow or upgrade your plan.',
    limitExceededPlaceholder: 'Chat limit exceeded',
    messagePlaceholder: 'Ask your Mentor Coaching AI...',
    analysisInProgress: 'Analysis in progress, please wait...',
    tip: 'Tip',
    waitingTips: {
      title: 'Quick tip',
      tip1: 'We recommend always doing transcript analyses in a new chat.',
      tip2: 'After an analysis, continue asking follow-up questions in the same chat.',
      tip3: 'Make sure your transcripts clearly label coach vs. client turns and include timestamps.',
      tip4: 'Use the attach icon inside a new chat to upload transcripts.',
      tip5: 'Click the + icon in the header to start a fresh chat.',
      tip6: 'Activate the ICF Progress toggle when uploading transcripts to track development by competency.',
      tip7: 'Read the Terms of Service to understand how analyses work, their limits, and how to use them responsibly.',
      tip8: 'Review the Privacy Policy so you know how your and your client’s data stays secure.',
      tip9: 'Head to the Profile & Settings section for invoices, billing, and account controls.',
      tip10: 'Transcript allowances refresh monthly according to your purchased package.',
      tip11: 'You can switch between packages whenever you need to.',
    },
    enterNewTitle: 'Enter a new title for this session',
    aiDisclaimer: 'AI can make mistakes. Please verify important information.',
  },

  // Alerts & Confirmations
  alerts: {
    connectionError: 'Connection error. Please check your internet.',
    sessionExpired: 'Your session has expired. Please login again.',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  },
  errors: {
    connectionUnavailable: 'Connection could not be established. Please check your internet connection and try again.',
    serverUnavailable: 'The server is not reachable right now. Please try again in a little while.',
    timeout: 'This took longer than expected. Please try again.',
    rateLimited: 'Too many requests were sent in a short time. Please wait a moment and try again.',
    voiceMinutesExceeded: 'Voice transcription minute limit reached. Your plan includes {{limit}} minutes a month, with about {{remaining}} minutes left including purchased packs.',
    voiceMinutesExceededTrial: 'Trial voice transcription limit reached. Your 3-day trial includes {{limit}} minutes; about {{remaining}} minutes remain. Choose a plan to keep transcribing.',
    voiceMinutesExceededGeneric: 'Voice transcription minute limit reached. Buy transcription minutes or upload a shorter recording.',
    sessionExpired: 'Your session may have expired. Please sign in again.',
    genericRetry: 'Something went wrong. Please try again.',
  },

  // Settings
  settings: {
    title: 'Settings',
    language: 'Language',
    notifications: 'Notifications',
    privacy: 'Privacy',
    support: 'Support',
    about: 'About',
    version: 'Version',
  },

  // Profile & Subscription
  profile: {
    billingCycle1mo: '1 month',
    billingCycle3mo: '3 months',
    billingCycle6mo: '6 months',
    developmentPlan: {
      title: 'Development Plan',
      nextLabel: 'Next',
      lastUpdated: 'Last updated',
      empty: 'No development plan yet. Generate one to get a personalized roadmap that the AI references in every analysis and chat.',
      refreshSuccessTitle: 'Plan refreshed',
      refreshSuccessMessage: 'Your development plan is up to date.',
      refreshFailedTitle: 'Could not refresh',
      refreshFailedMessage: 'Please try again in a moment.',
      refreshing: 'Refreshing…',
      refreshCta: 'Refresh plan',
      generateCta: 'Generate plan'
    },
    title: 'Profile & Subscription',
    loading: 'Loading profile...',
    failedToLoad: 'Failed to load profile',
    retry: 'Retry',
    webTitle: 'Profile',
    webSubtitle: 'Manage account settings, security, and usage in one place.',
    webLogout: 'Log out',
    webEditProfile: 'Edit profile',
    webLanguagePreferences: 'Language preferences',
    webLanguageMeta: 'App and email language',
    webAccountSecurity: 'Account and security',
    webPasswordTitle: 'Password',
    webPasswordSubtitle: 'Change your password.',
    webBillingTitle: 'Subscription and billing',
    webBillingSubtitle: 'Manage your plan and payment settings.',
    webPlanTitle: 'Your plan',
    webManagePlan: 'Manage plan',
    webCancelSubscription: 'Cancel subscription',
    webCancelSubscriptionSubtitle: 'Stop renewal from this account.',
    cancelTrial: 'Cancel trial',
    cancelTrialSubtitle: 'Stop renewal before the trial charges.',
    cancelTrialMessage: 'Choose whether to keep access until the trial deadline or end the trial now. You will not be charged after cancellation.',
    cancelTrialAtEndButton: 'Cancel at trial end',
    cancelTrialAtEndDescription: 'Keep access until the trial ends, then stop before any charge.',
    cancelTrialNowButton: 'End trial today',
    cancelTrialNowDescription: 'End trial access immediately. You will not be charged.',
    cancelTrialSuccessImmediate: 'Your trial has ended. You will not be charged.',
    cancelTrialSuccessScheduled: 'Your trial stays available until its deadline, then ends without a charge.',
    resumeTrialRenewal: 'Resume renewal',
    resumeTrialSuccess: 'Trial renewal restored. Your card will be charged when the trial ends unless you cancel again.',
    trialSetToEnd: 'Trial will end without a charge at the current deadline.',
    choosePlan: 'Choose a plan',
    choosePlanBeforeTrialEnds: 'Subscribe before your trial ends to keep access.',
    choosePlanToRestoreAccess: 'Choose a plan to continue using the platform.',
    trialCardLabel: 'Free trial · Card on file',
    trialNoCardLabel: 'Free trial · No card required',
    trialEndsOn: 'Ends on',
    trialActive: 'Trial active',
    trialCardNotice: 'Your saved payment method will be charged when the trial ends unless you cancel beforehand.',
    trialNoCardNotice: 'Your trial ends at the current deadline and will not renew or charge automatically.',
    priceAfterTrial: '{{price}} after trial',
    afterTrial: 'after trial',
    trialLessThanHour: 'Less than 1 hour left',
    trialHoursRemaining: '{{count}} hours left',
    trialDaysRemaining: '{{count}} days left',
    trialAnalyses: 'Trial analyses',
    trialChats: 'Trial chats',
    trialLifetimeLimit: 'For this trial',
    webBillingPortalTitle: 'Payment method and invoices',
    webBillingPortalSubtitle: 'Open Stripe billing details.',
    webMonthlyTranscripts: 'Transcripts this month',
    webDailyChat: 'Daily chat',
    webCreditBalance: 'Credit balance',
    webCreditHint: 'Used for extra analyses and reports.',
    webBuyCredits: 'Buy credits',
    webPrivacyData: 'Privacy and data',
    webExportDataTitle: 'Export data',
    webExportDataSubtitle: 'Download the data in your account.',
    webPrivacyPolicyTitle: 'Privacy policy',
    webPrivacyPolicySubtitle: 'Read our privacy policy.',
    webDeleteAccountTitle: 'Close account',
    webDeleteAccountSubtitle: 'Permanently delete your account and data.',
    webCoachingProfileTitle: 'Coaching profile',
    webCoachingProfileCopy: 'Rebuild your personalized suggestions from your onboarding answers.',
    webRegenerateProfile: 'Regenerate coaching profile',
    webReplayTraining: 'Replay the guided tour',
    webReplayTrainingSubtitle: 'See where everything is, step by step.',

    // Profile Information
    profileInformation: 'Profile Information',
    name: 'Name',
    email: 'Email',
    memberSince: 'Member since',
    accountType: 'Account type',
    notSet: 'Not set',
    unverified: 'Unverified',

    // Subscription Details
    subscriptionDetails: 'Subscription Details',
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    perMonth: '/month',
    nextBillingDate: 'Next billing date',
    cancelAtPeriodEnd: '⚠️ Subscription will cancel at period end',
    pendingPlanChange: 'Plan changes to {{plan}} on {{date}}.',

    // Plan Types
    planIndividual: 'Students',
    planAdvanced: 'Chasing Credentials',
    planProfessional: 'Mentor Coach',
    planUnknown: 'Unknown',
    planIndividualDescription: 'For students reviewing a few real coaching sessions each month.',
    planAdvancedDescription: 'For credential candidates who need level selection, marker tables, and ICF-ready exports.',
    planProfessionalDescription: 'For mentor coaches who review more sessions and need custom analysis workflows.',
    priceUnavailable: 'Price unavailable',

    // Usage & Credits (unified section)
    planAndUsage: 'Plan & Usage',
    usageStatistics: 'Usage Statistics',
    dailyChats: 'Daily Chats',
    monthlyChats: 'Monthly Chats',
    monthlyTranscripts: 'Monthly Transcripts',
    documents: 'Documents',
    storage: 'Storage (MB)',
    dailyChatsShort: 'Daily Chats',
    monthlyTranscriptsShort: 'Monthly Transcripts',
    extraCreditsShort: 'Extra Credits',
    resetsDaily: 'Resets daily',
    resetsMonthly: 'Resets monthly',
    neverExpires: 'Never expires',
    usedOf: '{{used}} of {{limit}}',

    // Account Management
    accountManagement: 'Account Management',
    editProfile: 'Edit Profile',
    changeLanguage: 'Change Language',
    changePlan: 'Change Plan',
    cancelSubscription: 'Cancel Subscription',
    manageSubscription: 'Manage Subscription',
    exportData: 'Export My Data',
    deleteAccount: 'Delete Account',

    // Edit Profile Modal
    editProfileTitle: 'Edit Profile',
    fullName: 'Full Name',
    save: 'Save',
    cancel: 'Cancel',
    profileUpdated: 'Profile updated successfully',
    enterFullName: 'Please enter your full name',
    updateFailed: 'Failed to update profile',

    // Change Plan Modal
    changePlanTitle: 'Update Subscription',
    changePlanDescription: 'Pick a tier and billing cycle. We’ll handle proration automatically.',
    planTierLabel: 'Plan tier',
    billingCycleLabel: 'Billing cycle',
    billingCycleMonthly: 'Monthly',
    billingCycleYearly: 'Yearly',
    updatePlan: 'Update plan',
    planChangedSuccess: 'Subscription updated successfully.',
    planChangeFailed: 'Unable to update subscription at this time.',
    viewPlanDetails: 'View full plan comparison',
    planDetailsLinkFailed: 'Could not open plan details. Please try again.',
    viewInvoice: 'View receipt',
    loadingPricing: 'Loading latest pricing…',
    // Plan change confirm copy (BIL-L05): from Stripe's preview of the change.
    planChangeSummaryTitle: 'What changes',
    planChangePreviewLoading: 'Calculating what switching from {{current}} to {{target}} costs today…',
    planChangeFallbackTitle: 'Amount shown on your invoice',
    planChangeFallbackMessage: 'We could not load today’s amount. An upgrade is charged now for the rest of your billing period, and the exact amount is shown on your invoice. A downgrade takes effect at the end of your billing period, with no charge today.',
    planChangeFallbackDueToday: 'Shown on invoice',
    planChangeFallbackPauseNotice: 'If you have a pause scheduled, changing your plan cancels it.',
    planChangeUpgradeTitle: 'Charged today',
    planChangeUpgradeMessage: 'You switch from {{current}} to {{target}} now. {{amount}} is charged today for the rest of your current billing period.',
    planChangeUpgradeNewPeriodMessage: 'You switch from {{current}} to {{target}} now and a new billing period starts today. {{amount}} is charged today, after a credit for the unused time on your current plan.',
    planChangeNoChargeTitle: 'No charge today',
    planChangeDowngradeMessage: 'No charge today. Your plan changes to {{target}} on {{date}}; you keep {{current}} until then.',
    planChangeTrialMessage: 'No charge today. Your trial continues, and {{target}} starts when it ends on {{date}} at {{price}}.',
    planChangeSamePlanTitle: 'Current plan',
    planChangeSamePlanMessage: '{{current}} is your current plan. Pick another plan or billing cycle to change it.',
    planChangeKeepPlanMessage: 'No charge today. You keep {{current}}, and the scheduled change to {{target}} is canceled.',
    planChangeKeepRenewingMessage: 'No charge today. You keep {{current}}, and your subscription renews on {{date}} instead of ending.',
    planChangeRenewalNote: 'Your plan then renews on {{date}} at {{price}}.',
    planChangeDueTodayLabel: 'Due today',
    planChangePauseNotice: 'Changing your plan cancels the pause scheduled for the end of this billing period.',
    planChangePaymentPendingTitle: 'Payment needed',
    planChangePaymentPendingMessage: 'The payment for this plan change did not go through, so your plan has not changed. Pay the invoice or update your card to complete the change.',
    planChangePayInvoice: 'Pay invoice',
    currentPlanLabel: 'Current plan',
    newPlanLabel: 'New plan',
    planBillingNote: 'Future invoices will be {{price}} each {{interval}}.',
    planAcknowledgeUpgradeLabel: 'I understand that {{amount}} will be charged to my payment method today.',
    planAcknowledgeDowngradeLabel: 'I understand that my plan changes at the end of the current billing period, with no charge today.',
    planAcknowledgeKeepPlanLabel: 'I understand that my current plan continues, with no charge today.',
    planAcknowledgeFallbackLabel: 'I understand that an upgrade is charged today and the exact amount is shown on my invoice.',
    planAcknowledgeTrialLabel: 'I understand that nothing is charged today and the new plan is billed when my trial ends.',
    planInvoiceLinkFailed: 'Could not open the invoice link. Please check your connection.',

    // Language Selection Modal
    selectLanguage: 'Select Language',
    selectLanguageDescription: 'Choose your preferred language for the app',
    languageChanged: 'Language changed successfully',
    update: 'Update',

    // Cancel subscription
    cancelSubscriptionMessage: 'Cancel without deleting your account. You keep access until the end of the current billing period and are not charged again.',
    cancelAtPeriodEndButton: 'End of current period',
    cancelOptionScheduledDescription: 'Keep access until the current billing period ends.',
    cancelSuccessScheduled: 'Your subscription will stay active until the end of the current billing cycle.',
    pausedFromUntil: 'Paused from {{from}} until {{until}}',
    cancelPausedMessage: 'Your subscription is paused. Cancelling ends it now and you are not charged again.',
    cancelPausedButton: 'End now',
    cancelPausedDescription: 'The paused subscription ends today. No charge.',
    cancelPausedSuccess: 'Your subscription has ended. You will not be charged again.',
    cancelFailed: 'Failed to cancel subscription.',
    cancelReasonPrompt: 'What is the main reason you are cancelling?',
    cancelReasonNotePlaceholder: 'Tell us more (optional)',
    cancelReason: {
      too_expensive: 'Too expensive',
      done_with_credential: 'I completed my credential goal',
      not_useful: 'Not useful enough for me',
      technical: 'Technical issues',
      not_using: 'Not using it enough',
      missing_features: 'Missing features I need',
      switching: 'Switching to another tool',
      temporary_break: 'Just need a temporary break',
      other: 'Other',
      eu_withdrawal: 'EU withdrawal (refund due)',
    },
    withdrawal: {
      panelTitle: 'Right of withdrawal',
      action: 'Withdraw from contract here',
      availableUntil: 'You can withdraw from your subscription contract until {{date}}.',
      confirmTitle: 'Withdraw from your subscription contract?',
      pointEndsNow: 'Your subscription ends now and paid features stop right away.',
      pointRefund: 'We refund your payment to your card within 14 days.',
      pointTrialNoCharge: 'You are in your trial, so you have not been charged and will not be.',
      pointCredits: 'Credit packs you bought stay in your account.',
      pointEmail: 'We email you a confirmation that we received your withdrawal.',
      keep: 'Keep my subscription',
      confirm: 'Confirm withdrawal',
      success: 'Withdrawal received. We sent a confirmation to your email.',
      notAvailable: 'The withdrawal period for this subscription has ended. Contact support@mentorcoaching.ai if you need help.',
      failed: 'We could not process your withdrawal. Please try again or contact support@mentorcoaching.ai.',
    },
    retentionOfferTitle: 'Stay and get 20% off',
    retentionOfferDescription: 'Keep your subscription and save 20% on your next 3 months.',
    retentionOfferAccept: 'Accept 20% off',
    retentionOfferDecline: 'No thanks, continue cancelling',
    retentionOfferSuccess: 'Your 20% discount has been applied for the next 3 months.',
    retentionOfferFailed: 'We could not apply the offer. Please try again.',
    retentionOffers: {
      firstMonthDiscount: {
        title: 'How about 50% off your first month?',
        description: 'Stay on and get half off your next invoice — no strings attached.',
        accept: 'Get 50% off',
        success: 'Your 50% discount has been applied to your next invoice.',
      },
      pause: {
        title: 'Take a break instead?',
        description: "Pause for one month from the end of your current billing period. You keep full access until then. While paused you are not charged and paid features are off; your data stays. Billing restarts automatically after the month.",
        accept: 'Pause for 1 month',
        success: 'Your subscription will pause at the end of the current billing period and restart automatically one month later.',
      },
      stay20: {
        title: 'Stay and get 20% off',
        description: 'Keep your subscription and save 20% on your next 3 months.',
        accept: 'Accept 20% off',
        success: 'Your 20% discount has been applied for the next 3 months.',
      },
      stay20Pack: {
        title: 'Stay and get 20% off',
        description: 'Keep your subscription and save 20% on your next renewal.',
        accept: 'Accept 20% off',
        success: 'Your 20% discount has been applied to your next renewal.',
      },
    },
    noActiveSubscription: 'No active subscription was found for this account.',
    billingActionTemporarilyUnavailable: 'Billing is temporarily unavailable. Please try again in a minute.',

    // Resume subscription
    resumeSubscription: 'Resume Subscription',
    resubscribe: 'Resubscribe',
    resumeSuccess: 'Your subscription has been resumed successfully.',
    resumeFailed: 'Failed to resume subscription.',
    cannotResumeSubscriptionStatus: 'This subscription cannot be resumed while it is {{status}}.',
    subscriptionNotScheduledForCancellation: 'This subscription is not scheduled for cancellation.',

    // Delete Account Modal
    deleteAccountTitle: 'Delete Account',
    deleteWarning: 'This action is permanent and cannot be undone. All your data will be deleted.',
    enterPassword: 'Enter your password',
    typeDeleteConfirm: 'Type DELETE to confirm',
    deletionReason: 'Reason for deletion (optional)',
    finalConfirmation: 'Final Confirmation',
    finalConfirmationMessage: 'This action is permanent and cannot be undone. All your data will be deleted.',
    accountDeleted: 'Account Deleted',
    accountDeletedMessage: 'Your account has been successfully deleted.',
    deleteConfirmError: 'Please type DELETE to confirm',
    deleteFailed: 'Failed to delete account',
    deleteAccountFailedNotDeleted: 'We couldn\'t delete your account, and your data was not deleted. Please try again or contact support.',
    deleteAccountOutcomeUnknown: 'We couldn\'t confirm whether your account was deleted. Please reload the page; if you can still sign in, try again or contact support.',
    deleteAccountBillingFailed: 'We couldn\'t cancel your subscription, so your account was not deleted. Please try again or contact support.',
    deleteAccountRateLimited: 'Too many deletion attempts. Please wait an hour and try again.',

    // Export Data
    dataExportDownloaded: 'Your data was downloaded as {{filename}}.',
    exportFailed: 'Failed to export data',

    // Billing Portal
    redirectToBilling: 'Redirect',
    pleaseVisit: 'Please visit',
    billingPortalFailed: 'Failed to access billing portal',

    // Coaching Profile
    coachingProfile: 'Coaching Profile',
    coachingProfileRegenDesc: 'Rebuild your personalized coaching suggestions from your intake answers. Existing suggestions will be replaced.',
    regenerateCoachingProfile: 'Regenerate Coaching Profile',
    regenerating: 'Regenerating…',
    regenSuccessTitle: 'Profile updated',
    regenSuccessMessage: 'Your personalized suggestions have been refreshed.',
    regenFailedTitle: 'Regenerate failed',
    regenFailedMessage: 'Could not regenerate. Please try again.',

    // Legal & Privacy
    legalAndPrivacy: 'Legal & Privacy',
    dataPrivacyNotice: 'Your data is yours. We do not use your information or documents to train our AI models or improve our platform.',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    legalLinkFailed: 'Could not open the link. Please try again.',

    // Credits
    credits: 'Credits',
    lowCredits: 'Low',
    availableCredits: 'Available Credits',
    subscriptionCredits: 'Subscription',
    subscriptionCreditsRemaining: 'Monthly analysis credits from your plan',
    purchasedCredits: 'Purchased',
    creditsResetOn: 'Resets on',
    remaining: '{{remaining}} of {{total}} remaining',
    buyMoreCredits: 'Buy More Credits',
    buyTranscriptionMinutes: 'Buy Transcription Minutes',
    purchasedCreditsNeverExpire: 'Purchased credits never expire',
  },

  // ICF Progress
  icfProgress: {
    recentAnalyses: 'Recent Analyses',
    title: 'Progress Dashboard',
    dashboardTitle: 'Progress Dashboard',
    loading: 'Loading progress...',
    failedToLoad: 'Failed to load dashboard',
    retry: 'Retry',
    lockedTitle: 'Unlock ICF progress tracking',
    lockedCopy: 'Upgrade to Advanced or Professional to track readiness level, strengths, and development focus.',
    lockedCta: 'Upgrade plan',
    lockedSchoolTitle: 'ICF progress is not enabled on this school plan',
    lockedSchoolCopy: 'This feature stays hidden when it is not included in your school plan. You can still use session analysis and chat.',
    lockedSchoolCta: 'Manage school plan',
    teaserEyebrow: 'Your tracked development',
    teaserTitle: 'A real preview of your ICF progress',
    teaserTrackedSessions: 'Tracked sessions',
    teaserInsightFallbackTitle: 'Strongest competency insight',
    teaserOneOfEight: 'This is 1 of 8 competency insights - unlock your full ICF development picture.',
    teaserPracticeUnlocked: 'First practice focus unlocked',
    teaserPracticeLocked: '{{count}} more practice focus is locked in your complete plan.',
    teaserLockedSectionsTitle: 'Your full development picture is ready',
    teaserLockedSectionsCopy: 'Unlock all competency lanes, trends, the complete practice plan, and your evidence portfolio.',
    teaserUnlockCta: 'Unlock full ICF progress',
    targetDate: 'Target date',
    targetDatePlaceholder: 'YYYY-MM-DD',
    saveTargetDate: 'Save date',
    clearTargetDate: 'Clear',
    targetDateInvalid: 'Enter a valid target date in YYYY-MM-DD format.',
    targetDateNeedsLevel: 'Choose an ACC, PCC, or MCC target before saving a date.',
    targetCountdown: '{{count}} days until your {{target}} target',
    targetCountdownOverdue: 'Your {{target}} target date was {{count}} days ago',
    exportPortfolio: 'Export development portfolio (PDF)',
    exportPortfolioFailed: 'Your development portfolio could not be exported. Please try again.',
    levelUpTitle: 'Your readiness level moved up',
    levelUpCopy: 'Your recent evidence moved from {{previous}} to {{next}}.',
    sparklineTitle: 'Competency history',
    sparklineSubtitle: 'Recent analyzed sessions with ACC and PCC reference bands.',
    sparklineEmpty: 'More analyzed sessions will build this line.',
    sparklineAccessibility: '{{competency}} history with ACC and PCC reference bands',
    backToProgress: 'Back to Progress',
    practiceExam: {
      eyebrow: 'Credential preparation',
      entryTitle: 'ICF practice exam',
      entryBody: 'Test your judgment with a focused 10-question set across the core competencies.',
      entryCta: 'Start practice exam',
      title: 'ICF practice exam',
      subtitle: 'Choose the response that best reflects ICF coaching practice. You will get explanations and a competency breakdown at the end.',
      loading: 'Loading your question set…',
      loadError: 'The practice questions could not be loaded. Please try again.',
      submitError: 'Your answers could not be scored. Please try again.',
      retry: 'Try again',
      progress: 'Question {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
      finish: 'See results',
      submitting: 'Scoring…',
      resultsTitle: 'Practice complete',
      resultSummary: '{{correct}} of {{total}} correct',
      restart: 'Try again',
      competencyBreakdown: 'Competency breakdown',
      reviewTitle: 'Answer review',
      correctAnswer: 'Best answer',
      unknownCompetency: 'Core competency',
      questions: {
        q1: {
          prompt: 'A client asks the coach to decide which career offer to accept. Which response best demonstrates the coach role?',
          options: { a: 'Recommend the offer with the highest salary', b: 'Compare the offers and choose for the client', c: 'Explore what matters to the client and support their own choice', d: 'Refer every career decision to a recruiter' },
          explanation: 'Ethical coaching stays within the coach role and supports the client to make their own choices instead of becoming prescriptive.',
        },
        q2: {
          prompt: 'A client reveals a need outside the coach’s competence that is better suited to therapy. What should the coach do?',
          options: { a: 'Continue because the relationship is established', b: 'Diagnose the client before deciding', c: 'Discuss the boundary and refer the client to appropriate professional support', d: 'Promise that coaching can resolve the issue' },
          explanation: 'Coaches recognize the limits of their competence, explain the boundary, and refer when another professional service is more appropriate.',
        },
        q3: {
          prompt: 'Which practice best reflects an embodied coaching mindset?',
          options: { a: 'Treat the coach’s first interpretation as fact', b: 'Continue learning, reflecting, and noticing personal bias', c: 'Avoid feedback to protect confidence', d: 'Prepare the same advice for every client' },
          explanation: 'A coaching mindset is reflective and curious, with ongoing learning and awareness of the coach’s own biases and preferences.',
        },
        q4: {
          prompt: 'At the start of a session, what should the coach and client establish together?',
          options: { a: 'The coach’s preferred topic', b: 'A desired outcome and how the client will know the session was useful', c: 'A guaranteed action plan', d: 'A diagnosis of the client’s problem' },
          explanation: 'The coach partners with the client on the session outcome, its meaning, and measures of success.',
        },
        q5: {
          prompt: 'A client disagrees with an observation the coach offered. What should the coach do?',
          options: { a: 'Defend the observation', b: 'Invite the response and accept the client’s view', c: 'Repeat the observation more forcefully', d: 'Change the subject without acknowledgment' },
          explanation: 'Trust and safety grow when the coach invites the client’s response and accepts it as part of genuine partnership.',
        },
        q6: {
          prompt: 'After asking a question, the coach notices a long silence. What best demonstrates presence?',
          options: { a: 'Ask a second question immediately', b: 'Fill the silence with an example', c: 'Remain attentive and allow the client space to think or feel', d: 'Assume the client did not understand' },
          explanation: 'Maintaining presence includes comfort with silence so the client has room to think or feel.',
        },
        q7: {
          prompt: 'Which response is the best example of active listening?',
          options: { a: 'Prepare the next question while the client speaks', b: 'Briefly reflect the client’s words, emotion, and a noticed energy shift', c: 'Summarize only the chronology', d: 'Interrupt to correct an assumption' },
          explanation: 'Active listening attends to words, emotions, energy, and meaning, then reflects succinctly to support clarity.',
        },
        q8: {
          prompt: 'A client repeatedly uses the phrase “I am trapped.” What is the most listening-centered response?',
          options: { a: 'Replace it with more positive language', b: 'Explore what “trapped” means in the client’s experience', c: 'Tell the client the phrase is limiting', d: 'Ignore the wording and ask about deadlines' },
          explanation: 'Listening-centered coaching explores the client’s specific language instead of substituting the coach’s interpretation.',
        },
        q9: {
          prompt: 'Which question is most likely to evoke awareness?',
          options: { a: 'Why have you not fixed this yet?', b: 'What belief is shaping how you see this choice?', c: 'Wouldn’t the safer option be better?', d: 'Can I tell you what worked for me?' },
          explanation: 'Questions about beliefs and perspective can open new awareness without leading the client toward the coach’s answer.',
        },
        q10: {
          prompt: 'After the client names a new insight, what best facilitates growth?',
          options: { a: 'Assign the same homework used with other clients', b: 'Partner on how the learning will be used and let the client design actions and accountability', c: 'Move to a new topic without integrating it', d: 'Choose the fastest action for the client' },
          explanation: 'Growth is supported by integrating learning and partnering on client-designed actions, support, barriers, and accountability.',
        },
      },
    },

    // Session Transcripts
    sessionTranscripts: 'Session Transcripts',
    noAnalyzedSessions: 'No analyzed sessions yet',
    session: 'Session',
    webTitle: 'Progress',
    webSubtitle: 'Track your ICF development and the patterns from your latest analyses.',
    webUploadAnalysis: 'Upload new analysis',
    webWaitingForData: 'Waiting for data',
    webNoDataSummary: 'Upload at least two analyzed sessions to see your ICF readiness trend and priority growth areas here.',
    webEvidenceFallback: 'Add a few more analyses so this area can become clearer.',
    webLevelPanelTitle: 'ICF competency level',
    webLevelNearPcc: 'PCC preparation band',
    webTarget: 'Target',
    webViewCompetencies: 'View competencies',
    webSessionsAnalyzed: 'Analyzed sessions',
    webConsistency: 'Consistency',
    webMomentum: 'Momentum',
    webDetails: 'View details',
    webRecentAnalyses: 'Recent analyses',
    webRecentAnalysesSubtitle: 'Results update from session evidence.',
    webNoAnalysesYet: 'No analyses yet',
    webNoAnalysesYetBody: 'This table fills automatically after you upload your first session.',
    webViewAnalysis: 'View analysis',
    webNextFocus: 'Next focus',
    webNextFocusSubtitle: 'One or two behaviors are enough for the next session.',
    webCollectMoreEvidence: 'Add a few more analyses',
    webCollectMoreEvidenceBody: 'Clear focus suggestions will appear here after the first few analyses.',
    webPracticeTitleFallback: 'Next session focus',
    webPracticeFallback: 'Pick one behavior and practice it deliberately in the next session.',
    targetNotSet: 'Not set',
    goalUpdateFailed: 'Could not update target level',
    goalSummaryFallback: 'Set a credential target and upload more analyzed sessions to build your path.',
    trendsLockedShort: '{{count}} more',
    trendsSparseShort: 'Sparse',
    sinceLastSession: 'Since last session',
    checkinMet: 'Met',
    checkinPartial: 'Partial',
    checkinMissed: 'Still active',
    checkinNotObserved: 'Not observed',
    checkinFallback: 'The latest session needs more direct evidence to grade this practice item.',
    chartFoundation: 'Foundation',
    chartListening: 'Listening',
    chartAwareness: 'Awareness',
    chartGrowth: 'Growth',
    progressLabel: 'Progress',
    remainingLabel: 'Remaining',
    scoreLabel: 'Score',
    totalProgress: 'Overall progress',
    lastAnalysis: 'Last analysis',
    noAnalysisYet: 'No analysis yet',
    analyzedCount: 'Analyzed',
    trackingActive: 'Tracking active',
    trackingPaused: 'Tracking paused',
    competencyDistribution: 'Competency distribution',

    // Growth & Progress Metrics
    growthRate: 'Growth Rate',
    consistency: 'Consistency',
    momentum: 'Momentum',
    currentLevel: 'Current Level',
    noTimeline: 'No timeline data yet',

    // Momentum Directions
    momentumUp: 'Improving',
    momentumDown: 'Declining',
    momentumFlat: 'Stable',
    noMomentum: 'N/A',

    // Consistency
    consistencyScore: '{{percentage}}% consistent',
    noData: 'No data',

    // ICF Competency
    icfCompetencyProgress: 'ICF Competency Progress',
    current: 'Current',
    viewCompetencyDetail: 'View competency details',
    competencyInsights: 'Competency Momentum & Consistency',
    readinessTitle: 'ICF Readiness & Development',
    estimatedLevel: 'Estimated Level',
    targetLevel: 'Target Level',
    confidence: 'Confidence',
    confidenceLow: 'Low',
    confidenceMedium: 'Medium',
    confidenceHigh: 'High',
    readinessStatusTargetSupported: 'Target supported',
    readinessStatusNearTarget: 'Near target',
    readinessStatusDeveloping: 'Developing',
    readinessStatusNeedsEvidence: 'Needs evidence',
    readinessStatusNoData: 'No data',
    nextPracticeTitle: 'Next Recording Practice',
    successSignal: 'Success signal',
    blockersTitle: 'Target-Level Blockers',
    patternsTitle: 'Recurring Development Patterns',
    noCurrentBlockers: 'No repeated target-level blocker in the current evidence window.',
    noRecurringPatterns: 'No recurring development pattern yet. Upload more analyzed sessions to build this view.',
    seenInSessions: 'Seen in sessions',
    laneStableStrength: 'Stable strength',
    laneEmergingStrength: 'Emerging',
    laneInconsistent: 'Inconsistent',
    laneTargetBlocker: 'Below target level',
    laneInsufficientEvidence: 'Insufficient evidence',
    laneNeedsReview: 'Needs review',
    laneDemonstrated: 'Consistently demonstrated',
    laneEthicsConcern: 'Ethics concern',
    laneEthicsConcernBody: 'An ethics concern was flagged in a recent session. Ethical practice is not leveled; review the flagged moment with your mentor coach.',

    // Metrics
    overallScore: 'Overall Score',
    sessionsLabel: 'Sessions',

    // ICF Levels
    levelMCC: 'MCC level',
    levelPCC: 'PCC level',
    levelACC: 'ACC level',
    levelBelowACC: 'Below ACC',
    levelUpperPccMccAdjacent: 'Upper PCC / approaching MCC profile',

    // Competency Labels
    compEthics: 'Demonstrates Ethical Practice',
    compMindset: 'Embodies a Coaching Mindset',
    compAgreements: 'Establishes and Maintains Agreements',
    compTrust: 'Cultivates Trust and Safety',
    compPresence: 'Maintains Presence',
    compListening: 'Listens Actively',
    compAwareness: 'Evokes Awareness',
    compGrowth: 'Facilitates Client Growth',

    // Competency Full Names
    compEthicsFull: 'Demonstrates Ethical Practice',
    compMindsetFull: 'Embodies a Coaching Mindset',
    compAgreementsFull: 'Establishes and Maintains Agreements',
    compTrustFull: 'Cultivates Trust and Safety',
    compPresenceFull: 'Maintains Presence',
    compListeningFull: 'Listens Actively',
    compAwarenessFull: 'Evokes Awareness',
    compGrowthFull: 'Facilitates Client Growth',

    // Description
    levelDescription: 'Your current level based on competency distribution and recent analyses.',

    // Competency Breakdown Screen
    competencyBreakdown: 'Competency Breakdown',
    level: 'Level',
    competencyScores: 'Competency Scores',
    loadError: 'Failed to load progress data',

    // Detailed Competency Names
    competencies: {
      ethicalPractice: 'Demonstrates Ethical Practice',
      coachingMindset: 'Embodies a Coaching Mindset',
      agreements: 'Establishes and Maintains Agreements',
      trustSafety: 'Cultivates Trust and Safety',
      presence: 'Maintains Presence',
      activeListening: 'Listens Actively',
      awareness: 'Evokes Awareness',
      clientGrowth: 'Facilitates Client Growth',
    },
    detail: {
      title: 'Competency detail',
      invalidCompetency: 'This competency could not be found.',
      loadError: 'Competency details could not be loaded. Please try again.',
      levelHistory: 'Level history',
      levelHistoryDescription: 'Evidence-based level signals from your analyzed sessions.',
      historyPoint: '{{level}} signal in {{session}}',
      evidenceTitle: 'Evidence from your sessions',
      emptyEvidence: 'No direct evidence quotes are available for this competency yet.',
      practiceNext: 'Practice next',
      emptyPractice: 'A focused practice suggestion will appear as session evidence develops.',
      levelCriteria: 'What each level requires',
      noCriteria: 'No additional criteria are available for this competency.',
      lockedTrend: 'Analyze more sessions to unlock an evidence-based trend.',
      levelHistoryAccessibility: 'Chronological competency level history from below ACC through MCC',
      levelBelowAccShort: '<ACC',
      levelAccShort: 'ACC',
      levelPccShort: 'PCC',
      levelMccShort: 'MCC',
      strength: 'Strength',
      development: 'Development',
      sessionFallback: 'Analyzed session',
      successSignal: 'Success signal',
      showMoreEvidence: 'Show {{count}} more',
      showLessEvidence: 'Show less',
    },
    sessions: {
      title: 'Sessions in your progress',
      subtitle: 'Choose which analyzed sessions count toward your current evidence window.',
      included: 'Included',
      excluded: 'Not included',
      notTracked: 'Not tracked',
      notTrackedHint: 'This session was analyzed without ICF progress tracking, so it cannot be added to your evidence window.',
      processing: 'Processing',
      notAnalyzed: 'Not analyzed yet',
      sessionFallback: 'Session {{id}}',
      toggleLabel: 'Include {{title}} in ICF progress',
      empty: 'Your analyzed sessions will appear here.',
      loadError: 'Sessions could not be loaded.',
      toggleError: 'This session could not be updated. Please try again.',
    },
    sessionList: {
      title: 'Session analyses',
      countLabel: '{{count}} session(s)',
      lastAnalyzed: 'Last analyzed: {{date}}',
      include: 'Include',
      qualityScore: 'Quality score',
      messageCount: 'Messages',
      analysisDuration: 'Analysis time',
      viewDetails: 'View details',
      emptyTitle: 'No sessions yet',
      emptyDescription: 'Analyzed coaching sessions will appear here.',
    },
    dataManagement: {
      title: 'Data management',
      subtitle: 'Retention period and privacy settings for your progress data.',
      retentionLabel: 'Data retention (days)',
      retentionInvalid: 'Data retention must be between 1 and 2555 days.',
      saveSuccess: 'Settings updated.',
      saveError: 'Settings could not be updated.',
      loadError: 'Data could not be loaded.',
      purgeTitle: 'Delete data',
      purgeSubtitle: 'Permanently delete all of your progress data.',
      purgeAction: 'Delete all data',
      purgeConfirmTitle: 'Permanent deletion',
      purgeConfirmBody: 'All of your progress data will be permanently deleted. Are you sure?',
      purgeConfirmAction: 'Delete',
      purgeSuccess: 'All of your progress data was deleted.',
      purgeError: 'Deletion failed.',
    },
    plan: {
      title: 'What to work on next',
      subtitle: 'Your plan refreshes from the evidence in each analyzed session.',
      version: 'Plan v{{version}}',
      successSignal: 'Success signal',
      updated: 'Updated {{date}}',
      empty: 'Your next practice items will appear as session evidence develops.',
      lockedTeaser: 'Unlock the complete plan to see the second practice item and all focus areas.',
      checkinSubtitle: 'How the previous plan showed up in your latest analyzed session.',
    },
    crfReadiness: {
      title: 'ICF {{level}} readiness (Competency Review Form rule)',
      subtitleShort: 'You are {{count}} statements short for the {{level}} Competency Review Form.',
      subtitleComplete: 'Every {{level}} competency gate is met across your analyzed sessions.',
      verdictDemonstrated: 'Proficiency demonstrated',
      verdictNotYet: 'Not yet demonstrated',
      sessionsConsidered: '{{count}} sessions assessed against the {{level}} instrument.',
      gateCount: '{{demonstrated}} / {{required}} demonstrated',
      gateTotal: 'of {{total}} statements',
      gateMet: 'gate met',
      gateShort: '{{count}} short',
      chipHint: 'Tap a statement id to read the official wording.',
      openDetail: 'Open competency detail',
      notAssessed: '{{count}} sessions not assessed at {{level}}.',
      reanalyzeCta: 'Re-analyze them at {{level}}',
      reanalyzeConfirm: 'Re-analyze {{count}} sessions against the {{level}} instrument? Each one runs a fresh analysis.',
      reanalyzeConfirmCta: 'Start re-analysis',
      reanalyzeCancel: 'Cancel',
      reanalyzeStarted: 'Re-analysis started for {{count}} sessions. Results appear as each one finishes.',
      reanalyzePartial: 'Re-analysis started for {{started}} sessions; {{failed}} could not be started.',
      reanalyzeError: 'We could not start the re-analysis. Please try again.',
      footnote: 'A statement counts as demonstrated if any single analyzed session met it (later sessions never remove it), N/A never counts, and the denominator is the fixed ICF {{level}} form total (rev. {{revision}}).',
      detailTitle: 'ICF {{level}} form statements',
      demonstratedIn: 'Demonstrated in: Session {{sessions}}',
      noOpportunity: 'No opportunity observed yet.',
      planSubtitle: 'You are {{count}} statements short for the {{level}} Competency Review Form.',
      gapSuccessSignal: 'Closes {{count}} statements: {{statements}}',
    },
  },

  // Platform Admin
  platformAdmin: {
    cancellationInsightsTitle: 'Cancellation insights',
    cancellationInsightsDescription: 'Cancellation reasons recorded during the last 90 days.',
    cancellationInsightsTotal: 'Cancellations in the last 90 days',
    redoOnboardingTitle: 'Redo onboarding',
    redoOnboardingDescription: 'Resets your own onboarding, intake answers and development plan so the app treats you as a brand-new user. Only affects your account — no other user is touched.',
    redoOnboardingAction: 'Reset my onboarding',
    redoOnboardingConfirm: 'This clears your intake answers and generated development plan, then restarts the onboarding tour. This cannot be undone. Continue?',
    redoOnboardingSuccess: 'Onboarding reset. Starting the tour…',
    redoOnboardingError: 'Unable to reset onboarding.',
    lifecycleTitle: 'Lifecycle Emails (Resend)',
    lifecycleDescription: 'Control lifecycle automation delivery and inspect the durable outbox.',
    lifecycleSaved: 'Lifecycle email settings saved.',
    lifecycleError: 'Unable to update lifecycle email settings.',
    lifecycleTestQueued: 'Test lifecycle event queued.',
    lifecycleTestRecipient: 'Test recipient email',
    lifecycleSendTest: 'Send test event',
    lifecycleCounts: 'Outbox',
    lifecycleMode: { disabled: 'Disabled', test: 'Test', live: 'Live' },
    lifecycleSaveBeforeTest: 'Save test mode first. A test event is sent with the saved mode.',
    lifecycleLastError: 'Last error',
    lifecycleTestSkipped: {
      lifecycle_disabled: 'Test event not sent: the saved mode is Disabled. Save Test mode first.',
      recipient_ineligible: 'Test event not sent: your admin account can\'t receive lifecycle email. It must be verified and active, subscribed to product email, and not bounced or marked as spam.',
      synthetic_account: 'Test event not sent: this is an automated test account. Use your own admin account.',
      unknown: 'Test event not sent.',
    },
    subtitle: 'Schools, users, billing, and platform-wide settings.',
    title: 'Platform Administration',
    loading: 'Loading platform data...',
    failedToLoad: 'Failed to load platform information',

    // Tabs
    overview: 'Overview',
    schools: 'Schools',
    usersTab: 'Users',
    settings: 'Settings',

    // Stats
    platformOverview: 'Platform Overview',
    totalSchools: 'Total Schools',
    activeSchools: 'Active Schools',
    b2b2cStudents: 'B2B2C Students',
    b2cUsers: 'B2C Users',
    activeSubscriptions: 'Active Subscriptions',
    active: 'active',

    // Quick Actions
    quickActions: 'Quick Actions',
    createNewSchool: 'Create New School',
    addSchool: 'Add a new school to the platform',
    manageB2CDocuments: 'Manage B2C Documents',
    uploadGeneral: 'Upload and manage general coaching content',
    createTestSchool: 'Create Test School',
    testB2B2C: 'Create test school and admin for B2B2C testing',
    debugAuth: 'Debug Auth',
    testAuth: 'Test authentication and super admin status',
    testSentry: 'Test Sentry',
    testErrorMonitoring: 'Send test errors to Sentry error monitoring',

    // Schools List
    schoolsList: 'Schools',
    create: 'Create',
    noSchools: 'No schools created yet',
    createFirstSchool: 'Create your first school to start managing the platform',
    createSchool: 'Create School',
    students: 'students',
    billableSeats: 'student + mentor seats',
    admins: 'Admins',
    noAdmins: 'No admins yet',
    pendingInvitation: 'Pending',
    resend: 'Resend',
    addAdmin: 'Add Admin',
    viewStudents: 'Students',
    schoolSettings: 'Settings',
    schoolActionsTitle: 'School settings',
    schoolActionsSubtitle: 'What would you like to manage for {{name}}?',
    schoolActionEditPlanDesc: 'Update pricing, included seats, and add-on packages.',
    schoolActionBillInviteDesc: 'Collect payment and invite the billing admin through Stripe.',
    schoolActionUpdateSeatsDesc: 'Manually adjust the total seat capacity.',
    schoolActionSeatRequestsDesc: 'Review and approve pending seat increase requests.',
    schoolActionSyncStripeDesc: 'Refresh the subscription status from Stripe.',
    schoolActionDeactivateDesc: 'Suspend access without deleting the school.',
    schoolActionActivateDesc: 'Restore access for this school.',
    schoolActionOpenSettings: 'Open detailed settings',
    schoolActionOpenSettingsDesc: 'Jump to the billing dashboard for this school.',
    schoolActionCancel: 'Close',
    focusedSchool: 'Currently selected',
    createdOn: 'Created',

    // Users Tab
    usersRoster: 'User Directory',
    usersSummary: 'Manage B2C members and school-linked accounts.',
    userFilterAll: 'All',
    userFilterB2C: 'B2C',
    userFilterB2B2C: 'School',
    userNameFallback: 'User',
    userJoined: 'Joined',
    userSchool: 'School',
    userSchoolUnknown: 'No school assigned',
    userPackage: 'Package',
    userPackageUnknown: 'Unknown package',
    userStatus: 'Subscription',
    userStatusUnknown: 'Status unavailable',
    userRenewal: 'Renews',
    userRenewalUnknown: 'Renewal date unavailable',
    userSourceSchool: 'Managed by school subscription',
    userSourceUser: 'Managed by personal subscription',
    accountTypeB2C: 'B2C Account',
    accountTypeB2B2C: 'School Account',
    viewSchool: 'Open school',
    resetUsage: 'Reset usage',
    resettingUsage: 'Resetting…',
    resetUsageConfirm: 'Reset usage limits for {{name}}? This clears their chat and analysis counters for the current period.',
    resetUsageSuccess: 'Usage limits reset successfully.',
    resetUsageError: 'Could not reset usage limits. Please try again.',
    resetSchoolUsage: 'Reset school usage',
    resettingSchoolUsage: 'Resetting school usage…',
    resetSchoolUsageConfirm: 'Reset usage for {{name}}? This restores the shared school credit pool usage and clears chat, transcript, and analysis counters for current school members. It does not delete users, invitations, documents, or purchased credits.',
    resetSchoolUsageSuccess: 'School usage reset for {{users}} members. Subscription credits remaining: {{credits}}.',
    resetSchoolUsageError: 'Could not reset school usage. Please try again.',
    schoolActionResetUsageDesc: 'Reset member counters and restore the shared credit pool without deleting school data.',
    deleteUser: 'Delete account',
    deletingUser: 'Deleting…',
    deleteUserConfirm: 'Delete {{email}}? This permanently removes the account, documents, and chat history. This cannot be undone.',
    deleteUserSuccess: 'User account deleted.',
    deleteUserError: 'Unable to delete the account right now. Please try again.',
    noUsers: 'No users found',
    addUsersHint: 'Invite users or connect schools to see them here.',
    manageSchoolsCta: 'Manage schools',

    // Usage statistics
    transcriptsUsage: 'Transcript analyses',
    transcriptionMinutesUsage: 'Transcription min',
    chatMessagesUsage: 'Chat messages',

    // Settings / Billing
    llmSettingsTitle: 'LLM Settings',
    llmSettingsDescription: 'Adjust the primary generation and fast planning models in real time.',
    llmSettingsNote: 'Changes apply to new requests; in-flight tasks finish with their original models.',
    mainModel: 'Primary Model',
    fastModel: 'Fast Model',
    saveLlmSettings: 'Save LLM Settings',
    llmSettingsSaving: 'Saving…',
    llmSettingsSaved: 'LLM settings saved.',
    llmSettingsError: 'Unable to save LLM settings.',
    // Transcript post-processing model settings
    transcriptModelTitle: 'Transcript Model',
    transcriptModelDescription: 'Model for speaker label correction and grammar fixing in voice transcriptions.',
    transcriptModel: 'Transcript Post-Processing Model',
    transcriptModelNote: 'A larger model typically produces better speaker identification and grammar correction results.',
    saveTranscriptSettings: 'Save Transcript Settings',
    transcriptSettingsSaving: 'Saving…',
    transcriptSettingsSaved: 'Transcript model settings saved.',
    transcriptSettingsError: 'Unable to save transcript model settings.',
    // Audio model settings (for audio-aware post-processing)
    audioModelTitle: 'Audio Model (Speaker Verification)',
    audioModelDescription: 'Model for audio-aware speaker verification and correction using Gemini\'s audio understanding.',
    audioModel: 'Audio Understanding Model',
    audioModelNote: 'This model analyzes audio to verify and correct speaker labels. Larger models may produce better results but are slower.',
    saveAudioSettings: 'Save Audio Model',
    audioSettingsSaving: 'Saving…',
    audioSettingsSaved: 'Audio model settings saved.',
    audioSettingsError: 'Unable to save audio model settings.',
    llmProviderGoogle: 'Google Gemini',
    llmProviderOpenAI: 'OpenAI GPT',
    llmProviderGroq: 'Groq',
    llmProviderOpenRouter: 'OpenRouter',
    billingSettingsTitle: 'School Billing & Plans',
    billingSettingsDescription: 'Review and adjust school subscription plans, seat allocations, and Stripe synchronization.',
    claudeGateway: {
      title: 'Claude API gateway',
      description: 'Spend this month on the Anthropic Claude API, the monthly cap, and the switch that sends every workload to its OpenRouter fallback. At 80% of the cap you get a Telegram alert; at 100% every workload runs on OpenRouter until the month rolls over.',
      spent: 'Spent this month',
      cap: 'Monthly cap (USD)',
      capPlaceholder: '100',
      saveCap: 'Save cap',
      forceOpenRouter: 'Send everything to OpenRouter',
      resumeClaude: 'Resume Claude',
      stateActive: 'Claude is serving the workloads assigned to it.',
      stateNoKey: 'No ANTHROPIC_API_KEY is set: every workload runs on its OpenRouter fallback.',
      stateForced: 'Kill switch on: every workload runs on its OpenRouter fallback.',
      stateExhausted: 'Monthly cap reached: every workload runs on its OpenRouter fallback until the month rolls over.',
      byWorkload: 'Spend and prompt-cache hit rate by workload',
      cacheHitRate: 'cache hit',
      calls: 'calls',
      noSpendYet: 'No Claude calls this month yet.',
      saved: 'Claude gateway settings saved.',
      invalidCap: 'Enter the cap in dollars, for example 100 or 150.50.',
      forbidden: 'Only platform super admins can change the Claude gateway.',
      error: 'Could not load or save the Claude gateway settings. Try again.',
    },
    otpLockout: {
      title: 'Clear sign-in lockout',
      description: 'Unlocks email-code sign-in for an address locked after too many wrong codes (from any IP). Works the same whether or not the address has an account.',
      emailPlaceholder: 'user@example.com',
      action: 'Clear sign-in lockout',
      confirmTitle: 'Clear sign-in lockout?',
      confirmMessage: 'All wrong-code lockouts for {{email}} will be removed, so sign-in codes can be entered again right away.',
      success: 'Sign-in lockout cleared for {{email}}.',
      invalidEmail: 'Enter a valid email address.',
      forbidden: 'Only platform super admins can clear sign-in lockouts.',
      error: 'Could not clear the sign-in lockout. Try again.',
    },
    creditAdjust: {
      title: 'Adjust credits',
      description: 'Add or remove analysis credits for one user or one school. Each adjustment is recorded with your note and your account as operator.',
      target_user: 'User',
      target_school: 'School',
      idPlaceholder_user: 'User ID',
      idPlaceholder_school: 'School ID',
      type_purchased: 'Purchased credits',
      type_subscription: 'Subscription credits',
      deltaPlaceholder: 'Change, e.g. 5 or -2',
      notePlaceholder: 'Reason (recorded with the adjustment)',
      action: 'Adjust credits',
      confirmTitle: 'Adjust credits?',
      confirmMessage: '{{delta}} {{creditType}} for {{target}} #{{id}}.',
      success: '{{delta}} {{creditType}} applied to {{target}} #{{id}}. Balance: {{subscription}} subscription, {{purchased}} purchased.',
      invalidTarget: 'Enter a valid user or school ID.',
      invalidDelta: 'Enter a whole number other than 0.',
      rejected: 'The adjustment was rejected. Check the ID and amount.',
      forbidden: 'Only platform super admins can adjust credits.',
      error: 'Could not adjust credits. A balance cannot go below zero or below credits already used.',
    },
    vectorStore: {
      title: 'Knowledge base vector store',
      description: 'Checks that pgvector is installed and counts the stored chunks. Cleanup removes chunks whose document was deleted.',
      checkAction: 'Check health',
      checkError: 'Could not check the vector store.',
      statusOk: 'Healthy',
      statusError: 'Not ready',
      pgvectorVersion: 'pgvector version',
      totalChunks: 'Chunks',
      embeddedChunks: 'Embedded chunks',
      cleanupAction: 'Clean up orphaned chunks',
      cleanupConfirmTitle: 'Clean up orphaned chunks?',
      cleanupConfirmMessage: 'Chunks that belong to deleted documents will be removed permanently.',
      cleanupSuccess: 'Orphaned chunks cleaned up.',
      cleanupError: 'Could not clean up orphaned chunks.',
    },
    workflowRuns: {
      title: 'Workflow runs',
      recentAction: 'Show latest grading runs',
      recentEmpty: 'No grading runs yet.',
      userLabel: 'user {{id}}',
      runIdPlaceholder: 'Workflow run UUID',
      inspectAction: 'Inspect run',
      errorTitle: 'Error',
      statusLabel: 'Status: {{status}}',
      typeLabel: 'Type: {{type}}',
      nodesLabel: 'Nodes ({{count}}):',
    },
    webhookInbox: {
      title: 'Stripe Webhook Inbox',
      description: 'Recent Stripe webhook events (metadata only). Retry stuck or failed events, or queue a subscription reconciliation.',
      filterAttention: 'Needs attention',
      filterAll: 'All recent',
      refresh: 'Refresh',
      loadError: 'Could not load webhook events.',
      emptyAttention: 'No pending or failed webhook events.',
      emptyAll: 'No webhook events recorded yet.',
      meta: 'Attempts: {{attempts}} · Received: {{received}} · Next attempt: {{next}}',
      lastError: 'Last error: {{error}}',
      retryAction: 'Retry',
      retryConfirmTitle: 'Retry this webhook event?',
      retryConfirmMessage: '{{eventType}} ({{eventId}}) will be reset to pending and processed again.',
      retrySuccess: 'Webhook event queued for retry.',
      retryError: 'Could not retry the webhook event.',
      reconcileAction: 'Run reconciliation',
      reconcileConfirmTitle: 'Run Stripe reconciliation?',
      reconcileConfirmMessage: 'Queues a background job that re-syncs local subscriptions with Stripe.',
      reconcileSuccess: 'Stripe reconciliation queued.',
      reconcileError: 'Could not queue Stripe reconciliation.',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      statusFailed: 'Failed',
      statusDeadLetter: 'Dead letter',
      statusSucceeded: 'Succeeded',
      statusIgnored: 'Ignored',
    },
    planSummary: '{{price}} for {{seats}} seats in base plan',
    addonSummary: '{{price}} per additional {{seats}} seats',
    seatCapacitySummary: 'Student + mentor usage: {{current}} / {{max}} seats',
    noBillingConfigured: 'No custom billing plan configured yet.',
    editPlan: 'Edit plan',
    updateSeats: 'Update seats',
    seatRequests: 'Seat requests',
    billAndInvite: 'Bill & invite admin',
    syncStripe: 'Sync Stripe',
    syncStripeSuccess: 'Stripe synchronization complete. Status: {{status}}',
    syncStripeError: 'Unable to synchronize with Stripe right now.',
    subscriptionStatusUpdated: 'Subscription status updated to {{status}}.',
    subscriptionStatusError: 'Unable to update subscription status.',
    deactivateSchoolTitle: 'Deactivate school?',
    deactivateSchoolConfirm: '{{school}} will be set to canceled. Its {{students}} students and {{mentors}} mentors can lose access until the school is reactivated. Stripe is not changed: an existing Stripe subscription keeps billing, and a later Stripe sync can overwrite this status.',
    deactivateSchoolAction: 'Deactivate',
    activateSchoolTitle: 'Activate school?',
    activateSchoolConfirm: '{{school}} will be set to active as a local override. Stripe is not changed. A school without a Stripe subscription is given a credit pool.',
    activateSchoolAction: 'Activate',
    seedOverwriteConfirmTitle: 'Overwrite framework markers?',
    seedOverwriteConfirm: 'Overwrite deletes the stored markers of {{frameworks}} and re-creates them from the bundled framework files. Marker edits made in the database are lost.',
    seedOverwriteAllFrameworks: 'all frameworks',
    seedOverwriteAction: 'Overwrite',
    recoverUsageConfirmTitle: 'Recover usage counters?',
    recoverUsageConfirm: 'This recounts chat requests since the billing period start of every user and school with a Stripe period, and rewrites their monthly usage counters. It is safe to run more than once.',
    recoverUsageAction: 'Recover',
    activateSchool: 'Activate',
    deactivateSchool: 'Deactivate',
    unknownStatus: 'unknown',

    // Legacy placeholders used in other screens
    comingSoon: 'Coming Soon',
    userManagementDesc: 'Comprehensive user management including B2C users, school admins, and platform admins.',
    platformSettingsDesc: 'LLM configuration and platform settings will be available here.',

    // Mentors
    manageMentors: 'Mentors',
    schoolActionManageMentorsDesc: 'Invite, view, or remove school mentors',

    // Access Control
    accessRequired: 'Super Admin Access Required',
    mustBeAdmin: 'You must be a platform administrator to access this section.',
  },

  // Members screen (unified students + mentors + admins view)
  members: {
    title: 'Members',
    summaryLine: '{{total}} total • {{active}} active • {{invited}} invited',
    invite: 'Invite',
    inviteFirst: 'Invite someone',
    invitePickerTitle: 'Invite to your school',
    invitePickerSubtitle: 'Pick the role for this invitation.',
    inviteStudentDesc: 'Coaching trainee who submits sessions for analysis.',
    inviteMentorDesc: 'Experienced coach who reviews and supports students.',
    inviteAdminDesc: 'Co-administrator who manages the school alongside you.',
    inviteAdminTitle: 'Invite an admin',
    inviteAdminSubtitle: 'They\u2019ll get an email invitation and sign in with a one-time code after activation.',
    inviteAdminFailed: 'Could not send admin invitation',
    fullNameLabel: 'Full name',
    fullNamePlaceholder: 'Jane Doe',
    emailLabel: 'Email',
    sendInvite: 'Send invite',
    searchPlaceholder: 'Search by name or email',
    roleFilterAll: 'Everyone ({{count}})',
    roleFilterStudents: 'Students ({{count}})',
    roleFilterMentors: 'Mentors ({{count}})',
    roleFilterAdmins: 'Admins ({{count}})',
    statusFilterAll: 'Any status',
    statusFilterActive: 'Active ({{count}})',
    statusFilterInvited: 'Invited ({{count}})',
    statusFilterInactive: 'Inactive ({{count}})',
    loading: 'Loading members…',
    loadFailed: 'Failed to load members',
    emptyTitle: 'No members yet',
    emptyDesc: 'Invite students, mentors, or admins to get started.',
    emptyFiltered: 'No members match this filter.',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusInvited: 'Invited',
    role: {
      student: 'Student',
      mentor: 'Mentor',
      admin: 'Admin',
    },
    inviteExpires: 'Expires {{date}}',
    lastActivity: 'Last active {{date}}',
    mentorSince: 'Mentor since {{date}}',
    resend: 'Resend',
    resendSuccessTitle: 'Invitation resent',
    resendSuccessMessage: 'A fresh invitation email has been sent.',
    resendFailed: 'Could not resend invitation',
    revoke: 'Revoke',
    revokeTitle: 'Revoke invitation?',
    revokeMessage: 'The invitation link will stop working immediately.',
    revokeFailed: 'Could not revoke invitation',
    noSchoolAccess: 'This screen is available only to school administrators.',
  },

  // Standalone /students tab (school admin)
  students: {
    title: 'Students',
    summaryLine: '{{total}} total • {{active}} active • {{invited}} invited',
    invite: 'Invite',
    inviteFirst: 'Invite a student',
    searchPlaceholder: 'Search by name or email',
    filterAll: 'All ({{count}})',
    filterActive: 'Active ({{count}})',
    filterInvited: 'Invited ({{count}})',
    filterInactive: 'Inactive ({{count}})',
    loading: 'Loading students…',
    loadFailed: 'Failed to load students',
    emptyTitle: 'No students yet',
    emptyDesc: 'Invite your first student to get started.',
    emptyFiltered: 'No students match this filter.',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusInvited: 'Invited',
    transcriptsShort_one: '{{count}} transcript',
    transcriptsShort_other: '{{count}} transcripts',
    transcriptsShort: '{{count}} transcripts',
    chatsShort_one: '{{count}} chat',
    chatsShort_other: '{{count}} chats',
    chatsShort: '{{count}} chats',
    inviteExpires: 'Expires {{date}}',
    noSchoolAccess: 'Student insights are only available for school administrators.',
  },

  // Cohorts (school-owned student groupings)
  cohorts: {
    title: 'Cohorts',
    subtitle: 'Group students into training cohorts. A student can be in one active cohort at a time.',
    create: 'New cohort',
    createFirst: 'Create first cohort',
    loading: 'Loading cohorts…',
    emptyTitle: 'No cohorts yet',
    emptyDesc: 'Create a cohort to group students by program, start date, or mentor.',
    memberCount_one: '{{count}} member',
    memberCount_other: '{{count}} members',
    memberCount: '{{count}} members',
    openEnded: 'open',
    members: 'Members',
    addStudents: 'Add',
    addStudentsTitle: 'Add students to cohort',
    csvInvite: 'CSV invite',
    csvInviteComplete: 'CSV import complete',
    csvInviteSummary: 'Invited {{invited}} new students and added {{added}} existing students.',
    csvInviteSkipped: '{{count}} already in this cohort.',
    csvInviteEmailFailures: '{{count}} invitation emails could not be sent. Use resend from Students.',
    csvInvitePersonalSubscriptionWarning: '{{count}} invitees already have an active personal subscription. Joining your school does not cancel it; they can cancel it in their billing settings.',
    csvInviteFailed: '{{count}} rows failed.',
    csvInviteFailedGeneric: 'Failed to import CSV',
    noStudentsToAdd: 'No students available to add.',
    noMembers: 'No members yet.',
    archive: 'Archive',
    archiveTitle: 'Archive cohort?',
    archiveConfirm: 'Active members will be removed from the cohort.',
    transfer: 'Transfer',
    transferTitle: 'Transfer student?',
    transferPrompt: 'This student is in another active cohort. Transfer them to this one?',
    nameLabel: 'Name',
    namePlaceholder: 'e.g. Level 1 Spring 2026',
    descriptionLabel: 'Description (optional)',
    descriptionPlaceholder: 'Short description…',
  },

  // School Management
  schoolManagement: {
    title: 'School Management',
    loading: 'Loading school data...',
    failedToLoad: 'Failed to load school information',
    exportStudentsSuccess: 'Student data exported successfully.',
    exportStudentsError: 'Failed to export student data. Please try again.',
    resendInvitationError: 'Failed to resend invitation. Please try again.',
    documentLinkSheet: {
      title: 'Link to frameworks',
      description: 'Optionally link this document to one or more frameworks so the AI retrieves it for those frameworks.',
      file: 'File: {{filename}}',
      uploadWithoutLinking: 'Upload without linking',
      uploadLinked: 'Upload and link ({{count}})',
    },
    noSchool: 'No school found',
    loadingAnalytics: 'Loading analytics...',
    dashboardAnalytics: 'Dashboard Analytics',
    cohortsTab: 'Cohorts',
    engagementsTab: 'Mentor engagements',
    engagementRoster: {
      title: 'Mentor engagement roster',
      subtitle: 'Mentor-coaching engagements run by mentors in your school.',
      privacyTitle: 'Why some rows say "Private mentee"',
      privacyBody: 'Mentee names, emails and forms are only visible when the mentor switches on "Share with school" inside the engagement. Until then you see status and counts only.',
      privateMentee: 'Private mentee',
      shared: 'Shared with school',
      notShared: 'Not shared',
      mentor: 'Mentor #{{id}}',
      level: 'Level',
      status: 'Status',
      sessions: '{{count}} sessions',
      finalSofs: '{{count}} final SOFs',
      crfFinal: 'CRF final',
      crfDraft: 'CRF draft',
      crfNone: 'No CRF yet',
      rulesOk: 'ICF rules OK',
      rulesIncomplete: 'ICF rules incomplete',
      open: 'Open read-only',
      filterAll: 'All',
      filterActive: 'Active',
      filterCompleted: 'Completed',
      filterArchived: 'Archived',
      countActive: '{{count}} active',
      countCompleted: '{{count}} completed',
      countCrfFinal: '{{count}} final CRFs',
      countShared: '{{count}} shared',
      empty: 'No mentor engagements yet',
      emptyBody: 'Engagements appear here once mentors in your school create them.',
      emptyFiltered: 'No engagements match this filter.',
      loadError: 'Could not load the engagement roster.',
      forbidden: 'Mentor engagements are not enabled for this school. Ask your account owner about the mentor plan.',
      retry: 'Retry',
    },
    sections: {
      students: 'Students',
      thisMonth: 'This month',
      allTime: 'All time',
    },
    metrics: {
      transcriptsThisMonth: 'Transcripts this month',
      transcriptsTotal: 'Transcripts total',
      active7Days: 'Active / total',
      activePercent: '{{pct}}% active this week',
      avgIcfScore: 'Average ICF score',
      avgIcfSubtext: 'Across completed analyses',
      chatsThisMonth: 'Chat sessions this month',
      chatsTotal: 'Chat sessions total',
      documentsUploaded: 'Documents uploaded',
    },
    recentAnalysesTitle: 'Recent Transcript Analyses',
    recentAnalysesEmpty: 'No transcript analyses yet',
    inactiveStudentsTitle: 'Inactive Students ({{count}})',
    inactiveStudentsDescription: 'These students haven’t had any activity in the last 7 days:',
    inactiveStudentsMore: '+{{count}} more inactive students',
    quickActionsHeading: 'Quick Actions',
    quickActionsButtons: {
      inviteStudent: 'Invite Student',
      uploadDocument: 'Upload Document',
      viewStudents: 'View All Students',
    },
    studentsHeading: 'Students ({{count}})',
    filters: {
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      invited: 'Invited',
    },
    sortBy: 'Sort by:',
    sortOptions: {
      name: 'Name',
      activity: 'Activity',
      transcripts: 'Transcripts',
      score: 'Score',
    },
    loadingStudentAnalytics: 'Loading student analytics...',

    // Tabs
    overview: 'Overview',
    students: 'Students',
    mentorsTab: 'Mentors',
    documents: 'Documents',
    settings: 'Settings',

    // Overview
    schoolOverview: 'School Overview',
    subscription: 'Subscription',
    planType: 'Plan Type',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    seatsUsed: 'Seats Used',
    of: 'of',
    billingCycle: 'Billing Cycle',
    nextBilling: 'Next Billing',
    studentEnrollment: 'Student Enrollment',
    totalStudents: 'Total Students',
    activeStudents: 'Active Students',
    pendingInvites: 'Pending Invites',

    // Students
    studentsList: 'Students List',
    inviteStudent: 'Invite Student',
    invite: 'Invite',
    exportCSV: 'Export CSV',
    requestMoreSeats: 'Request More Seats',
    noStudents: 'No students enrolled yet',
    noStudentsFiltered: 'No students match this filter',
    noStudentsFilteredHint: 'Try adjusting your filters',
    inviteFirstStudent: 'Invite your first student to get started',
    studentName: 'Student Name',
    email: 'Email',
    enrolled: 'Enrolled',
    removeStudent: 'Remove Student',
    packageLabel: 'Package',
    subscriptionStatus: 'Subscription Status',
    renewalDate: 'Renews On',
    renewalUnknown: 'Renewal date unavailable',
    statusUnknown: 'Status unavailable',
    unknownPackage: 'Unknown package',
    resetUsage: 'Reset usage',
    resettingUsage: 'Resetting…',
    resetUsageConfirm: 'Reset usage limits for {{name}}? This clears their chat and analysis counters for the current period.',
    resetUsageSuccess: 'Usage limits reset successfully.',
    resetUsageError: 'Failed to reset usage limits. Please try again.',
    student: {
      statusActive: 'Active',
      statusInactive: 'Inactive',
      lastActivityLabel: 'Last:',
      never: 'Never',
      transcriptsCount: '{{completed}} / {{total}} transcripts',
      messagesCount: '{{count}} messages',
      avgScore: 'Avg: {{score}}/100',
      enrolledAt: 'Enrolled: {{date}}',
      invitedAt: 'Invited: {{date}}',
      sending: 'Sending...',
    },

    // Quick Actions
    quickActions: 'Quick Actions',
    manageStudents: 'Manage Students',
    inviteStudents: 'Invite new students to your school',
    manageAdmins: 'Manage Admins',
    addRemoveAdmins: 'Add or remove school administrators',
    viewDocuments: 'View Documents',
    accessMaterials: 'Access school-specific coaching materials',
    schoolSettings: 'School Settings',
    configureSchool: 'Configure school preferences and billing',

    // Access Control
    accessRequired: 'School Admin Access Required',
    mustBeSchoolAdmin: 'You must be a school administrator to access this section.',

    // Super Admin View
    superAdminViewTitle: 'Super Admin View',
    superAdminViewDesc1: 'As a super admin, you have access to all schools in the system. This school management interface is primarily for school administrators.',
    superAdminViewDesc2: 'For comprehensive platform management, please use the "Platform Admin" tab.',

    // Coming Soon Sections
    documentsComingSoon: 'This section will allow you to upload and manage coaching documents specific to your school.',
    settingsComingSoon: 'Configure your school\'s AI coaching settings, system prompts, and preferences.',

    documentsSection: {
      title: 'RAG Knowledge Base Documents',
      subtitle: 'Upload coaching resources and materials',
      aboutTitle: 'About School Documents',
      aboutDescription: 'These documents are used to enhance the AI\'s coaching knowledge for all students in your school. Supported formats: PDF, TXT, DOCX (max 50MB).',
      loading: 'Loading documents...',
      emptyTitle: 'No Documents Yet',
      emptySubtitle: 'Upload your first coaching resource to enhance the AI\'s knowledge',
      uploadFirst: 'Upload Your First Document',
      methodLabel: 'Method',
      methodGrowModel: 'GROW model',
      methodCustomFramework: 'Custom framework',
      methodLinkedFramework: 'Linked framework',
      methodSchoolDocument: 'School document',
      methodUnknown: 'Unknown',
      sizeLabel: 'Size',
      chunksLabel: '{{count}} chunks',
      dateLabel: '{{date}}',
      processed: 'Processed',
      processing: 'Processing',
      deleteTitle: 'Delete Document',
      deleteConfirm: 'Are you sure you want to delete "{{filename}}"?',
      deleteSuccess: 'Document deleted successfully',
      deleteError: 'Failed to delete document. Please try again.',
      uploadSuccess: 'Document uploaded successfully',
      uploadError: 'Failed to upload document. Please try again.',
      loadError: 'Failed to load documents. Please try again.',
      totalDocs: 'Total Documents: {{count}}',
      totalChunks: 'Total Chunks: {{count}}',
      totalSize: 'Total Size: {{size}}',
    },

    // Frameworks Tab
    frameworks: 'Frameworks',
    frameworksSection: {
      active: 'Active',
      inactive: 'Inactive',
      approved: 'Approved',
      pendingApproval: 'Pending',
      stepsShort: 'steps',
      preview: 'Preview',
      searchSteps: 'Search steps…',
      noSteps: 'No steps yet. Add your first step.',
      conceptsShort: 'concepts',
      frameworkMetaTitle: 'Framework details',
      selectStepTitle: 'Select a step',
      selectStepBody: 'Pick a step from the left panel, or add a new one to get started.',
      controlPanel: 'Control panel',
      positiveShort: 'Positive',
      negativeShort: 'Growth',
      approvalReminder: 'Review and approve this framework before publishing.',
      activeLabel: 'Active',
      activeHint: 'Available across all coaching processes.',
      approvedLabel: 'Approved',
      approvedHint: 'Marks this framework as production ready.',
      lastSaved: 'Last saved: just now',
      footerHint: 'Changes won\'t apply until saved.',
      title: 'Coaching Frameworks',
      subtitle: 'Manage your school\'s coaching methodology frameworks',
      loading: 'Loading frameworks...',
      emptyTitle: 'No Frameworks Yet',
      emptySubtitle: 'Upload a coaching methodology document to auto-extract a framework',
      uploadFramework: 'Upload Framework Document',
      uploadFirst: 'Upload Your First Framework',
      uploadFrameworkDesc: 'Upload a PDF, TXT, or DOCX describing your coaching methodology. AI will extract the framework structure automatically.',
      infoTitle: 'What are Coaching Frameworks?',
      infoDescription: 'Upload a document describing your coaching methodology and AI will automatically extract the steps, markers, and competencies into a structured framework.',
      editFramework: 'Edit Framework',
      stepCount: '{{count}} steps',
      typeStepModel: 'Step Model',
      typeCompetencyModel: 'Competency Model',
      typeStepModelDescription: 'A Step Model defines the session flow in sequence (e.g., prepare → explore → act). Steps are usually followed in order.',
      typeCompetencyModelDescription: 'A Competency Model defines skill areas to assess (e.g., listening, presence, questioning). Areas are evaluated without strict sequence.',
      statusApproved: 'Approved',
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      createdAt: 'Created: {{date}}',
      sourceDoc: 'Source: {{filename}}',
      extractionDetailsTitle: 'Extraction Detail Summary',
      extractionDetailsSummary: '{{subSteps}} sub-steps/dimensions • {{concepts}} concepts • {{positive}} positive • {{negative}} negative • {{questions}} sample questions',
      // Editor
      editorTitle: 'Edit Framework',
      frameworkName: 'Framework Name',
      frameworkNameTr: 'Name (Turkish)',
      frameworkNameEn: 'Name (English)',
      frameworkType: 'Framework Type',
      stepsHeading: 'Steps',
      addStep: 'Add Step',
      stepName: 'Step Name',
      stepNameTr: 'Name (Turkish)',
      stepNameEn: 'Name (English)',
      stepDescription: 'Description',
      subSteps: 'Sub-steps',
      behaviorDimensions: 'Behavior Dimensions',
      concepts: 'Concepts',
      positiveMarkers: 'Positive Markers',
      negativeMarkers: 'Negative Markers',
      sampleQuestions: 'Sample Questions',
      subStepsShort: 'sub-steps',
      behaviorDimensionsShort: 'dimensions',
      positiveMarkersShort: 'positive',
      negativeMarkersShort: 'negative',
      sampleQuestionsShort: 'questions',
      icfMapping: 'ICF Competency Mapping',
      icfMappingNone: 'None',
      approve: 'Approve',
      activate: 'Activate',
      deactivate: 'Deactivate',
      save: 'Save Changes',
      saving: 'Saving...',
      saveSuccess: 'Framework saved successfully',
      saveError: 'Failed to save framework. Please try again.',
      deleteStep: 'Delete Step',
      deleteStepConfirm: 'Remove this step from the framework?',
      moveUp: 'Move Up',
      moveDown: 'Move Down',
      expandStep: 'Expand',
      collapseStep: 'Collapse',
      addTag: 'Add',
      tagPlaceholder: 'Type and press Add...',
      // Framework picker in upload
      linkToFramework: 'Link to Framework (optional)',
      linkToFrameworkDesc: 'Associate this document with one or more frameworks for smarter AI retrieval',
      selectFrameworks: 'Select Frameworks',
      noFrameworksAvailable: 'No frameworks available',
      frameworkLanguage: 'Document Language',
      languageTr: 'Turkish',
      languageEn: 'English',
      uploadSuccess: 'Framework document uploaded. AI extraction will begin shortly.',
      extractionInProgress: 'Framework upload completed. AI extraction is in progress...',
      reviewReady: 'Framework extracted. Opening editor.',
      reviewTimeout: 'Upload succeeded, but extraction is still running. Refresh frameworks in a moment.',
      uploadError: 'Failed to upload framework document.',
      deleteTitle: 'Delete Framework',
      deleteConfirm: 'Are you sure you want to delete "{{name}}"?',
      deleteSuccess: 'Framework deleted successfully.',
      deleteError: 'Failed to delete framework. Please try again.',
    },

    settingsSection: {
      title: 'School Settings',
      profileTitle: 'School Profile',
      schoolName: 'School Name',
      schoolNameSupport: 'Contact support to change school name',
      schoolId: 'School ID',
      slug: 'Slug',
      subscriptionType: 'Subscription Type',
      subscriptionStatusFallback: 'inactive',
      studentCapacity: 'Student Capacity',
      studentCapacityValue: '{{current}} / {{max}} students',
      helpTitle: 'Need Help?',
      helpDescription: 'For assistance with school settings, branding, or configuration, please contact our support team.',
      contactSupport: 'Contact Support',
      supportDialogTitle: 'Support',
      supportDialogMessage: 'Email: support@mentorcoach.ai\nWe typically respond within 24 hours.',
    },
  },

  // School Credits
  studentDetail: {
    title: 'Student details',
    studentPill: 'Student',
    icfAvgPill: 'ICF avg {{score}}',
    loading: 'Loading student details…',
    loadErrorTitle: 'Failed to load student details',
    loadErrorBody: 'Failed to load student details.',
    noPermission: 'You do not have permission to view student details. Please contact your administrator.',
    accessDenied: 'Access denied. You need school admin privileges to view student analytics.',
    tryAgain: 'Try again',
    stats: {
      thisMonth: 'This month',
      transcripts: 'Transcripts',
      totalSessions: 'Total sessions',
      chatMessages: 'Chat messages',
      documents: 'Documents',
      avgIcf: 'Avg ICF',
    },
    recentAnalyses: 'Recent analyses',
    itemCountOne: '{{count}} item',
    itemCountOther: '{{count}} items',
    noAnalyses: 'No analyses yet',
    icfProgressTitle: 'ICF competency progress',
    overallAverage: 'Overall average',
    basedOnSessionsOne: 'Based on {{count}} session',
    basedOnSessionsOther: 'Based on {{count}} sessions',
    icfEmpty: 'ICF data appears once at least one session is analyzed.',
    lastActivityNote: 'Last activity: {{date}}. Data is visible only within this school.',
    readOnly: 'Read-only view',
    close: 'Close',
    closeDrawer: 'Close drawer',
    activity: {
      none: 'No activity yet',
      today: 'Active today',
      daysAgo: 'Active {{days}}d ago',
      inactiveDays: 'Inactive {{days}}d',
      inactiveLong: 'Inactive 30d+',
    },
  },
  schoolAiPolicy: {
    behaviorTitle: 'AI Behavior Settings',
    gradingHarshness: 'Grading Harshness',
    gradingHarshnessPlaceholder: '0.0 – 1.0 (e.g. 0.5)',
    narrativeStyle: 'Narrative Style',
    narrativeStyles: {
      balanced: 'balanced',
      encouraging: 'encouraging',
      direct: 'direct',
    },
    feedbackDetailLevel: 'Feedback Detail Level',
    detailLevels: {
      brief: 'brief',
      standard: 'standard',
      detailed: 'detailed',
    },
    saving: 'Saving...',
    saveBehavior: 'Save Behavior Settings',
    behaviorSaved: 'Behavior settings saved',
    knowledgeTitle: 'Knowledge Bindings',
    knowledgePackIds: 'Knowledge Pack IDs',
    knowledgePackIdsPlaceholder: 'Comma-separated pack IDs',
    frameworkSourceIds: 'Framework Source IDs',
    frameworkSourceIdsPlaceholder: 'Comma-separated framework IDs',
    saveKnowledge: 'Save Knowledge Bindings',
    knowledgeSaved: 'Knowledge bindings saved',
    knowledgeHint: 'Separate IDs with commas. These extend the platform-level knowledge packs.',
    behaviorLoadError: 'Error loading behavior policy',
    knowledgeLoadError: 'Error loading knowledge policy',
    tryAgainLater: 'Please refresh the page or try again later.',
    behaviorSaveError: 'Behavior settings could not be saved. Please try again.',
    knowledgeSaveError: 'Knowledge bindings could not be saved. Please try again.',
  },
  schoolCredits: {
    title: 'Credit Pool',
    overview: 'Credit Overview',
    available: 'credits available',
    totalAvailable: 'Total Available',
    subscriptionPool: 'Subscription Pool',
    paidSeatCapacity: 'Paid Seat Capacity',
    creditsPerSeat: 'Analysis Credits per Seat',
    subscriptionRemaining: 'Subscription Remaining',
    purchasedCredits: 'Purchased Credits',
    billingPeriod: 'Billing Period',
    periodEnds: 'Period ends',
    purchased: 'purchased',
    used: 'used',
    poolUsage: 'Pool Usage',
    buyMore: 'Buy Credits',
    low: 'Low',
    critical: 'Critical',
    lowWarning: 'Low Credits',
    poolNote: 'Credits are shared across all students. Purchased credits never expire and are used after subscription credits.',
    usageByStudent: 'Usage by Student',
    student: 'Student',
    credits: 'Credits',
    noUsageYet: 'No credit usage recorded yet',
    totalUsed: 'Total Used',
  },

  // Create School
  createSchool: {
    title: 'Create New School',
    subtitle: 'Add a new school with subscription-ready defaults',
    schoolName: 'School Name',
    schoolNamePlaceholder: 'e.g., Mentor Coaching Academy',
    slug: 'Slug',
    slugPlaceholder: 'e.g., mentor-coaching',
    maxStudents: 'Max Students',
    harshness: 'Harshness',
    createButton: 'Create School',
    creating: 'Creating...',
    validationMaxStudents: 'Max students must be a positive number',
    validationHarshness: 'Harshness must be between 0 and 10',
    successMessage: 'School created successfully',
    name: 'Name',
    id: 'ID',
    required: 'Required',
    slugHelp: '3–50 lowercase letters, numbers, hyphens or underscores. Used in the school\'s links.',
    maxStudentsHelp: 'Capacity: how many students the school can hold. Paid seats are set under billing.',
    harshnessHelp: '0–10. Higher values give stricter feedback.',
    billingTitle: 'Billing',
    billingSubtitle: 'Monthly subscription. Enter prices in the currency\'s main unit (e.g. 49.00).',
    currency: 'Currency',
    basePrice: 'Base price per month',
    baseSeats: 'Seats included',
    addonPrice: 'Add-on price per month',
    addonPackageSize: 'Seats per add-on',
    priceSummary: '{{basePrice}} / month for {{baseSeats}} seats; +{{addonPrice}} / month per {{addonSeats}} extra seats',
    emailLanguage: 'Email language',
    emailLanguageHelp: 'Used for invitations and emails to members who haven\'t picked a language.',
    emailLanguageAuto: 'Auto (from currency)',
    emailLanguageEnglish: 'English',
    emailLanguageTurkish: 'Turkish',
    fixErrors: 'Please fix the highlighted fields.',
    billingSaveFailedTitle: 'School created, but its billing plan was not saved',
    billingSaveFailedMessage: '"{{name}}" (ID {{id}}) exists without a billing plan. Open it in Platform Admin and use Edit plan to set the billing. Do not create it again. Error: {{error}}',
    errors: {
      nameRequired: 'Enter the school name',
      slugRequired: 'Enter a slug',
      slugFormat: 'Use 3–50 lowercase letters, numbers, hyphens or underscores',
      price: 'Enter an amount like 49 or 49.00 (at most 2 decimals)',
      positiveWhole: 'Enter a whole number of at least 1',
    },
  },

  // Documents (RAG Knowledge Base)
  documents: {
    title: 'RAG Knowledge Base',
    subtitle: 'Manage the centralized knowledge base used by all users\' chats',
    loading: 'Loading...',
    uploadButton: 'Add to Knowledge Base',
    uploading: 'Uploading to Knowledge Base...',
    noDocuments: 'No knowledge base documents yet',
    noDocumentsSubtext: 'Upload coaching materials to build the centralized knowledge base',
    totalChunks: 'Total Chunks',
    status: 'Status',
    knowledgeBaseStats: 'Knowledge Base Statistics',
    chunks: 'chunks',
    processed: 'Processed',
    processing: 'Processing',
    confirmDelete: 'Are you sure you want to delete',
    deleteSuccess: 'RAG knowledge document deleted successfully',
    deleteFailed: 'Failed to delete document',
    uploadSuccess: 'RAG knowledge document uploaded successfully',
    uploadFailed: 'Failed to upload document',
    chunksCreated: 'Chunks created',
    loadFailed: 'Failed to load RAG knowledge base documents',
    accessDeniedTitle: 'Admin Access Required',
    accessDeniedText: 'This section is for managing the centralized RAG knowledge base that all users\' chats use.',
    accessDeniedSubtext: 'Only administrators can upload and manage knowledge base documents.',
    accessDeniedInfo: 'As a regular user, you can upload documents for analysis directly in the chat interface.',
  },

  // Admin Invite Modal

  // Student Invite Modal

  // School Plan Modal
  schoolPlan: {
    errors: {
      loadRequests: 'Failed to load requests.'
    },
    invalidValues: 'Please enter valid pricing and seat values.',
    savePlanError: 'Failed to save plan.',
    seats: {
      tooLowHint: 'Seat count must be at least as high as the current usage.',
      currentStatus: 'Current status',
      currentPlan: 'Current plan',
      currentPackage: 'Institution package',
      activeSeats: 'Active seats',
      currency: 'Currency',
      newTarget: 'New seat target',
      minHint: 'Minimum: {{n}}',
      prorate: 'Bill the difference now',
      prorateHint: 'If off, the change applies on the next billing cycle.',
      diffSummary: 'Change summary',
      seatLabel: 'Seat',
      monthlyFee: 'Monthly fee',
      diffPackage: 'Add-on package',
      notifyHint: 'This change will be notified to the school admin.',
      pendingRequests: 'Pending requests',
      viewAllRequests: 'View all requests →'
    },
    saveSeatsError: 'Failed to update seats.',
    requests: {
      approveSuccess: 'Request approved.',
      rejectSuccess: 'Request rejected.',
      actionError: 'Action could not be completed.',
      refresh: 'Refresh',
      subtle: 'Review and resolve your pending requests.',
      loading: 'Loading requests…',
      empty: 'No pending requests',
      emptyBody: 'When new requests come in, you can review them here.',
      pending: 'Pending',
      requestedSeats: 'Requested seats',
      requestedTier: 'Requested plan',
      note: 'Note',
      reject: 'Reject',
      approve: 'Approve'
    },
    tabs: {
      plan: 'Plan',
      seats: 'Seats',
      requests: 'Requests'
    },
    savePlan: 'Save plan',
    applyHint: 'Changes will not apply until saved.',
    saveSeats: 'Save changes',
    notifyHint: 'This change will be notified to the school admin.',
    subtitle: 'Manage seat count, plan, and billing changes in one place.',
    basePlan: 'Base plan',
    currency: 'Currency',
    currencyHint: '3-letter ISO code (try, usd, eur)',
    basePrice: 'Base monthly price',
    baseSeats: 'Seats included in base',
    addonPackages: 'Seat add-on packages',
    pkgSize: 'Seats per add-on package',
    pkgPrice: 'Add-on package price',
    summary: 'Plan summary',
    monthlyBase: 'Monthly base',
    perAddon: 'Per add-on package',
    includes: 'includes',
    aboutPlan: 'About this plan',
    aboutBody: 'Changes apply on the next billing cycle unless prorated.',
    seatUnit: 'seat',
    title: 'School Plan Details',
    planType: 'Plan Type',
    maxStudents: 'Max Students',
    currentStudents: 'Current Students',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    billingCycle: 'Billing Cycle',
    monthlyPrice: 'Monthly Price',
    features: 'Features',
    close: 'Close',
  },

  // Seat Update Modal

  // Seat Requests Modal
  seatRequests: {
    title: 'Seat Requests',
    noRequests: 'No pending seat requests',
    requestedBy: 'Requested by',
    requestedSeats: 'Requested Seats',
    currentSeats: 'Current',
    reason: 'Reason',
    requestDate: 'Request Date',
    approve: 'Approve',
    reject: 'Reject',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    close: 'Close',
    approveSuccess: 'Request approved successfully',
    rejectSuccess: 'Request rejected',
    actionError: 'Failed to process request',
  },

  // Plan Change Requests (admin modal)

  // Seat Request Create Modal

  // Plan Change Request (school create request modal)


  // Direct plan tier labels (used by some modals)

  // Admin Bill Invite Modal

  // Voice Transcription
  transcription: {
    realtimeNotAvailable: 'Realtime recording is not available yet. Please upload a file.',
    meetingBotNotAvailable: 'Meeting bot support is coming soon.',
    simple: {
      title: 'Audio recording ready',
      subtitle: 'A transcript will be extracted first, then ICF analysis will be performed.',
      audioFile: 'Audio file',
      ready: 'Ready',
      defaultsTitle: 'Smart defaults',
      defaultLanguage: 'Language will be detected automatically',
      defaultSpeakers: 'Speakers will be separated',
      defaultGrammar: 'Spelling will be corrected',
      defaultAnalysis: 'ICF analysis will follow',
      pathTitle: 'What will happen?',
      stepTranscribe: 'Audio is transcribed',
      stepSpeakers: 'Speakers are separated',
      stepAnalyze: 'ICF analysis is performed',
      stepChat: 'Feedback is added to chat',
      advancedTitle: 'Settings',
      safeDefaults: 'If you don\'t change the settings, we\'ll proceed with the safest defaults.',
      hideSettings: 'Hide settings',
      changeSettings: 'Change settings',
      startCombined: 'Transcribe and analyze'
    },
    edit: {
      tapToPlace: 'Tap a segment to place "{word}"',
      splitHere: 'Split here',
      move: 'Move'
    },
    title: 'Voice Transcription',
    uploadAudio: 'Upload Audio',
    myTranscripts: 'My Transcripts',

    modal: {
      defaultICFInstructions: 'Analyze this coaching session for ICF competencies',
      title: 'Transcription Options',
      start: 'Start',
      language: 'Language',
      autoDetect: 'Auto-detect',
      turkish: 'Turkish',
      english: 'English',
      speakerDiarization: 'Identify Speakers',
      speakerDiarizationDesc: 'Label as Koç (Coach) and Müşteri (Client)',
      grammarCorrection: 'Grammar Correction',
      grammarCorrectionDesc: 'AI-powered punctuation and spelling fixes',
      postTranscription: 'After Transcription',
      analysisInstructions: 'Analysis Instructions (Optional)',
      analysisPlaceholder: 'Evaluate this coaching session according to ICF PCC criteria...',
      icfProgressToggle: 'Count this session toward my ICF progress',
      icfProgressDesc: 'On by default. Turn off to analyze without affecting your progress history.',
      fileInfo: 'Duration: {{duration}} • {{size}}',
    },

    progress: {
      title: 'Transcribing',
      validating: 'Validating audio file...',
      uploading: 'Uploading...',
      transcribing: 'Transcribing with AI...',
      analyzingAudioCues: 'Analyzing audio emotions and cues...',
      mergingDiarization: 'Merging speaker identification...',
      detectingSilences: 'Detecting meaningful pauses...',
      failed: 'Transcription failed',
      identifyingSpeakers: 'Identifying speakers...',
      correctingGrammar: 'Applying grammar correction...',
      encrypting: 'Encrypting and storing...',
      complete: 'Complete!',
      estimatedTime: 'Estimated time: ~{{minutes}} minutes',
      tip: 'Tip: You can download transcripts as SRT/VTT subtitle files!',
      processing: 'Processing your audio...',
      cancel: 'Cancel transcription',
      cancelling: 'Cancelling...',
      cancelFailed: 'Could not cancel transcription. Please try again.',
    },

    viewer: {
      title: 'Transcript',
      download: 'Download',
      srt: 'SRT Subtitles',
      vtt: 'VTT Subtitles',
      txt: 'Plain Text',
      silence: 'Silence',
      seconds: 'seconds',
      tapToSeek: 'Tap to jump to this moment',
      rawText: 'Raw Text',
      correctedText: 'Corrected Text',
      speakers: 'Speakers',
      silences: 'Silences',
      duration: 'Duration',
      analyzeSession: 'Analyze Session',
      analyze: 'Analyze',
      playAudio: 'Play Audio',
      noContent: 'Transcript content not available',
      // Redesigned viewer
      breadcrumbSessions: 'Sessions',
      headerTitleReady: 'Transcript ready',
      headerSubtitle: 'Edit, check speakers and export in the format you want.',
      pillSaved: 'Saved',
      pillSpeakers: '{{n}} speakers',
      tabRead: 'Read',
      tabEdit: 'Edit',
      controlsTitle: 'Controls',
      speakersHeading: 'Speakers',
      coachLabel: 'Coach',
      clientLabel: 'Client',
      changeLabel: 'Rename',
      swapSpeakers: 'Coach ↔ Client',
      exportHeading: 'Export',
      shareHeading: 'Share',
      historyHeading: 'History',
      lastSavedJustNow: 'Last saved: just now',
      editsCount: '{{n}} words corrected',
      editPendingCount: '{{n}} edits pending',
      cancelEdits: 'Cancel',
      saveChanges: 'Save changes',
      transcriptUpdated: 'Transcript updated',
      refreshFeedback: 'Refresh feedback',
      backToSession: 'Back to session',
      openInChat: 'Open in chat',
      savedToLibrary: 'Saved to library',
      secureNoticeTitle: 'Secure',
      secureNoticeBody: 'Your coaching data stays in your control.',
      editWordTitle: 'Edit word',
      wordEditCancel: 'Cancel',
      wordEditSave: 'Save',
      // Audio cue labels
      laughs: 'laughs',
      voiceBreaks: 'voice breaks',
      emotionPeak: 'emotional peak',
      speakingFaster: 'speaking faster',
      speakingSlower: 'speaking slower',
      hesitation: 'hesitation',
      pitchShift: 'pitch shift',
      // Silence context labels
      reflectionPause: 'Reflection pause',
      emotionalPause: 'Emotional pause',
      thinkingPause: 'Thinking pause',
      // Coaching insights
      coachingInsights: 'Coaching Insights',
      powerfulQuestion: 'Powerful question',
      breakthroughMoment: 'Breakthrough moment',
      rapportLaughter: 'Rapport laughter',
      noInsights: 'No coaching insights detected',
      // Prosodic summary
      prosodicSummary: 'Session Audio Analysis',
      speakingRate: 'Speaking rate',
      speakingTime: 'Speaking time',
      laughterCount: 'Laughter instances',
      emotionalMoments: 'Emotional moments',
      voiceBreakCount: 'Voice breaks',
      reflectionPauses: 'Reflection pauses',
      speakingRatio: 'Speaking ratio (Coach/Client)',
      wordsPerMin: 'words/min',
      emotionalArc: 'Emotional arc',
      diarizationMethod: 'Diarization',
      diarizationConfidence: 'Confidence',
      providerUsed: 'Provider',
    },


    list: {
      empty: 'No transcripts yet',
      emptyDesc: 'Upload or record an audio file to create your first transcript',
      uploadFirst: 'Upload Audio',
      processing: 'Processing...',
      completed: 'Completed',
      failed: 'Failed',
      deleteConfirm: 'Delete this transcript?',
      deleteConfirmDesc: 'This will permanently delete the transcript and audio file.',
      deleted: 'Transcript deleted successfully',
      pullToRefresh: 'Pull to refresh',
    },

    errors: {
      loadFailed: 'Transcript could not be loaded',
      quotaExceeded: 'Monthly transcript limit exceeded',
      fileTooLarge: 'File too large ({{size}}MB). Maximum allowed: {{max}}MB',
      fileTooLargeGeneric: 'The file is too large. Please upload a shorter recording or a smaller file.',
      durationTooLong: 'Audio too long. Maximum: {{duration}}',
      unsupportedFormat: 'Unsupported audio format',
      unsupportedAudio: 'This audio format is not supported. Please try MP3, WAV, M4A, or another supported format.',
      audioTooLarge: 'This file is larger than the {{limit}} MB upload limit. Upload the audio-only recording instead (Zoom saves an .m4a file next to the video), or a shorter recording.',
      audioTooLong: 'This recording is longer than the {{limit}}-minute limit. Trim it, or split it into parts of up to {{limit}} minutes and upload them one by one.',
      audioUnsupportedFormat: "This file type isn't supported. Upload your session recording as one of: {{formats}}.",
      audioUnreadable: "We couldn't read this recording; the file may be damaged or incomplete. Export it again from your recording app and upload the new file.",
      uploadFailed: 'Upload failed. Please try again.',
      uploadInterrupted: 'The upload was interrupted. Please select the file again and try once more.',
      transcriptionFailed: 'Transcription failed',
      downloadFailed: 'Failed to download transcript',
      audioLoadFailed: 'Failed to load audio',
    },

    actions: {
      upload: 'Upload Audio File',
      record: 'Record Audio',
      viewAll: 'View All Transcripts',
    },
  },

  // My Documents Screen

  // Transcript Analysis
  analysis: {
    simple: {
      summaryTitle: "Analysis summary",
      included: "Included",
      excluded: "Not included",
      notApplicable: "Not applicable",
      progressLabel: "ICF progress",
      engagementResult: "Result: an observation draft attached to {{mentee}}'s session for your review",
      credits: "Uses 1 analysis credit · {{remaining}} remaining",
      title: 'Ready to analyze',
      subtitle: "Review your analysis settings before starting.",
      ready: 'Ready',
      levelAuto: "Auto — determined from the session",
      resultToChat: 'Result will be added to the chat',
      stepMarkers: "{{level}} markers are evaluated",
      hideSettings: 'Hide settings',
      changeSettings: 'Change settings',
      start: 'Start analysis'
    },
    modal: {
      prepareSessionReview: "Prepare session review",
      queueingReview: 'Uploading the session and queuing the review. Live progress opens next.',
      prepareReview: "Prepare review",
      engagementSubtitle: "For {{mentee}} · reviewed against the {{level}} standard",
      reviewStandard: "Review standard",
      inheritedStandard: "{{level}} — inherited from the engagement",
      reviewStandardHelp: "The session is graded against the ICF {{level}} Minimum Skills Requirements and produces the {{level}} Session Observation Form (rev. {{sof_revision}}).",
      feedbackLanguage: "Feedback language",
      additionalOptions: "Additional options",
      title: 'Analyze Transcript',
      start: 'Analyze',
      sourceTranscript: 'Source Transcript',
      language: 'Analysis Language',
      instructions: 'Analysis Instructions',
      instructionsPlaceholder: 'Add specific instructions for the analysis...',
      infoNote: 'The analysis will use our AI coaching knowledge base to provide structured feedback on the coaching session.',
      modeTitle: 'Analysis Type',
      icfMode: 'ICF Assessment',
      icfModeDesc: 'Evaluate coaching competency against ICF standards',
      customMode: 'Custom Analysis',
      customModeDesc: 'Analyze with your own custom instructions',
      levelTitle: 'Target Level',
      levelAuto: 'Auto-detect',
      levelAutoDesc: 'Let the system determine the appropriate level',
      levelACC: 'ACC',
      levelPCC: 'PCC',
      levelMCC: 'MCC',
      includeMarkerTable: 'Include Full MSR Table',
      includeMarkerTableDesc: 'Evaluate every MSR individually with transcript evidence (takes longer)',
      customPromptPlaceholder: 'Enter your custom analysis instructions...',
      upgradeRequired: 'Upgrade',
      upgradeRequiredDesc: 'Available on {{tierName}} plan and above',
      observationLevelTitle: 'Observation level',
      observationLevelHelp:
        'The session is graded against the {{level}} Minimum Skills Requirements and produces the ICF {{level}} Session Observation Form (rev. {{revision}}).',
      observationLevelHelpAuto:
        'Auto produces a developmental report only — no ICF Session Observation Form. Pick a level to generate one.',
      observationLevelAuto: 'Auto — developmental report, no observation form',
      engagementSelectTitle: 'Add to engagement',
      engagementSelectHelp:
        'Optional. Attaching the session to a mentor engagement files its observation form under that mentee.',
      engagementSelectNone: 'No engagement',
      engagementSelectLocked:
        'Level locked to {{level}} by the engagement. This session stays out of your own ICF Progress.',
    },
    progress: {
      pdfSaved: 'PDF saved to device.',
      livePreview: 'Live Preview',
      title: 'Analyzing Your Session',
      completeTitle: 'Analysis Complete!',
      failedTitle: 'Analysis Failed',
      complete: 'Analysis complete!',
      failed: 'Analysis failed',
      starting: 'Starting analysis...',
      startFailed: 'Analysis could not be started. Please try again.',
      stalledBeforeStart: 'Analysis did not start. Please try again.',
      stalled: 'Analysis is taking too long and may be stuck. Please try again.',
      statusUnavailable: 'Analysis status stopped updating. Please try again.',
      missingResult: 'The analysis finished without a report. Please try again.',
      elapsedOnly: 'Elapsed {{elapsed}}',
      etaWithElapsed: 'Elapsed {{elapsed}} • Est. {{remaining}} left',
      reassuranceShort: 'Detailed ICF analysis is being prepared. This can take a few minutes.',
      reassuranceLong: 'Still working — longer transcripts and higher-level calibration can take more time.',
      etaFewMinutes: 'a few more minutes',
      detailReason: 'The system is not just summarizing; it is checking competency evidence, development areas, and level consistency.',
      etaUnderMinute: 'under 1 min',
      etaAboutDuration: 'about {{duration}}',
      etaRangeDuration: '{{min}}-{{max}}',
      secondsShort: '{{seconds}} sec',
      minutesShort: '{{minutes}} min',
      checkpoint: 'Checkpoint {{current}}/{{total}}: {{label}}',
      stillWorking: 'Still working. Updates may arrive slowly.',
      cancel: 'Cancel analysis',
      cancelling: 'Cancelling...',
      cancelFailed: 'Could not cancel the analysis. Please try again.',
      preparing: 'Preparing...',
      reading: 'Reading document...',
      context: 'Gathering context...',
      scoring: 'Evaluating competency evidence...',
      writing: 'Structuring developmental feedback...',
      validating: 'Checking level and evidence consistency...',
      stageDetail: {
        preparing: 'Preparing the analysis type, language, and session settings.',
        reading: 'Checking the coach/client flow, timestamps, and session structure in the transcript.',
        context: 'Preparing ICF competency indicators and relevant level context.',
        scoring: 'Matching behavioral evidence to each competency.',
        writing: 'Structuring feedback with strengths, development focus, and evidence quotes.',
        validating: 'Rechecking the level decision, evidence, and feedback consistency.',
        saving: 'Saving the report to chat and your session history.',
      },
      analyzing: 'Analyzing content...',
      generating: 'Generating insights...',
      saving: 'Saving results...',
      successMessage: 'Your coaching session has been analyzed. View the detailed feedback or download as PDF.',
      viewAnalysis: 'View Analysis',
      downloadPdf: 'Download PDF',
      backToTranscript: 'Back to Transcript',
      errorMessage: 'Something went wrong. Please try again.',
      tip: 'The system is not just summarizing; it is checking competency evidence, development areas, and level consistency.',
      document: 'Document',
      pdfWebOnly: 'PDF export is available on web only for now.',
      pleaseWait: 'This may take a moment...',
    },
    success: 'Analysis completed! Your feedback is ready below.',
    error: 'Failed to start analysis',
    viewAnalysis: 'View Analysis',
    exportPdf: 'Export PDF',
    analysesSection: 'Analyses',
    noAnalyses: 'No analyses yet',
    analysisDate: 'Analyzed on {{date}}',
  },

  // Pre-Auth Onboarding Flow

  // Home Screen (Dashboard)
  home: {
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    icfJourney: 'Your ICF Journey',
    currentLevel: 'Current',
    targetLevel: 'Target',
    none: 'None',
    toGoal: 'to goal',
    sessionsAnalyzed: 'sessions analyzed',
    quickActions: 'Quick Actions',
    analyzeSession: 'Analyze Session',
    talkToMentor: 'AI Mentor',
    myProgress: 'My Progress',
    myLibrary: 'Library',
    recentSessions: 'Recent Sessions',
    seeAll: 'See All',
    untitledSession: 'Coaching Session',
    emptyTitle: 'Start Your Journey',
    emptySubtitle: 'Upload your first coaching session to get AI-powered feedback',
    uploadFirst: 'Upload First Session',
    loadError: 'Failed to load dashboard',
  },

  // Library Screen
  library: {
    sampleTranscriptTitle: 'PCC demo session transcript',
    sampleTranscriptMeta: '38 min · transcript with linked marker evidence',
    sampleTranscriptOpen: 'Explore a sample session',
    sampleBadge: 'SAMPLE',
    emptyUploadCta: 'Upload a session',
    emptyRecordCta: 'Record now',
    analysisFailed: 'Analysis failed',
    unsupportedFileType: 'Unsupported file type. Please upload an audio recording (MP3, M4A, WAV) or a transcript (PDF, DOCX, TXT).',
    processing: 'Processing',
    analyzed: 'Analyzed',
    notAnalyzed: 'Not analyzed',
    filterAll: 'All',
    filterTranscripts: 'Voice',
    filterDocuments: 'Text',
    filterShared: 'Shared',
    typeVoice: 'VOICE',
    typeText: 'TEXT',
    typeShared: 'SHARED',
    documents: 'documents',
    itemCount: '{{count}} documents',
    noItems: 'No documents yet',
    emptyTitle: 'No documents yet',
    noTranscripts: 'No voice recordings',
    noTextDocs: 'No text documents',
    noDocuments: 'No documents yet',
    noSharedDocs: 'No shared documents yet',
    emptySubtitle: 'Upload a session recording or document to get started',
    emptySharedSubtitle: 'Documents shared by your school members will appear here',
    transcriptProcessing: 'Transcript is still processing. Please wait.',
    transcriptUnavailable: 'Transcript is not available.',
    noSessionAvailable: 'No chat session available for this document.',
    deleteTitle: 'Delete Document',
    deleteConfirm: 'Delete "{{filename}}"?',
    deleteWithChat: 'Delete "{{filename}}" and its associated chat?',
    deleteError: 'Failed to delete document. Please try again.',
    deleteFailedArtifactTitle: 'Clean up failed upload?',
    deleteFailedArtifactCopy: 'This will remove the failed upload file and its saved records. This cannot be undone.',
    deleteFailedArtifactAction: 'Delete and clean up',
    loadingDocument: 'Loading document...',
    // Sharing
    share: 'Share',
    shareWith: 'Share with school',
    sharedBy: 'Shared by {{name}}',
    shareSuccess: 'Document shared successfully',
    shareError: 'Failed to share document',
    // Date formatting
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{{days}}d ago',
    // Language labels
    langTurkish: 'Turkish',
    langEnglish: 'English',
    // Materials
    filterMaterials: 'Materials',
    typeMaterial: 'MATERIAL',
    uploadMaterial: 'Upload Material',
    voiceRecording: 'Voice Recording',
    textDocument: 'Text Document',
    analyzeDocument: 'Analyze Document',
    uploadChoice: 'What would you like to do?',
    noMaterials: 'No materials uploaded',
    uploadSuccess: 'Material uploaded successfully!',
    uploadFailed: 'Failed to upload material',
    fileTooLarge: 'File is too large. Maximum size is 50MB.',
    textDocsNotViewable: 'Text documents cannot be viewed inline yet',
    unknown: 'Unknown',
    sharingCenterStudentTitle: 'Share with your mentor',
    sharingCenterStudentCopy: 'Choose a transcript and send it to your mentor. You can manage who has access from the same place.',
    sharingCenterMentorTitle: 'Review student shares',
    sharingCenterMentorCopy: 'See transcripts students share with you, and share your own materials with the group.',
    sharedWithMeShort: 'Shared with you',
    sharedByMeShort: 'Shared by you',
    lastSharedTo: 'Latest share',
    openSharedInbox: 'Open shared inbox',
    manageLatestShare: 'Manage latest share',
    shareWithMentor: 'Share with mentor',
    manageSharing: 'Manage sharing',
    openTranscript: 'Open transcript',
    downloadPdf: 'Download PDF',
    sharedOutEmpty: 'Select a session from the list to share it.',
    sharedOutEmptyReadonly: 'Shared documents will appear here.',
    webTitle: 'Sessions',
    webSubtitle: 'Upload, analyze, and track your coaching recordings and transcripts in one place.',
    webPrimaryUpload: 'Upload new session',
    webUploadTitle: 'Upload your session',
    webUploadBody: 'Choose a voice recording or transcript. We will ask only the needed settings in the next step.',
    webVoiceTitle: 'Voice recording',
    webVoiceMeta: 'MP3, M4A, WAV, MP4, MOV and more',
    webTextTitle: 'Text / transcript',
    webTextMeta: 'TXT, DOCX, PDF',
    webFlowUploadTitle: 'Upload',
    webFlowUploadCopy: 'Choose a recording or transcript.',
    webFlowAnalyzeTitle: 'Analysis runs',
    webFlowAnalyzeCopy: 'AI reviews the coaching behaviors.',
    webFlowChatTitle: 'Ready in chat',
    webFlowChatCopy: 'Review results and ask follow-up questions.',
    webSearchPlaceholder: 'Search sessions...',
    webEmptyTitle: 'No sessions yet',
    webEmptyBody: 'After your first upload, analysis and chat views will be created automatically.',
    webEmptyCta: 'Upload first session',
    webSideTitleFirst: 'Upload your first session',
    webSideTitleNext: 'Add the next session',
    webSideBody: 'The simplest path: choose the file, keep the defaults, then review it in chat when the analysis is ready.',
    webSideUpload: 'Upload session',
    webSideTranscript: 'Upload transcript',
    webPrivacyTitle: 'Your privacy matters.',
    webPrivacyBody: 'Uploaded content is used for coaching analysis and can be managed from account settings.',
  },

  // Progress Screen (ICF Journey)
  progress: {
    icfJourney: 'Your ICF Journey',
    current: 'Current',
    target: 'Target',
    none: 'None',
    toGoal: 'to goal',
    sessionsAnalyzed: 'sessions analyzed',
    remaining: 'remaining',
    goalReached: 'Goal reached!',
  },

  // Upload Flow
  upload: {
    title: 'Upload Session',
    selectSource: 'How would you like to upload?',
    selectSourceDesc: 'Choose your session source',
    uploadFile: 'Upload File',
    uploadFileDesc: 'Audio or transcript file',
    recordNow: 'Record Now',
    pasteText: 'Paste Text',
    comingSoon: 'Coming Soon',
    soon: 'Soon',
    preparing: 'Preparing upload...',
    uploading: 'Uploading file...',
    transcribing: 'Transcribing audio...',
    analyzing: 'Analyzing session...',
    finalizing: 'Finalizing...',
    complete: 'Complete!',
    processing: 'Processing your session...',
    processingTitle: 'Processing',
    processingHint: 'This may take a few minutes...',
    successTitle: 'Session Uploaded!',
    successSubtitle: 'Your coaching session has been analyzed',
    overallScore: 'Overall Score',
    viewAnalysis: 'View Full Analysis',
    later: 'View Later',
    completeTitle: 'Complete',
    error: 'Upload failed',
    pickerError: 'Could not select file',
  },

  // Suggestion Chips

  // Toast Notifications
  toast: {
    purchaseSuccess: '{{count}} credits added to your account!',
    purchaseFailed: 'Credit purchase failed. Please try again.',
  },

  // Mentors (School Management)
  mentors: {
    cancelInviteConfirm: 'Cancel the invitation for {{name}} ({{email}})?',
    nameRequired: 'Please enter the mentor\'s name',
    invalidEmail: 'Please enter a valid email address',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter mentor\'s name',
    email: 'Email Address',
    invalidEmailHint: 'Enter a valid email address.',
    capabilityTitle: 'What this mentor can do',
    cap: {
      review: 'Review shared student sessions',
      feedback: 'Leave structured feedback',
      cohort: 'Track cohort progression'
    },
    roleHintTitle: 'About this role',
    roleHintBody: 'Mentors only see sessions students explicitly share with them.',
    verifyHint: 'Mentor receives a one-time invitation link via email.',
    sendInvitation: 'Send Invitation',
    resendSuccess: 'Invitation resent',
    resendError: 'Failed to resend invitation',
    cancelInviteTitle: 'Cancel Invitation',
    cancelError: 'Failed to cancel invitation',
    resendInvitation: 'Resend invitation',
    cancelInvitation: 'Cancel invitation',
    pendingInvitations: 'Pending Invitations',
    title: 'Mentors',
    invite: 'Invite Mentor',
    inviteTitle: 'Invite Mentor',
    inviteSubtitle: 'Enter the email address of the mentor you want to invite',
    emailPlaceholder: 'mentor@example.com',
    emailLabel: 'Email Address',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email',
    sendInvite: 'Send Invite',
    sending: 'Sending...',
    inviteSuccess: 'Invitation sent successfully',
    inviteError: 'Failed to send invitation',
    noMentors: 'No mentors yet',
    inviteFirst: 'Invite mentors to help manage your school',
    removeTitle: 'Remove Mentor',
    removeConfirm: 'Are you sure you want to remove {{name}} as a mentor?',
    removeMentor: 'Remove mentor',
    removeError: 'Failed to remove mentor',
    seatsFull: 'All mentor seats are filled',
  },

  // Document Sharing
  share: {
    consentText: 'I confirm that my client has been informed and has consented to this coaching session recording being shared for supervision/feedback purposes.',
    title: 'Share Document',
    subtitle: 'Share "{{filename}}" with your school',
    shareWith: 'Share with',
    entireSchool: 'Entire School',
    entireSchoolDesc: 'All students and mentors can view',
    specificStudents: 'Specific Students',
    specificStudentsDesc: 'Only selected students can view',
    selectStudents: 'Select Students',
    searchStudents: 'Search students...',
    noStudentsFound: 'No students found',
    selectedCount: '{{count}} recipient(s)',
    share: 'Share',
    sharing: 'Sharing...',
    cancel: 'Cancel',
    success: 'Document shared successfully',
    error: 'Failed to share document',
    stepOf: 'Step {{current}} of {{total}}',
    consentTitle: 'Client Consent',
    iConfirm: 'I confirm client consent',
    addNote: 'Add a note (optional)',
    notePlaceholder: 'Write a message...',
    send: 'Share',
    selectAtLeastOne: 'Please select at least one recipient',
    noRecipients: 'No recipients available',
    allShared: 'Shared with everyone',
    allSchoolMembersHaveAccess: 'All school members already have access',
    // New sharing keys
    allMembers: 'All Members',
    allStudents: 'All Students',
    manageRecipients: 'Manage Recipients',
    addMore: 'Add Recipients',
    addCount: 'Add {{count}}',
    removeRecipientTitle: 'Remove Recipient',
    removeRecipientConfirm: 'They will no longer have access to this document.',
    noRecipientsYet: 'No recipients yet',
    addRecipientsHint: 'Add recipients to share this document',
    selectRecipients: 'Select Recipients',
    roleStudent: 'Student',
    roleMentor: 'Mentor',
    roleAdmin: 'Admin',
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    empty: 'No notifications yet',
    emptySubtitle: 'You will see notifications here when documents are shared with you',
    markAllRead: 'Mark all as read',
    newDocument: 'New document shared',
    documentShared: '{{name}} shared a document with you',
    viewDocument: 'View Document',
    justNow: 'Just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    loadError: 'Failed to load notifications',
    fromSender: 'From {{name}}',
  },

  // Trial / Free Preview
  trial: {
    launchOffer: 'Launch offer: 20% off your first 3 months — use code LAUNCH20 at checkout',
    analysisUsed: {
      message: 'Your trial includes one analysis. More analyses unlock when your plan starts on {{date}}.',
      messageNoDate: 'Your trial includes one analysis. More analyses unlock when your plan starts.',
    },
    upload: {
      headerBadge: 'ICF feedback in minutes',
      title: 'Turn one coaching session into a development plan',
      description: 'Upload one coaching transcript and get a full 8-competency ICF analysis with your ACC/PCC/MCC level.',
      uploading: 'Uploading...',
      analyzing: 'Analyzing your transcript...',
      analyzingDescription: 'Usually takes 60–90 seconds',
      complete: 'Analysis complete!',
      error: 'Something went wrong',
      selectFile: 'Upload Transcript',
      tryAgain: 'Try Again',
      redirecting: 'Opening your results...',
      skipToPricing: 'View plans instead',
      helpToggle: "What's a transcript? ▼",
      helpContent: "A record of a coaching conversation between you and your client. For example:\n• A Zoom/Teams meeting transcript\n• A chat or email exchange\n• Notes you typed from a session",
      errorTooLarge: 'File is too large. Try a shorter transcript.',
      errorInvalid: 'This file type is not supported. Use PDF, Word, or text files.',
      errorDuplicate: 'This transcript was already analyzed. Try a different one.',
      errorNetwork: 'Connection lost. Check your internet and try again.',
      errorGeneric: 'Something went wrong. Please try again.',
      whatYouGet: "What you'll get",
      feature1: 'Full 8-competency ICF analysis',
      feature2: 'Your ACC / PCC / MCC level',
      feature3: '20 AI mentor conversations about your results',
    },
    banner: {
      expiresIn: 'Trial ends in',
      messagesUsed: '{{count}}/20 messages',
      subscribeCTA: 'Upgrade',
      expired: 'Expired',
      label: 'Free trial',
      legacyLabel: 'Free trial · No card required',
      cardBackedLabel: 'Free trial · Card on file',
      legacyNotice: 'Your free trial stays active until its current deadline. It will not renew or charge automatically.',
      cardBackedNotice: 'Your saved payment method is charged when the trial ends unless you cancel beforehand.',
      noMessages: 'no messages left',
      expiringSoon: 'expiring soon',
      lastMessage: 'This is your last free message',
      messagesOf: '{{used}} of {{total}} used',
      valueBadge: 'ICF feedback in minutes',
      welcomeTitle: 'Turn your next coaching session into a development plan',
      welcomeDescription: 'Upload a transcript, see your ACC/PCC/MCC competency profile, and ask your AI mentor what to improve next.',
      urgencyDescription: "Use the session while it is fresh and turn today's reflection into concrete next steps.",
      trialTerms: 'Free trial. Limited usage.',
      startTrial: 'Start Free Trial',
      startingTrial: 'Starting trial...',
      savingPath: 'Saving focus...',
      startError: 'We could not start your trial. Try again.',
      openApp: 'Open Mentor Coaching AI',
      uploadFirstCta: 'Upload transcript first',
      practiceCta: 'Practice with an AI client',
      pathQuestion: 'What should your trial adapt around first?',
      pathDescription: 'We save this choice and use it later in analysis, AI mentor chat, and activation reminders.',
      accessCodeHelper: 'Your code automatically connects the right school, mentor coach, or trial context and prepares the experience for you.',
      sampleFormHelper: 'The sample form shows which information will be used in a real analysis, including required fields, optional focus areas, and analysis language.',
      firstUploadHelper: 'The default settings are enough for most users. You can also add a target level or custom analysis focus.',
      liveMentorPrepTitle: 'Arrive better prepared for your live mentor coaching session',
      liveMentorPrepDescription: 'Use MCAi’s pre-analysis to arrive at your live mentor coaching session with sharper questions, evidence quotes, and a clearer development focus.',
      pathSaveError: 'We could not save that focus. Try again.',
      paths: {
        session_analysis: {
          title: 'Analyze a client session',
          description: 'Use a recent transcript while the session is still fresh.',
          headline: 'Turn a real client session into concrete coaching feedback',
          body: 'Your trial will prioritize transcript analysis, ICF competency signals, and next-session improvements.',
          uploadTitle: 'Start with the session you most want feedback on',
          uploadDescription: 'Upload the session you most want feedback on. Mentor Coaching AI will use your saved focus to shape the first analysis and follow-up chat.',
        },
        credential_prep: {
          title: 'Prepare for ACC/PCC/MCC',
          description: 'See where your coaching evidence is ready and where it needs work.',
          headline: 'Use the trial to see how credential-ready your coaching is',
          body: 'Your trial will focus on ICF evidence, level signals, and the competency gaps that matter for credential preparation, so you can bring sharper questions to your live mentor coaching session.',
          uploadTitle: 'Upload a session that represents your current coaching level',
          uploadDescription: 'Upload a session that represents your current coaching level. The app will keep your credential focus in later analysis and mentor chat.',
        },
        mentor_review: {
          title: 'Review as a mentor coach',
          description: 'Find evidence, patterns, and supervision themes faster.',
          headline: 'Turn mentor-review work into a sharper evidence base',
          body: 'Your trial will emphasize session evidence, development themes, and questions you can use in a live mentor coaching session.',
          uploadTitle: 'Upload a session you need to review',
          uploadDescription: 'Upload a session you need to review. Mentor Coaching AI will keep the mentor-review context available in later app guidance.',
        },
        practice_first: {
          title: 'Practice before uploading',
          description: 'Start with a simulated client, then analyze your real work.',
          headline: 'Start with practice, then bring a real session into the trial',
          body: 'Your trial will make the first steps lighter: practice with an AI client, then use a real session when you are ready.',
          uploadTitle: 'Practice first or upload when ready',
          uploadDescription: 'You can upload now or start with the AI client. Your saved practice-first focus will carry into later guidance.',
        },
      },
      uploadTitle: 'Start with one real coaching session',
      uploadDescription: 'Upload a transcript during your free trial.',
      uploadSession: 'Upload a Session',
      activeKicker: 'Free trial',
      activeTitle: 'Your trial is active',
      activeStatus: '{{chatCount}} chats used \u00B7 {{remaining}} remaining \u00B7 {{hoursLeft}}h left',
      hoursLeft: '{{count}}h left',
      continueSession: 'Continue trial session',
      expiredTitle: 'Your trial has ended',
      expiredDescription: 'Upgrade to continue analyzing sessions and chatting with your AI mentor.',
      viewPlans: 'View Plans',
    },
    chatLimit: {
      badge: 'Free Trial',
      title: "You've used your trial messages",
      description: 'Unlock unlimited conversations to keep improving your coaching skills with personalized AI feedback.',
      withPro: 'With a subscription',
      feature1: 'Unlimited coaching conversations',
      feature2: 'Unlimited transcript analyses',
      feature3: 'Track progress over time',
      subscribeCTA: 'Continue Coaching',
      inputPlaceholder: 'Trial limit reached — subscribe to continue',
      guarantee: 'Cancel anytime. Instant access.',
      dismiss: 'Not now',
    },
    expired: {
      lockBadge: 'Preview Ended',
      title: 'Your analysis results are locked',
      description: 'Subscribe to unlock your full results forever and keep improving with unlimited analyses.',
      yourLevel: 'Your level:',
      unlockTitle: 'Unlock with subscription',
      unlock1: 'This analysis — permanently yours',
      unlock2: 'Unlimited new analyses',
      unlock3: 'Unlimited AI coaching conversations',
      unlock4: 'Track progress across sessions',
      subscribeCTA: 'Unlock My Results',
      guarantee: 'Cancel anytime. Results stay forever.',
      headerBadge: 'Trial period ended',
      modalTitle: "Don't lose your analysis",
      modalDescription: 'Your coaching analysis and AI conversations are waiting. Subscribe to keep them forever and unlock unlimited access.',
      losing: 'Without subscribing',
      losingDetail: 'Analysis results locked. Chat history inaccessible.',
      keeping: 'With subscription',
      keepingDetail: 'All results unlocked forever. Unlimited analyses and conversations.',
      dismiss: 'Maybe later',
    },
  },

  mentorTraining: {
    cohortSettings: 'Cohort settings',
    featureOffTitle: 'Mentor Coach Training is off for this cohort',
    featureOffBody: 'When you turn on this feature in cohort settings, students will see the Mentor Coach Training tab in the sidebar and can access the drills you publish there.',
    enableFeature: 'Enable feature',
    title: 'Mentor Coach Training',
    subtitle:
      'Grade an analyzed coaching session as a mentor coach. MCAi independently scores the same session; your written feedback is critiqued against the ICF Mentor Coaching Competencies.',
    cohort: 'Cohort',
    back: 'Back to list',
    transcript: 'Transcript',
    gradeAsMentor: 'Grade as a mentor coach',
    yourSubmission: 'Your submission',
    overallLevel: 'Overall level call',
    writtenFeedback: 'Written mentor feedback',
    writtenHint:
      'What would you tell this candidate coach in a mentor session? Cite evidence.',
    strength: 'Strength',
    growth: 'Growth area',
    strengthPlaceholder: 'An observation tied to a quote from the transcript…',
    growthPlaceholder: 'An area and a forward-looking experiment they could try…',
    evidencePlaceholder: 'Paste a quote from the transcript (optional)…',
    submit: 'Submit & see agreement',
    noTranscript:
      'This drill has no embedded transcript. Ask your instructor for the source.',
    submissions: 'submissions',
    archive: 'Archive',
    publishedOn: 'Published',
    notPublished: 'Not published yet',
    studentGrading: "Student's grading",
    studentFeedback: "Student's written feedback",
    noMembersYet: 'No cohort members yet.',
    newDrill: 'New drill',
    noData: 'No data',
    footnote:
      'The Mentor Coach Qualification (MCQ) — ICF\'s new mentor coach credential — takes effect January 1, 2027.',
    level: { acc: 'ACC', pcc: 'PCC', mcc: 'MCC', unknown: '—' },
    status: {
      submitted: 'Submitted',
      inProgress: 'In progress',
      notStarted: 'Not started',
    },
    view: { student: 'Student view', instructor: 'Instructor view' },
    empty: {
      studentTitle: 'No drills assigned to you yet',
      studentBody:
        'When your instructor publishes a transcript as a drill, it appears here.',
      instructorTitle: 'No drills for this cohort yet',
      instructorBody:
        'Open an analyzed transcript and click "Publish as drill" to assign it to this cohort.',
      noCohortsTitle: 'Create a cohort first',
      noCohortsBody:
        'Open School Management to create a new cohort and add your students.',
    },
    stats: {
      submitted: 'Completed',
      inProgress: 'In progress',
      notStarted: 'Not started',
      avgScore: 'Avg agreement',
    },
    table: {
      student: 'Student',
      status: 'Status',
      score: 'Agreement',
      alignment: 'Alignment',
    },
    results: {
      title: 'Grading agreement',
      summary: 'Compared with MCAi pipeline',
      exactMatches: 'exact matches',
      you: 'You',
      mcai: 'MCAi',
      evidence: "MCAi's evidence quotes",
      critiqueTitle: 'Written feedback critique',
      alignment: 'Alignment',
      strengthCritique: 'Strength note',
      growthCritique: 'Growth note',
      suggestedRewrite: 'Suggested rewrite',
      tips: 'Tips to get closer to MCC-level mentor feedback',
      processing: 'Processing…',
      fallback:
        'Critique service was temporarily unavailable — your feedback was saved; you can self-review.',
    },
    publish: {
      title: 'Publish a new drill',
      cohort: 'Cohort',
      sourceDoc: 'Source transcript (analyzed)',
      titleLabel: 'Drill title',
      titlePlaceholder: 'e.g. Active listening at PCC level',
      module: 'Module (optional)',
      modulePlaceholder: 'e.g. Week 3',
      targetLevel: 'Target level',
      instructions: 'Instructor note (optional)',
      instructionsPlaceholder:
        'Competency or topic you want students to focus on…',
      cancel: 'Cancel',
      confirm: 'Publish to cohort',
      noCohorts: 'Create a cohort first.',
      noDocs:
        "You don't have any analyzed transcripts yet. Upload and analyze a session first.",
    },
    validation: {
      allCompetencies: 'Please pick a level for every competency.',
      feedbackRequired: 'Please write strength and growth feedback.',
    },
  },
  mentorEngagements: {
    workspace: {
      "sessionActions": "Session actions",
      "tabs": {
            "overview": "Overview",
            "sessions": "Sessions",
            "documents": "Review & documents"
      },
      "reviewing": "Reviewing {{mentee}} · {{level}} standard (ICF {{level}} forms rev. {{revision}})",
      "editEngagement": "Edit engagement",
      "priorities": "Development priorities",
      "editPriorities": "Edit priorities",
      "priorityNote": "Priority note",
      "addPriority": "Add priority",
      "remove": "Remove",
      "noPriorities": "No development priorities set yet.",
      "mentorSet": "Set by mentor",
      "sinceReview": "Since last reviewed session",
      "noComparison": "Not enough reviewed sessions to compare yet",
      "comparisonSessions": "Session {{previous}} → Session {{latest}}",
      "noChanges": "No rating changes in the compared statements.",
      "competencies": "Competency overview",
      "demonstrated": "{{count}} of {{required}} demonstrated",
      "confirmed": "Confirmed by you",
      "aiSuggested": "AI-suggested",
      "summary": "Engagement summary",
      "summaryCounts": "{{hours}} hours · {{sessions}} sessions",
      "share": "Share status with school",
      "shareExplanation": "When shared, school staff can read these forms.",
      "metadataOnly": "Only engagement status is available. The mentor has not shared form content.",
      "practiceDetails": "Reflection & practice",
      "reflection": "Mentee reflection",
      "practiceActions": "Practice actions",
      "action": "Practice action",
      "addAction": "Add practice action",
      "optionalCompetency": "Competency (optional)",
      "none": "None",
      "done": "Completed",
      "missing": "Missing documentation",
      "documentationComplete": "Documentation is complete.",
      "sessionNumber": "Session {{number}}",
      "sofExport": "Session {{number}} · SOF PDF",
      "drafts": "{{count}} drafts awaiting review",
      "viewStatus": "View status",
      "next": {
            "add_first_session": "Add first session",
            "review_draft_sof": "Review draft observation",
            "finalize_sof": "Finalize observation form",
            "set_priorities": "Set development priorities",
            "record_practice": "Record practice",
            "generate_crf_narrative": "Generate CRF narrative",
            "finalize_crf": "Finalize CRF",
            "complete_rule_checks": "Complete rule checks",
            "export_documents": "Export documents"
      },
      "states": {
            "consistently_demonstrated": "Consistently demonstrated",
            "developing": "Developing",
            "insufficient_evidence": "Insufficient evidence",
            "needs_mentor_review": "Needs your review",
            "verified": "Verified",
            "not_observed": "No observation yet"
      },
      "missingItems": {
            "unsigned_sof": "Observation form needs signature",
            "missing_session_date": "Session date missing",
            "missing_duration": "Session duration missing",
            "crf_not_finalized": "CRF not finalized",
            "c1_not_verified": "C1 verification pending"
      },
      "ratings": {
        "does_not_meet": "Does not meet standard",
            "observed": "Observed",
            "not_observed": "Not observed",
            "meets": "Meets standard",
            "below": "Below standard",
            "exceeds": "Exceeds standard",
            "na": "Not applicable",
            "not_applicable": "Not applicable"
      }
},
    review: {
      action: "Review",
      title: "Session {{number}} · {{date}}",
      uploaded: "Uploaded recording",
      manual: "Manual mentor session",
      draft: "Draft",
      final: "Final",
      signed: "Signed by {{name}} · {{date}}",
      summary: "{{mentorConfirmed}} of {{total}} confirmed by you · {{aiSuggested}} AI-suggested · {{unrated}} unrated",
      confirmed: "Confirmed by you",
      aiSuggested: "AI suggested",
      unrated: "Unrated",
      useAi: "Use AI rating",
      rationale: "AI rationale",
      counterEvidence: "Counter-evidence",
      supportingEvidence: "Supporting evidence",
      coach: "Coach",
      client: "Client",
      turn: "Turn {{number}}",
      noEvidence: "No citations available.",
      comment: "Mentor comments",
      c1: "C1 · Ethics and coaching role",
      c1Note: "Stored values may be AI defaults. Confirmation is shown only for choices made during this review; the form does not store who set these values.",
      storedValue: "Stored value · confirmation unknown",
      original: "Original value",
      observed: "Observed",
      notObserved: "Not observed",
      strengths: "Strengths",
      development: "Development",
      competency: "Competency",
      statement: "Statement for feedback",
      addFeedback: "Add feedback",
      removeFeedback: "Remove feedback",
      save: "Save draft",
      finalize: "Finalize",
      reopen: "Reopen",
      pdf: "Download PDF",
      unsaved: "Save your changes before finalizing or downloading.",
      saveError: "Could not save the review. Your edits are preserved; please retry.",
      loadError: "Could not load the observation form.",
      reopenError: "Could not reopen the form.",
      archived: "Archived engagements are read-only.",
      overridden: "You changed this",
      progress: "{{confirmed}} of {{total}} confirmed",
      finalizeWarning: "{{unrated}} unrated · {{rejected}} with rejected evidence. You can still finalize.",
      state: {
        unrated: "Unrated",
        aiSuggested: "AI suggested",
        confirmed: "Confirmed",
        overridden: "Changed by you",
        evidenceRejected: "Evidence rejected",
        aiSaid: "AI said {{label}}",
      },
      rating: {
        helper: "Pick a rating",
        aiSuggestedPct: "AI suggested · {{percent}}%",
        lowConfidence: "Low confidence — look here first",
        pcc64: "No energy shift in the session still counts as Observed.",
        naDefinition: "Not applicable: the behaviour was not relevant in this session.",
        overrideReason: "Why did you change it? (optional)",
        confirmedCaption: "Confirmed by you",
      },
      actions: {
        confirmNext: "Confirm & next",
        rateNext: "Rate & next",
        saveNext: "Save & next",
        prev: "Previous",
        next: "Next",
        jump: "Jump to transcript",
      },
      rail: {
        statements: "Statements",
        reviewed: "{{done}}/{{total}}",
        stepper: "Statement {{index}} of {{total}}",
        wrapup: "Wrap-up",
        wrapupHint: "C1 qualifiers, strengths and development",
        lowConfidence: "Low confidence",
      },
      evidence: {
        title: "Evidence",
        kept: "{{kept}} of {{total}} kept",
        why: "Why the AI rated this",
        supports: "supports",
        contradicts: "contradicts",
        showMore: "Show {{count}} more",
        showLess: "Show fewer",
        noTimestamp: "No timestamp",
        unrecorded: "No timestamps were recorded in the session.",
        none: "The AI found no evidence for this statement. Rate it from your own notes.",
        allRejected: "You rejected all supporting evidence — re-check the rating.",
        speakerMismatch: "This line is not the coach speaking",
        feedbackDisabled: "Re-run the analysis to enable relevance feedback.",
        confidence: "{{percent}}% confidence",
        precision: "{{percent}}% of citations kept so far",
      },
      relevance: {
        relevant: "Relevant",
        notRelevant: "Not relevant",
        reasonPrompt: "Why not?",
        rejected: "Rejected · {{reason}}",
        reopen: "Tap to reopen",
        reason: {
          wrong_statement: "Wrong statement",
          misquoted: "Misquoted",
          not_the_coach: "Not the coach",
          too_weak: "Too weak",
          other: "Other",
        },
      },
      transcript: {
        title: "Transcript",
        around: "Around turn {{turn}}",
        earlier: "Load earlier",
        later: "Load later",
        search: "Search the loaded turns",
        noMatches: "No matches in the loaded turns.",
        copyTimestamp: "Add timestamp to comment",
        copied: "Timestamp added to your comment.",
        unavailable: "Transcript not available for this session.",
        close: "Close transcript",
      },
      keyboard: {
        hint: "↑ ↓ move · 1–5 rate · Enter confirm · E evidence · T transcript",
      },
    },
    common: {
      close: "Close {{title}}",
    },
    title: 'Mentees',
    subtitle: 'Review sessions, agree priorities, and prepare credential documents.',
    newEngagement: 'New mentee',
    empty: 'No mentees yet',
    emptyBody: 'Add a mentee to begin reviewing sessions.',
    loadError: 'Could not load engagements.',
    back: 'All mentees',
    mockBanner: 'Demo data — the mentor forms API is mocked in this build.',
    level: 'Level',
    status: {
      active: 'Active',
      completed: 'Completed',
      archived: 'Archived',
    },
    list: {
      sessions: '{{count}} sessions',
      sofsFinal: '{{count}} forms final',
      crfDraft: 'CRF draft',
      crfFinal: 'CRF final',
      rulesOk: 'ICF rules met',
      rulesIncomplete: 'ICF rules incomplete',
    },
    create: {
      title: 'New mentee',
      menteeName: 'Mentee name',
      menteeNamePlaceholder: 'Full name as it should appear on the forms',
      menteeEmail: 'Mentee email (optional)',
      menteeEmailPlaceholder: 'name@example.com',
      targetLevel: 'Credential level',
      language: 'Form language',
      startedAt: 'Start date',
      submit: 'Add mentee',
      cancel: 'Cancel',
      nameRequired: 'Enter the mentee name.',
      error: 'Could not create the engagement.',
    },
    detail: {
      invalidHours: "Enter a non-negative number of hours, such as 0 or 1.5.",
      contact: 'Mentee and engagement',
      hours: 'Mentor coaching hours',
      individualHours: 'One-to-one hours',
      groupHours: 'Group hours',
      totalHours: 'Total hours',
      startedAt: 'First session',
      endedAt: 'Last session',
      previousMentor: 'Previous mentor coach',
      printedName: 'Your printed name',
      notes: 'Notes',
      save: 'Save changes',
      saved: 'Changes saved.',
      saveError: 'Could not save the changes.',
      loadError: 'Could not load this engagement.',
    },
    rules: {
      title: 'ICF requirements',
      subtitle: 'Checked against the ICF mentor coaching volume rules. Warnings never block you.',
      totalHours: 'At least 10 hours of mentor coaching',
      individualHours: 'At least 3 hours one-to-one',
      observedSessions: 'At least 3 observed sessions',
      engagementSpan: 'At least three months between first and final mentor coaching session (ICF: 12 full weeks)',
      sessionMetadata: 'Every included session has a date and duration',
      c1Verified: 'Competency 1 verified on the review form',
      pass: 'Met',
      fail: 'Not yet',
    },
    sessions: {
      unsupportedFile: "Choose an audio recording (MP3, M4A, WAV, MP4, OGG, WebM, FLAC or AAC) or a PDF, TXT or DOCX transcript.",
      uploadComplete: "Session analyzed. The observation form is ready for review.",
      editSof: "Edit observation",
      title: 'Observed sessions',
      number: '#',
      date: 'Date',
      modality: 'Modality',
      duration: 'Duration',
      source: 'Source',
      sofStatus: 'Observation form',
      includeInCrf: 'In CRF',
      actions: 'Actions',
      empty: 'No sessions yet. Upload a recording or add a session you observed live.',
      uploadSession: 'Upload session',
      addManual: 'Add manual session',
      downloadSof: 'Download SOF PDF',
      finalize: 'Finalize',
      reopen: 'Reopen',
      remove: 'Remove',
      removeConfirmTitle: 'Remove session',
      removeConfirmBody: 'This removes the session and its observation form from the engagement.',
      notStarted: 'Not started',
      minutes: '{{count}} min',
      uploadError: 'Could not start the analysis.',
      addPromptTitle: 'Add your first session',
      addPromptBody: 'Upload a recording or transcript of a mentee session. The observation form is drafted from it automatically. No recording? Enter the session by hand instead.',
      addPromptUpload: 'Upload a recording or transcript',
      addPromptManual: 'Enter manually',
      uploadStarted: 'Analysis started. The session appears in this table once it finishes.',
      needsLevelAnalysis: 'Needs {{level}} analysis',
      levelMismatch: "This session's analysis was graded at {{analysisLevel}}, but this engagement targets {{targetLevel}}. Run a {{targetLevel}} analysis of the session to create its observation form.",
      levelMismatchUnknown: "This session's analysis was graded at a different level, but this engagement targets {{targetLevel}}. Run a {{targetLevel}} analysis of the session to create its observation form.",
    },
    modality: {
      in_person: 'In person',
      virtual: 'Virtual',
      recorded: 'Recorded',
    },
    source: {
      mcai: 'Analyzed',
      manual: 'Manual',
    },
    formStatus: {
      draft: 'Draft',
      final: 'Final',
    },
    manual: {
      invalidDate: "Enter a valid session date (YYYY-MM-DD).",
      invalidDuration: "Enter a positive whole number of minutes.",
      editTitle: "Edit session observation",
      title: 'Add manual session',
      subtitle: 'For a session you observed live or outside the app. Rate each statement on the official scale.',
      sessionDate: 'Session date',
      modality: 'Modality',
      duration: 'Duration (minutes)',
      c1Title: 'Competency 1 qualifiers',
      c1Note: 'Either qualifier marked Not Observed is a hard veto regardless of the other competencies.',
      comment: 'Comment (optional)',
      commentPlaceholder: 'Evidence or note for this statement',
      progress: '{{rated}} of {{total}} statements rated',
      save: 'Save session',
      cancel: 'Cancel',
      error: 'Could not save the manual session.',
      unrated: 'Not rated',
    },
    crf: {
      useDraft: "Use generated draft (replace current feedback)",
      title: 'Competency Review Form',
      subtitle: 'Union across every included observation form. One Meets/Exceeds (or Observed) anywhere counts.',
      noSessions: 'Add at least one observed session to compute the review form.',
      gateSummary: '{{code}} · {{required}} of {{total}} required · {{demonstrated}} demonstrated · {{short}} short',
      gateMet: '{{code}} · {{required}} of {{total}} required · {{demonstrated}} demonstrated · met',
      statementGrid: 'Statements',
      demonstratedIn: 'Demonstrated in: {{sessions}}',
      notDemonstrated: 'Not yet demonstrated',
      naEverywhere: 'No opportunity observed',
      c1Title: 'Competency 1 verification',
      c1Verified: 'I verify Competency 1 for this mentee',
      c1Notes: 'Notes (confidentiality, boundaries, conflicts of interest)',
      feedbackTitle: 'Cumulative feedback',
      feedbackSubtitle: 'Three strengths and three development areas, cited across sessions.',
      strengths: 'Strengths',
      development: 'Development areas',
      slotCompetency: 'Competency',
      slotStatement: 'Statement for feedback',
      slotComments: 'Comments',
      slotEmpty: 'Empty slot',
      generateDraft: 'Generate draft',
      regenerate: 'Regenerate',
      generating: 'Drafting feedback across sessions…',
      narrativeQueued: 'Generating the cumulative feedback draft — this takes a moment.',
      narrativeError: 'Could not generate the draft.',
      verdict: 'Overall verdict',
      verdictDemonstrated: 'Has demonstrated proficiency in each competency area',
      verdictNotYet: 'Has not yet demonstrated proficiency in each competency area',
      verdictComputed: 'Computed from the gates above',
      verdictOverride: 'Override the computed verdict',
      verdictOverrideWarning:
        'You are overriding the computed verdict. The gate table above does not support this outcome.',
      save: 'Save review form',
      saved: 'Review form saved.',
      saveError: 'Could not save the review form.',
      finalize: 'Finalize CRF',
      reopen: 'Reopen CRF',
      downloadPdf: 'Download CRF PDF',
      emailToMentee: 'Email to mentee',
      locked: 'This record is final and read-only.',
      c2NoteAccMcc: 'Competency 2 has no behavioral statements at this level.',
      c2NotePcc: 'Competency 2 is proxied by PCC markers {{markers}} — a view only, never double-counted.',
    },
    finalize: {
      mcsActive: "I hold an active MCS appropriate for this credential level.",
      noConflict: "I have no kinship relationship or known conflict of interest with the mentee.",
      requirementsUnderstood: "I have read and understand the mentor coaching requirements.",
      feedbackReviewed: "I personally observed and evaluated the coaching and reviewed the feedback and client reflections with the mentee in real time.",
      sharingPermission: "I have permission to share this form with ICF.",
      preReflection: "Client reflection before the review",
      postReflection: "Client reflection after the review",
      completionRequired: "Complete both reflection summaries and confirm each statement before signing.",
      attestation: "I confirm I personally reviewed this assessment and the required feedback with the mentee, and intend my typed name to sign this form.",
      title: 'Finalize and sign',
      body: 'Finalizing locks the record. You can reopen it later, and the reopen is logged.',
      printedName: 'Printed name',
      printedNamePlaceholder: 'Type your full name',
      date: 'Date',
      warningsTitle: 'These ICF requirements are not met yet:',
      confirm: 'Finalize',
      cancel: 'Cancel',
      nameRequired: 'Type your printed name to sign.',
      error: 'Could not finalize the record.',
      reopenConfirmTitle: 'Reopen record',
      reopenConfirmBody: 'The record becomes editable again and the reopen is recorded in the audit log.',
    },
    email: {
      title: 'Email to mentee',
      recipient: 'Recipient',
      noRecipient: 'Add a mentee email on the engagement first.',
      documents: 'Documents',
      crf: 'Competency Review Form',
      sofFor: 'Observation form — session {{number}}',
      send: 'Send',
      cancel: 'Cancel',
      sent: 'Documents sent to {{email}}.',
      error: 'Could not send the documents.',
      selectOne: 'Select at least one document.',
    },
    toast: {
      legacyPdf: "This older signed form needs to be reopened, reviewed and signed again before export.",
      downloadError: 'Could not download the PDF.',
    },
    privateMentee: 'Private mentee',
    retry: 'Retry',
    statusFlow: {
      title: 'Engagement status',
      markCompleted: 'Mark completed',
      archive: 'Archive',
      reactivate: 'Reactivate',
      confirmCompleteTitle: 'Mark this engagement as completed?',
      confirmCompleteBody: 'The engagement moves to the Completed list. Forms stay available and you can reactivate it later.',
      confirmArchiveTitle: 'Archive this engagement?',
      confirmArchiveBody: 'Archived engagements are read-only. You can reactivate them at any time.',
      confirmReactivateTitle: 'Reactivate this engagement?',
      confirmReactivateBody: 'The engagement returns to the Active list and becomes editable again.',
      changed: 'Status updated.',
      error: 'Could not update the engagement status.',
      archivedNotice: 'This engagement is archived and read-only. Reactivate it to make changes.',
      completedNotice: 'This engagement is marked as completed.',
    },
    filters: {
      label: 'Show',
      all: 'All',
      active: 'Active',
      completed: 'Completed',
      archived: 'Archived',
      emptyFiltered: 'No engagements match this filter.',
    },
    sessionMeta: {
      title: 'Edit session details',
      subtitle: 'Date, modality and duration recorded on the Session Observation Form.',
      editAction: 'Edit details',
      save: 'Save details',
      cancel: 'Cancel',
      saved: 'Session details saved.',
      error: 'Could not save the session details.',
    },
    overrides: {
      hint: 'Tap a statement to override the computed result. Overrides save immediately and the gates recompute.',
      badge: 'Mentor override',
      reset: 'Reset to computed',
      saved: 'Override saved.',
      error: 'Could not save the override.',
    },
    validation: {
      invalidEmail: 'Enter a valid email address.',
      invalidDate: 'Dates must use the YYYY-MM-DD format.',
      menteeNameRequired: 'Mentee name is required.',
    },
    overviewLoadError: 'Could not load the engagement overview.',
  },
  jobs: {
    errors: {
      analysis_failed: "The analysis didn't finish. You weren't charged. Please try again.",
      transcription_failed: "The transcription didn't finish. Please try again.",
      worker_lost: "This job stopped unexpectedly. You weren't charged. Please try again.",
      timed_out: 'This job took too long and was stopped. You weren\'t charged. Please try again.',
      not_started: "This job didn't start in time. You weren't charged. Please try again.",
      cancelled: 'Cancelled.',
      no_credits: 'No credits remaining. Please purchase more credits.',
      provider_unavailable: 'We have a temporary problem on our side. Nothing was charged. Please try again in a few minutes.',
      dispatch_failed: "We couldn't start this job. You weren't charged. Please try again.",
      parent_failed: "The transcription failed, so the analysis didn't run. You weren't charged.",
      task_failed: 'Task failed.',
      invalid_audio: "This audio file couldn't be processed. Check its format and length, then try again.",
      trial_analysis_used: 'Your trial includes one analysis. More analyses unlock when your plan starts.',
    },
    progress: {
      waitingInLine: "Still waiting in line. You'll only be charged once.",
      waitingInLineTranscription: 'Still waiting in line. Your upload is safe.',
      lostTrack: 'We lost track of this job. It may still be running.',
      keepWaiting: 'Keep waiting',
      checkAgain: 'Check again',
      checking: 'Checking...',
      tryAgain: 'Try again',
    },
  },
  errorBoundary: {
    title: 'Something went wrong',
    screenBody: 'This screen hit an unexpected error. Your data is safe. Try again, or go back to the dashboard.',
    appBody: 'The app hit an unexpected error. Your data is safe. Reload the page to continue.',
    tryAgain: 'Try again',
    reload: 'Reload',
    goToDashboard: 'Go to dashboard',
  },
  sampleReportPolicy: {
    observedChip: 'Observed',
    c1Caption: 'Ethics threshold · not leveled',
    ethicsConcernChip: 'Ethics concern',
    c1EthicsConcernCaption: 'Ethics threshold · flagged for review · not leveled',
    c2Caption: 'Assessed by the ICF exam · not leveled',
    c1ObservedNote: 'Observed. Conduct consistent with ethical practice and the coaching role was observed in this session, and no behaviour contrary to the ethical standards was observed. Ethical practice is a threshold to be met rather than a skill level, so this competency is not assigned a level and does not affect the overall level decision.',
    c2ExamOnlyNote: 'There are no behavioral markers for this competency area. Maintaining a coaching mindset — staying open, curious, flexible and client-centered — develops across a coach’s professional journey and cannot be evaluated from a single recorded session. This competency is therefore not assigned a level and does not affect the overall level decision.',
  },
  paymentFailedBanner: {
    title: 'Your last payment failed — update your payment method',
    body: 'Your access continues while we retry the charge. Update your card to keep your subscription.',
    cta: 'Update payment method',
    dismiss: 'Dismiss',
    portalError: 'Could not open the billing portal. Please try again.',
  },
  entitlementLocks: {
    seePlans: 'See plans',
    chatTitle: 'Chat needs an active subscription',
    chatBody: 'Your credits still cover new analyses and your past reports. Subscribe to ask follow-up questions.',
    chatPlaceholder: 'Chat needs an active subscription',
    chatReassessBody: 'Your credits still let you re-assess this session for 1 credit: ask to check the PCC markers or to re-analyze it. Other questions need a subscription.',
    chatReassessPlaceholder: 'Re-assess this session (1 credit)',
    reassessSuggestionMarkers: 'Check the PCC markers',
    reassessSuggestionReanalyze: 'Re-analyze this session',
    mentorTitle: 'Mentor engagements need the Mentor Coach plan',
    mentorBody: 'Your past reports and credits stay available. Subscribe to the Mentor Coach plan to review mentees and complete ICF forms.',
    mcsTitle: 'MCS preparation needs the Mentor Coach plan',
    mcsBody: 'Subscribe to the Mentor Coach plan to prepare for the ICF Mentor Coach Specialization.',
  },
  emailChange: {
    confirming: 'Confirming your new email address…',
    successTitle: 'Email address updated',
    successBody: 'For your security we signed you out everywhere. Sign in again with your new email address.',
    needsLoginTitle: 'Sign in to confirm',
    needsLoginBody: 'Sign in with your current email address on this device, then open the confirmation link again.',
    invalidTitle: 'This link is invalid or has expired',
    invalidBody: 'Request the email change again from your profile. The link works for 2 hours, from the account that requested it.',
    failedTitle: 'We could not confirm your email',
    failedBody: 'Something went wrong on our side. Please open the link again in a moment.',
    signIn: 'Sign in',
    backToApp: 'Back to the app',
  },
  chatLibrary: {
    errors: {
      sendLimitReached: 'You have reached your usage limit for now. Try again later or check your plan.',
      sendNeedsSubscription: 'Your current plan does not include this. Check your subscription to continue.',
      trialChatLimitReached: "You've used all {{limit}} chat messages included in your trial. Choose a plan to keep chatting.",
      trialChatLimitReachedPlanStarts: "You've used all {{limit}} chat messages included in your trial. Chat unlocks again when your plan starts.",
      documentHasNoTranscript: 'This document has no transcript to analyze. Upload the session transcript or recording instead. Nothing was charged.',
      followupCreditRequired: 'Re-assessing a session at a target level uses 1 analysis credit, and none are available. Check your plan or credits to continue.',
      sendVerifyEmail: 'Please verify your email address before using the AI assistant.',
      sendTooLong: 'This message is too long. Please shorten it and try again.',
      fileTooLarge: 'This file is too large.',
      fileUnsupported: 'This file type is not supported. Use PDF, DOCX, TXT, RTF or an image.',
      fileNoText: 'We could not read any text from this file. Try a different format.',
      referenceTooManyFiles: 'This conversation already has the maximum number of reference files. Remove one before adding another.',
      referenceSessionFull: 'This conversation has no room for more reference text. Remove a reference file before adding another.',
      noAnalysisToExport: 'This conversation has no analysis to export yet.',
      removeRecipientFailed: 'The recipient could not be removed. Please try again.',
      addRecipientsFailed: 'The recipients could not be added. Please try again.',
    },
    library: {
      transcribed: 'Transcribed',
      uploadPrompt: 'Choose a recording or a transcript below to upload.',
      loadErrorTitle: 'Your library could not be loaded.',
      loadErrorBody: 'Check your connection and try again. Your documents are safe.',
      sharedLoadError: 'Shared documents could not be loaded.',
      refreshError: 'The list could not be refreshed. You are seeing the last loaded documents.',
      loadMore: 'Load more ({{shown}} of {{total}} shown)',
      loadMoreError: 'More documents could not be loaded.',
      recipientsLoadError: 'Recipients could not be loaded.',
    },
  },
  report: {
    sessionFallback: 'Session #{{id}}',
    back: 'Back',
    eyebrow: 'Session report',
    overallLevel: 'Overall level',
    confidence: 'Confidence: {{label}}',
    analyzedOn: 'Analyzed {{date}}',
    reviewRecommended: 'Flagged for a closer look: the evidence sits between two levels.',
    excludedNote: 'This session is excluded from your ICF progress. The report stays available here.',
    summaryTitle: 'Summary',
    whyNotHigher: 'What would move it higher',
    nextStepsTitle: 'What to work on next',
    competenciesTitle: 'Competencies',
    competenciesHint: 'Each competency gets its own level. The overall level follows the ICF decision rules across C3–C8, so one competency can sit above or below it.',
    strengthsLabel: 'Strengths',
    developmentLabel: 'To develop',
    patternLabel: 'Pattern to watch',
    showEvidence: 'Show evidence ({{count}})',
    hideEvidence: 'Hide evidence',
    expand: 'Expand {{competency}}',
    collapse: 'Collapse {{competency}}',
    noEvidence: 'No quotes were recorded for this competency.',
    planTitle: 'Development plan',
    practiceTitle: 'Practice in your next session',
    successIndicator: 'You will know it worked when: {{text}}',
    mentorQuestionsTitle: 'Bring to your mentor session',
    downloadsTitle: 'Downloads',
    kindReport: 'Report',
    kindChat: 'Chat',
    levelShortReadyForPcc: 'PCC prep',
    state: {
      processingTitle: 'Your report is being prepared',
      processingBody: 'The analysis usually takes a few minutes. This page updates on its own.',
      noReportTitle: 'No report for this session yet',
      noReportBody: 'If you just started an analysis it may still be running. Check again in a minute, or open your sessions.',
      failedTitle: 'The analysis did not finish',
      failedBody: 'Something went wrong while preparing this report. Check again, or start the analysis again from your sessions.',
      legacyTitle: 'This report is in the chat',
      legacyBody: 'Reports created before the structured report view are shown in the conversation.',
      lockedTitle: 'Reports need an active plan or credits',
      lockedBody: 'Choose a plan or buy credits to open your reports again.',
      loadError: 'Could not load this report.',
      notFound: 'This report could not be found.',
      checkAgain: 'Check again',
      openChat: 'Open in chat',
      goToSessions: 'Go to sessions',
      seePlans: 'See plans',
    },
    card: {
      title: 'Your session report',
      body: 'Overall level, evidence for each competency and your next steps.',
      open: 'Open full report',
    },
    sample: {
      meta: '{{minutes}} min session · fictional participants: {{coach}} and {{client}}',
    },
  },
  onboardingProgress: {
    tour: 'Part 1 of 2 · Tour · step {{current}} of {{total}}',
    intake: 'Part 2 of 2 · Your profile · step {{current}} of {{total}}',
  },
  planPricing: {
    loading: 'Loading prices…',
    error: 'Prices could not be loaded.',
    retry: 'Try again',
    sampleHint: 'An overall level, evidence for each ICF competency and a practice plan: see what every analysis gives you.',
  },
  mentorPlan: {
    eyebrow: 'Your mentoring plan',
    checklistStep: 'Checklist step: {{title}}',
    setupDoneTitle: 'Your workspace is set up',
    setupDoneBody: 'Keep your weekly practice going with each new mentee.',
  },
  mentorChecklist: {
    title: 'Set up your mentor workspace',
    subtitle: 'Each step ticks off when you do it in the app.',
    progress: '{{completed}}/{{total}} done',
    next: 'Next',
    done: 'Done',
    doItNow: 'Do it now',
    successLabel: 'Done when',
    previewNote: 'Each step ticks off on your Mentees page and dashboard as you do it.',
    revealTitle: 'Your setup checklist',
    completeTitle: 'Your mentor workspace is set up',
    completeBody: 'Every setup step is done. Add your next mentee when you are ready.',
    completeCta: 'Add another mentee',
    lockedBody: 'Mentees, with the ICF SOF and CRF forms, are part of the Mentor Coach plan.',
    lockedCta: 'See Mentor Coach',
    loadError: 'Your setup checklist could not be loaded.',
    retry: 'Try again',
    steps: {
      create_engagement: {
        title: 'Add your first mentee',
        why: 'A mentee engagement keeps their sessions, credential goal and forms together.',
        done: 'First mentee engagement created',
      },
      add_session: {
        title: 'Add a session',
        why: 'The observation form is built from a session: a recording, a transcript or your own notes.',
        done: 'First session added',
      },
      review_sof: {
        title: 'Review the observation draft (SOF)',
        why: 'Confirm or change the AI-suggested ratings and save. You stay the assessor.',
        done: 'First observation form saved',
      },
      finalize_crf: {
        title: 'Finalize the competency review (CRF)',
        why: 'The CRF sums up the engagement against the ICF statements, and you sign it.',
        done: 'First CRF finalized',
      },
      send_forms: {
        title: 'Send the forms to your mentee',
        why: 'Your mentee gets the signed SOF and CRF PDFs by email.',
        done: 'Forms sent to a mentee',
      },
      link_cohort: {
        title: 'Share an engagement with your school',
        why: 'Sharing links the mentee engagement to your school cohort, so school staff can follow it.',
        done: 'Engagement shared with your school',
      },
    },
  },
} as const;
